//https://github.com/bedrock-apis/bds-docs/blob/4460af618b6f0a96374ead7645c6cda14af53fdd/metadata/vanilladata_modules/mojang-items.json
export const typeIds = {
	data_items: [
		{
			command_name: "minecraft:acacia_boat",
			name: "minecraft:acacia_boat",
			raw_id: 405,
			serialization_id: "item.acacia_boat",
			serialization_name: "minecraft:acacia_boat",
		},
		{
			command_name: "minecraft:acacia_button",
			name: "minecraft:acacia_button",
			raw_id: -140,
			serialization_id: "item.acacia_button",
			serialization_name: "minecraft:acacia_button",
		},
		{
			command_name: "minecraft:acacia_chest_boat",
			name: "minecraft:acacia_chest_boat",
			raw_id: 678,
			serialization_id: "item.acacia_chest_boat",
			serialization_name: "minecraft:acacia_chest_boat",
		},
		{
			command_name: "minecraft:acacia_door",
			name: "minecraft:acacia_door",
			raw_id: 589,
			serialization_id: "item.acacia_door",
			serialization_name: "minecraft:acacia_door",
		},
		{
			command_name: "minecraft:acacia_fence",
			name: "minecraft:acacia_fence",
			raw_id: -575,
			serialization_id: "item.acacia_fence",
			serialization_name: "minecraft:acacia_fence",
		},
		{
			command_name: "minecraft:acacia_fence_gate",
			name: "minecraft:acacia_fence_gate",
			raw_id: 187,
			serialization_id: "item.acacia_fence_gate",
			serialization_name: "minecraft:acacia_fence_gate",
		},
		{
			command_name: "minecraft:acacia_hanging_sign",
			name: "minecraft:acacia_hanging_sign",
			raw_id: -504,
			serialization_id: "item.acacia_hanging_sign",
			serialization_name: "minecraft:acacia_hanging_sign",
		},
		{
			command_name: "minecraft:acacia_leaves",
			name: "minecraft:acacia_leaves",
			raw_id: 161,
			serialization_id: "item.acacia_leaves",
			serialization_name: "minecraft:acacia_leaves",
		},
		{
			command_name: "minecraft:acacia_log",
			name: "minecraft:acacia_log",
			raw_id: 162,
			serialization_id: "item.acacia_log",
			serialization_name: "minecraft:acacia_log",
		},
		{
			command_name: "minecraft:acacia_planks",
			name: "minecraft:acacia_planks",
			raw_id: -742,
			serialization_id: "item.acacia_planks",
			serialization_name: "minecraft:acacia_planks",
		},
		{
			command_name: "minecraft:acacia_pressure_plate",
			name: "minecraft:acacia_pressure_plate",
			raw_id: -150,
			serialization_id: "item.acacia_pressure_plate",
			serialization_name: "minecraft:acacia_pressure_plate",
		},
		{
			command_name: "minecraft:acacia_sapling",
			name: "minecraft:acacia_sapling",
			raw_id: -828,
			serialization_id: "item.acacia_sapling",
			serialization_name: "minecraft:acacia_sapling",
		},
		{
			command_name: "minecraft:acacia_sign",
			name: "minecraft:acacia_sign",
			raw_id: 612,
			serialization_id: "item.acacia_sign",
			serialization_name: "minecraft:acacia_sign",
		},
		{
			command_name: "minecraft:acacia_slab",
			name: "minecraft:acacia_slab",
			raw_id: -807,
			serialization_id: "item.acacia_slab",
			serialization_name: "minecraft:acacia_slab",
		},
		{
			command_name: "minecraft:acacia_stairs",
			name: "minecraft:acacia_stairs",
			raw_id: 163,
			serialization_id: "item.acacia_stairs",
			serialization_name: "minecraft:acacia_stairs",
		},
		{
			command_name: "minecraft:acacia_trapdoor",
			name: "minecraft:acacia_trapdoor",
			raw_id: -145,
			serialization_id: "item.acacia_trapdoor",
			serialization_name: "minecraft:acacia_trapdoor",
		},
		{
			command_name: "minecraft:acacia_wood",
			name: "minecraft:acacia_wood",
			raw_id: -817,
			serialization_id: "item.acacia_wood",
			serialization_name: "minecraft:acacia_wood",
		},
		{
			command_name: "minecraft:activator_rail",
			name: "minecraft:activator_rail",
			raw_id: 126,
			serialization_id: "item.activator_rail",
			serialization_name: "minecraft:activator_rail",
		},
		{
			command_name: "minecraft:air",
			name: "minecraft:air",
			raw_id: -158,
			serialization_id: "item.air",
			serialization_name: "minecraft:air",
		},
		{
			command_name: "minecraft:allay_spawn_egg",
			name: "minecraft:allay_spawn_egg",
			raw_id: 667,
			serialization_id: "item.allay_spawn_egg",
			serialization_name: "minecraft:allay_spawn_egg",
		},
		{
			command_name: "minecraft:allium",
			name: "minecraft:allium",
			raw_id: -831,
			serialization_id: "item.allium",
			serialization_name: "minecraft:allium",
		},
		{
			command_name: "minecraft:allow",
			name: "minecraft:allow",
			raw_id: 210,
			serialization_id: "item.allow",
			serialization_name: "minecraft:allow",
		},
		{
			command_name: "minecraft:amethyst_block",
			name: "minecraft:amethyst_block",
			raw_id: -327,
			serialization_id: "item.amethyst_block",
			serialization_name: "minecraft:amethyst_block",
		},
		{
			command_name: "minecraft:amethyst_cluster",
			name: "minecraft:amethyst_cluster",
			raw_id: -329,
			serialization_id: "item.amethyst_cluster",
			serialization_name: "minecraft:amethyst_cluster",
		},
		{
			command_name: "minecraft:amethyst_shard",
			name: "minecraft:amethyst_shard",
			raw_id: 660,
			serialization_id: "item.amethyst_shard",
			serialization_name: "minecraft:amethyst_shard",
		},
		{
			command_name: "minecraft:ancient_debris",
			name: "minecraft:ancient_debris",
			raw_id: -271,
			serialization_id: "item.ancient_debris",
			serialization_name: "minecraft:ancient_debris",
		},
		{
			command_name: "minecraft:andesite",
			name: "minecraft:andesite",
			raw_id: -594,
			serialization_id: "item.andesite",
			serialization_name: "minecraft:andesite",
		},
		{
			command_name: "minecraft:andesite_slab",
			name: "minecraft:andesite_slab",
			raw_id: -893,
			serialization_id: "item.andesite_slab",
			serialization_name: "minecraft:andesite_slab",
		},
		{
			command_name: "minecraft:andesite_stairs",
			name: "minecraft:andesite_stairs",
			raw_id: -171,
			serialization_id: "item.andesite_stairs",
			serialization_name: "minecraft:andesite_stairs",
		},
		{
			command_name: "minecraft:andesite_wall",
			name: "minecraft:andesite_wall",
			raw_id: -974,
			serialization_id: "item.andesite_wall",
			serialization_name: "minecraft:andesite_wall",
		},
		{
			command_name: "minecraft:angler_pottery_sherd",
			name: "minecraft:angler_pottery_sherd",
			raw_id: 692,
			serialization_id: "item.angler_pottery_sherd",
			serialization_name: "minecraft:angler_pottery_sherd",
		},
		{
			command_name: "minecraft:anvil",
			name: "minecraft:anvil",
			raw_id: 145,
			serialization_id: "item.anvil",
			serialization_name: "minecraft:anvil",
		},
		{
			command_name: "minecraft:apple",
			name: "minecraft:apple",
			raw_id: 278,
			serialization_id: "item.apple.name",
			serialization_name: "minecraft:apple",
		},
		{
			command_name: "minecraft:archer_pottery_sherd",
			name: "minecraft:archer_pottery_sherd",
			raw_id: 693,
			serialization_id: "item.archer_pottery_sherd",
			serialization_name: "minecraft:archer_pottery_sherd",
		},
		{
			command_name: "minecraft:armadillo_scute",
			name: "minecraft:armadillo_scute",
			raw_id: 739,
			serialization_id: "item.armadillo_scute",
			serialization_name: "minecraft:armadillo_scute",
		},
		{
			command_name: "minecraft:armadillo_spawn_egg",
			name: "minecraft:armadillo_spawn_egg",
			raw_id: 738,
			serialization_id: "item.armadillo_spawn_egg",
			serialization_name: "minecraft:armadillo_spawn_egg",
		},
		{
			command_name: "minecraft:armor_stand",
			name: "minecraft:armor_stand",
			raw_id: 585,
			serialization_id: "item.armor_stand",
			serialization_name: "minecraft:armor_stand",
		},
		{
			command_name: "minecraft:arms_up_pottery_sherd",
			name: "minecraft:arms_up_pottery_sherd",
			raw_id: 694,
			serialization_id: "item.arms_up_pottery_sherd",
			serialization_name: "minecraft:arms_up_pottery_sherd",
		},
		{
			command_name: "minecraft:arrow",
			name: "minecraft:arrow",
			raw_id: 325,
			serialization_id: "item.arrow",
			serialization_name: "minecraft:arrow",
		},
		{
			command_name: "minecraft:axolotl_bucket",
			name: "minecraft:axolotl_bucket",
			raw_id: 394,
			serialization_id: "item.axolotl_bucket",
			serialization_name: "minecraft:axolotl_bucket",
		},
		{
			command_name: "minecraft:axolotl_spawn_egg",
			name: "minecraft:axolotl_spawn_egg",
			raw_id: 530,
			serialization_id: "item.axolotl_spawn_egg",
			serialization_name: "minecraft:axolotl_spawn_egg",
		},
		{
			command_name: "minecraft:azalea",
			name: "minecraft:azalea",
			raw_id: -337,
			serialization_id: "item.azalea",
			serialization_name: "minecraft:azalea",
		},
		{
			command_name: "minecraft:azalea_leaves",
			name: "minecraft:azalea_leaves",
			raw_id: -324,
			serialization_id: "item.azalea_leaves",
			serialization_name: "minecraft:azalea_leaves",
		},
		{
			command_name: "minecraft:azalea_leaves_flowered",
			name: "minecraft:azalea_leaves_flowered",
			raw_id: -325,
			serialization_id: "item.azalea_leaves_flowered",
			serialization_name: "minecraft:azalea_leaves_flowered",
		},
		{
			command_name: "minecraft:azure_bluet",
			name: "minecraft:azure_bluet",
			raw_id: -832,
			serialization_id: "item.azure_bluet",
			serialization_name: "minecraft:azure_bluet",
		},
		{
			command_name: "minecraft:baked_potato",
			name: "minecraft:baked_potato",
			raw_id: 303,
			serialization_id: "item.baked_potato",
			serialization_name: "minecraft:baked_potato",
		},
		{
			command_name: "minecraft:bamboo",
			name: "minecraft:bamboo",
			raw_id: -163,
			serialization_id: "item.bamboo",
			serialization_name: "minecraft:bamboo",
		},
		{
			command_name: "minecraft:bamboo_block",
			name: "minecraft:bamboo_block",
			raw_id: -527,
			serialization_id: "item.bamboo_block",
			serialization_name: "minecraft:bamboo_block",
		},
		{
			command_name: "minecraft:bamboo_button",
			name: "minecraft:bamboo_button",
			raw_id: -511,
			serialization_id: "item.bamboo_button",
			serialization_name: "minecraft:bamboo_button",
		},
		{
			command_name: "minecraft:bamboo_chest_raft",
			name: "minecraft:bamboo_chest_raft",
			raw_id: 690,
			serialization_id: "item.bamboo_chest_raft",
			serialization_name: "minecraft:bamboo_chest_raft",
		},
		{
			command_name: "minecraft:bamboo_door",
			name: "minecraft:bamboo_door",
			raw_id: -517,
			serialization_id: "item.bamboo_door",
			serialization_name: "minecraft:bamboo_door",
		},
		{
			command_name: "minecraft:bamboo_fence",
			name: "minecraft:bamboo_fence",
			raw_id: -515,
			serialization_id: "item.bamboo_fence",
			serialization_name: "minecraft:bamboo_fence",
		},
		{
			command_name: "minecraft:bamboo_fence_gate",
			name: "minecraft:bamboo_fence_gate",
			raw_id: -516,
			serialization_id: "item.bamboo_fence_gate",
			serialization_name: "minecraft:bamboo_fence_gate",
		},
		{
			command_name: "minecraft:bamboo_hanging_sign",
			name: "minecraft:bamboo_hanging_sign",
			raw_id: -522,
			serialization_id: "item.bamboo_hanging_sign",
			serialization_name: "minecraft:bamboo_hanging_sign",
		},
		{
			command_name: "minecraft:bamboo_mosaic",
			name: "minecraft:bamboo_mosaic",
			raw_id: -509,
			serialization_id: "item.bamboo_mosaic",
			serialization_name: "minecraft:bamboo_mosaic",
		},
		{
			command_name: "minecraft:bamboo_mosaic_slab",
			name: "minecraft:bamboo_mosaic_slab",
			raw_id: -524,
			serialization_id: "item.bamboo_mosaic_slab",
			serialization_name: "minecraft:bamboo_mosaic_slab",
		},
		{
			command_name: "minecraft:bamboo_mosaic_stairs",
			name: "minecraft:bamboo_mosaic_stairs",
			raw_id: -523,
			serialization_id: "item.bamboo_mosaic_stairs",
			serialization_name: "minecraft:bamboo_mosaic_stairs",
		},
		{
			command_name: "minecraft:bamboo_planks",
			name: "minecraft:bamboo_planks",
			raw_id: -510,
			serialization_id: "item.bamboo_planks",
			serialization_name: "minecraft:bamboo_planks",
		},
		{
			command_name: "minecraft:bamboo_pressure_plate",
			name: "minecraft:bamboo_pressure_plate",
			raw_id: -514,
			serialization_id: "item.bamboo_pressure_plate",
			serialization_name: "minecraft:bamboo_pressure_plate",
		},
		{
			command_name: "minecraft:bamboo_raft",
			name: "minecraft:bamboo_raft",
			raw_id: 689,
			serialization_id: "item.bamboo_raft",
			serialization_name: "minecraft:bamboo_raft",
		},
		{
			command_name: "minecraft:bamboo_sign",
			name: "minecraft:bamboo_sign",
			raw_id: 688,
			serialization_id: "item.bamboo_sign",
			serialization_name: "minecraft:bamboo_sign",
		},
		{
			command_name: "minecraft:bamboo_slab",
			name: "minecraft:bamboo_slab",
			raw_id: -513,
			serialization_id: "item.bamboo_slab",
			serialization_name: "minecraft:bamboo_slab",
		},
		{
			command_name: "minecraft:bamboo_stairs",
			name: "minecraft:bamboo_stairs",
			raw_id: -512,
			serialization_id: "item.bamboo_stairs",
			serialization_name: "minecraft:bamboo_stairs",
		},
		{
			command_name: "minecraft:bamboo_trapdoor",
			name: "minecraft:bamboo_trapdoor",
			raw_id: -520,
			serialization_id: "item.bamboo_trapdoor",
			serialization_name: "minecraft:bamboo_trapdoor",
		},
		{
			command_name: "minecraft:banner",
			name: "minecraft:banner",
			raw_id: 600,
			serialization_id: "item.banner",
			serialization_name: "minecraft:banner",
		},
		{
			command_name: "minecraft:barrel",
			name: "minecraft:barrel",
			raw_id: -203,
			serialization_id: "item.barrel",
			serialization_name: "minecraft:barrel",
		},
		{
			command_name: "minecraft:barrier",
			name: "minecraft:barrier",
			raw_id: -161,
			serialization_id: "item.barrier",
			serialization_name: "minecraft:barrier",
		},
		{
			command_name: "minecraft:basalt",
			name: "minecraft:basalt",
			raw_id: -234,
			serialization_id: "item.basalt",
			serialization_name: "minecraft:basalt",
		},
		{
			command_name: "minecraft:bat_spawn_egg",
			name: "minecraft:bat_spawn_egg",
			raw_id: 480,
			serialization_id: "item.bat_spawn_egg",
			serialization_name: "minecraft:bat_spawn_egg",
		},
		{
			command_name: "minecraft:beacon",
			name: "minecraft:beacon",
			raw_id: 138,
			serialization_id: "item.beacon",
			serialization_name: "minecraft:beacon",
		},
		{
			command_name: "minecraft:bed",
			name: "minecraft:bed",
			raw_id: 444,
			serialization_id: "item.bed",
			serialization_name: "minecraft:bed",
		},
		{
			command_name: "minecraft:bedrock",
			name: "minecraft:bedrock",
			raw_id: 7,
			serialization_id: "item.bedrock",
			serialization_name: "minecraft:bedrock",
		},
		{
			command_name: "minecraft:bee_nest",
			name: "minecraft:bee_nest",
			raw_id: -218,
			serialization_id: "item.bee_nest",
			serialization_name: "minecraft:bee_nest",
		},
		{
			command_name: "minecraft:bee_spawn_egg",
			name: "minecraft:bee_spawn_egg",
			raw_id: 522,
			serialization_id: "item.bee_spawn_egg",
			serialization_name: "minecraft:bee_spawn_egg",
		},
		{
			command_name: "minecraft:beef",
			name: "minecraft:beef",
			raw_id: 295,
			serialization_id: "item.beef",
			serialization_name: "minecraft:beef",
		},
		{
			command_name: "minecraft:beehive",
			name: "minecraft:beehive",
			raw_id: -219,
			serialization_id: "item.beehive",
			serialization_name: "minecraft:beehive",
		},
		{
			command_name: "minecraft:beetroot",
			name: "minecraft:beetroot",
			raw_id: 307,
			serialization_id: "item.beetroot",
			serialization_name: "minecraft:beetroot",
		},
		{
			command_name: "minecraft:beetroot_seeds",
			name: "minecraft:beetroot_seeds",
			raw_id: 317,
			serialization_id: "item.beetroot_seeds",
			serialization_name: "minecraft:beetroot_seeds",
		},
		{
			command_name: "minecraft:beetroot_soup",
			name: "minecraft:beetroot_soup",
			raw_id: 308,
			serialization_id: "item.beetroot_soup",
			serialization_name: "minecraft:beetroot_soup",
		},
		{
			command_name: "minecraft:bell",
			name: "minecraft:bell",
			raw_id: -206,
			serialization_id: "item.bell",
			serialization_name: "minecraft:bell",
		},
		{
			command_name: "minecraft:big_dripleaf",
			name: "minecraft:big_dripleaf",
			raw_id: -323,
			serialization_id: "item.big_dripleaf",
			serialization_name: "minecraft:big_dripleaf",
		},
		{
			command_name: "minecraft:birch_boat",
			name: "minecraft:birch_boat",
			raw_id: 402,
			serialization_id: "item.birch_boat",
			serialization_name: "minecraft:birch_boat",
		},
		{
			command_name: "minecraft:birch_button",
			name: "minecraft:birch_button",
			raw_id: -141,
			serialization_id: "item.birch_button",
			serialization_name: "minecraft:birch_button",
		},
		{
			command_name: "minecraft:birch_chest_boat",
			name: "minecraft:birch_chest_boat",
			raw_id: 675,
			serialization_id: "item.birch_chest_boat",
			serialization_name: "minecraft:birch_chest_boat",
		},
		{
			command_name: "minecraft:birch_door",
			name: "minecraft:birch_door",
			raw_id: 587,
			serialization_id: "item.birch_door",
			serialization_name: "minecraft:birch_door",
		},
		{
			command_name: "minecraft:birch_fence",
			name: "minecraft:birch_fence",
			raw_id: -576,
			serialization_id: "item.birch_fence",
			serialization_name: "minecraft:birch_fence",
		},
		{
			command_name: "minecraft:birch_fence_gate",
			name: "minecraft:birch_fence_gate",
			raw_id: 184,
			serialization_id: "item.birch_fence_gate",
			serialization_name: "minecraft:birch_fence_gate",
		},
		{
			command_name: "minecraft:birch_hanging_sign",
			name: "minecraft:birch_hanging_sign",
			raw_id: -502,
			serialization_id: "item.birch_hanging_sign",
			serialization_name: "minecraft:birch_hanging_sign",
		},
		{
			command_name: "minecraft:birch_leaves",
			name: "minecraft:birch_leaves",
			raw_id: -801,
			serialization_id: "item.birch_leaves",
			serialization_name: "minecraft:birch_leaves",
		},
		{
			command_name: "minecraft:birch_log",
			name: "minecraft:birch_log",
			raw_id: -570,
			serialization_id: "item.birch_log",
			serialization_name: "minecraft:birch_log",
		},
		{
			command_name: "minecraft:birch_planks",
			name: "minecraft:birch_planks",
			raw_id: -740,
			serialization_id: "item.birch_planks",
			serialization_name: "minecraft:birch_planks",
		},
		{
			command_name: "minecraft:birch_pressure_plate",
			name: "minecraft:birch_pressure_plate",
			raw_id: -151,
			serialization_id: "item.birch_pressure_plate",
			serialization_name: "minecraft:birch_pressure_plate",
		},
		{
			command_name: "minecraft:birch_sapling",
			name: "minecraft:birch_sapling",
			raw_id: -826,
			serialization_id: "item.birch_sapling",
			serialization_name: "minecraft:birch_sapling",
		},
		{
			command_name: "minecraft:birch_sign",
			name: "minecraft:birch_sign",
			raw_id: 610,
			serialization_id: "item.birch_sign",
			serialization_name: "minecraft:birch_sign",
		},
		{
			command_name: "minecraft:birch_slab",
			name: "minecraft:birch_slab",
			raw_id: -805,
			serialization_id: "item.birch_slab",
			serialization_name: "minecraft:birch_slab",
		},
		{
			command_name: "minecraft:birch_stairs",
			name: "minecraft:birch_stairs",
			raw_id: 135,
			serialization_id: "item.birch_stairs",
			serialization_name: "minecraft:birch_stairs",
		},
		{
			command_name: "minecraft:birch_trapdoor",
			name: "minecraft:birch_trapdoor",
			raw_id: -146,
			serialization_id: "item.birch_trapdoor",
			serialization_name: "minecraft:birch_trapdoor",
		},
		{
			command_name: "minecraft:birch_wood",
			name: "minecraft:birch_wood",
			raw_id: -815,
			serialization_id: "item.birch_wood",
			serialization_name: "minecraft:birch_wood",
		},
		{
			command_name: "minecraft:black_bundle",
			name: "minecraft:black_bundle",
			raw_id: 257,
			serialization_id: "item.black_bundle",
			serialization_name: "minecraft:black_bundle",
		},
		{
			command_name: "minecraft:black_candle",
			name: "minecraft:black_candle",
			raw_id: -428,
			serialization_id: "item.black_candle",
			serialization_name: "minecraft:black_candle",
		},
		{
			command_name: "minecraft:black_carpet",
			name: "minecraft:black_carpet",
			raw_id: -611,
			serialization_id: "item.black_carpet",
			serialization_name: "minecraft:black_carpet",
		},
		{
			command_name: "minecraft:black_concrete",
			name: "minecraft:black_concrete",
			raw_id: -642,
			serialization_id: "item.black_concrete",
			serialization_name: "minecraft:black_concrete",
		},
		{
			command_name: "minecraft:black_concrete_powder",
			name: "minecraft:black_concrete_powder",
			raw_id: -723,
			serialization_id: "item.black_concrete_powder",
			serialization_name: "minecraft:black_concrete_powder",
		},
		{
			command_name: "minecraft:black_dye",
			name: "minecraft:black_dye",
			raw_id: 421,
			serialization_id: "item.black_dye",
			serialization_name: "minecraft:black_dye",
		},
		{
			command_name: "minecraft:black_glazed_terracotta",
			name: "minecraft:black_glazed_terracotta",
			raw_id: 235,
			serialization_id: "item.black_glazed_terracotta",
			serialization_name: "minecraft:black_glazed_terracotta",
		},
		{
			command_name: "minecraft:black_shulker_box",
			name: "minecraft:black_shulker_box",
			raw_id: -627,
			serialization_id: "item.black_shulker_box",
			serialization_name: "minecraft:black_shulker_box",
		},
		{
			command_name: "minecraft:black_stained_glass",
			name: "minecraft:black_stained_glass",
			raw_id: -687,
			serialization_id: "item.black_stained_glass",
			serialization_name: "minecraft:black_stained_glass",
		},
		{
			command_name: "minecraft:black_stained_glass_pane",
			name: "minecraft:black_stained_glass_pane",
			raw_id: -657,
			serialization_id: "item.black_stained_glass_pane",
			serialization_name: "minecraft:black_stained_glass_pane",
		},
		{
			command_name: "minecraft:black_terracotta",
			name: "minecraft:black_terracotta",
			raw_id: -738,
			serialization_id: "item.black_terracotta",
			serialization_name: "minecraft:black_terracotta",
		},
		{
			command_name: "minecraft:black_wool",
			name: "minecraft:black_wool",
			raw_id: -554,
			serialization_id: "item.black_wool",
			serialization_name: "minecraft:black_wool",
		},
		{
			command_name: "minecraft:blackstone",
			name: "minecraft:blackstone",
			raw_id: -273,
			serialization_id: "item.blackstone",
			serialization_name: "minecraft:blackstone",
		},
		{
			command_name: "minecraft:blackstone_slab",
			name: "minecraft:blackstone_slab",
			raw_id: -282,
			serialization_id: "item.blackstone_slab",
			serialization_name: "minecraft:blackstone_slab",
		},
		{
			command_name: "minecraft:blackstone_stairs",
			name: "minecraft:blackstone_stairs",
			raw_id: -276,
			serialization_id: "item.blackstone_stairs",
			serialization_name: "minecraft:blackstone_stairs",
		},
		{
			command_name: "minecraft:blackstone_wall",
			name: "minecraft:blackstone_wall",
			raw_id: -277,
			serialization_id: "item.blackstone_wall",
			serialization_name: "minecraft:blackstone_wall",
		},
		{
			command_name: "minecraft:blade_pottery_sherd",
			name: "minecraft:blade_pottery_sherd",
			raw_id: 695,
			serialization_id: "item.blade_pottery_sherd",
			serialization_name: "minecraft:blade_pottery_sherd",
		},
		{
			command_name: "minecraft:blast_furnace",
			name: "minecraft:blast_furnace",
			raw_id: -196,
			serialization_id: "item.blast_furnace",
			serialization_name: "minecraft:blast_furnace",
		},
		{
			command_name: "minecraft:blaze_powder",
			name: "minecraft:blaze_powder",
			raw_id: 456,
			serialization_id: "item.blaze_powder",
			serialization_name: "minecraft:blaze_powder",
		},
		{
			command_name: "minecraft:blaze_rod",
			name: "minecraft:blaze_rod",
			raw_id: 449,
			serialization_id: "item.blaze_rod",
			serialization_name: "minecraft:blaze_rod",
		},
		{
			command_name: "minecraft:blaze_spawn_egg",
			name: "minecraft:blaze_spawn_egg",
			raw_id: 483,
			serialization_id: "item.blaze_spawn_egg",
			serialization_name: "minecraft:blaze_spawn_egg",
		},
		{
			command_name: "minecraft:blue_bundle",
			name: "minecraft:blue_bundle",
			raw_id: 258,
			serialization_id: "item.blue_bundle",
			serialization_name: "minecraft:blue_bundle",
		},
		{
			command_name: "minecraft:blue_candle",
			name: "minecraft:blue_candle",
			raw_id: -424,
			serialization_id: "item.blue_candle",
			serialization_name: "minecraft:blue_candle",
		},
		{
			command_name: "minecraft:blue_carpet",
			name: "minecraft:blue_carpet",
			raw_id: -607,
			serialization_id: "item.blue_carpet",
			serialization_name: "minecraft:blue_carpet",
		},
		{
			command_name: "minecraft:blue_concrete",
			name: "minecraft:blue_concrete",
			raw_id: -638,
			serialization_id: "item.blue_concrete",
			serialization_name: "minecraft:blue_concrete",
		},
		{
			command_name: "minecraft:blue_concrete_powder",
			name: "minecraft:blue_concrete_powder",
			raw_id: -719,
			serialization_id: "item.blue_concrete_powder",
			serialization_name: "minecraft:blue_concrete_powder",
		},
		{
			command_name: "minecraft:blue_dye",
			name: "minecraft:blue_dye",
			raw_id: 425,
			serialization_id: "item.blue_dye",
			serialization_name: "minecraft:blue_dye",
		},
		{
			command_name: "minecraft:blue_glazed_terracotta",
			name: "minecraft:blue_glazed_terracotta",
			raw_id: 231,
			serialization_id: "item.blue_glazed_terracotta",
			serialization_name: "minecraft:blue_glazed_terracotta",
		},
		{
			command_name: "minecraft:blue_ice",
			name: "minecraft:blue_ice",
			raw_id: -11,
			serialization_id: "item.blue_ice",
			serialization_name: "minecraft:blue_ice",
		},
		{
			command_name: "minecraft:blue_orchid",
			name: "minecraft:blue_orchid",
			raw_id: -830,
			serialization_id: "item.blue_orchid",
			serialization_name: "minecraft:blue_orchid",
		},
		{
			command_name: "minecraft:blue_shulker_box",
			name: "minecraft:blue_shulker_box",
			raw_id: -623,
			serialization_id: "item.blue_shulker_box",
			serialization_name: "minecraft:blue_shulker_box",
		},
		{
			command_name: "minecraft:blue_stained_glass",
			name: "minecraft:blue_stained_glass",
			raw_id: -683,
			serialization_id: "item.blue_stained_glass",
			serialization_name: "minecraft:blue_stained_glass",
		},
		{
			command_name: "minecraft:blue_stained_glass_pane",
			name: "minecraft:blue_stained_glass_pane",
			raw_id: -653,
			serialization_id: "item.blue_stained_glass_pane",
			serialization_name: "minecraft:blue_stained_glass_pane",
		},
		{
			command_name: "minecraft:blue_terracotta",
			name: "minecraft:blue_terracotta",
			raw_id: -734,
			serialization_id: "item.blue_terracotta",
			serialization_name: "minecraft:blue_terracotta",
		},
		{
			command_name: "minecraft:blue_wool",
			name: "minecraft:blue_wool",
			raw_id: -563,
			serialization_id: "item.blue_wool",
			serialization_name: "minecraft:blue_wool",
		},
		{
			command_name: "minecraft:bogged_spawn_egg",
			name: "minecraft:bogged_spawn_egg",
			raw_id: 490,
			serialization_id: "item.bogged_spawn_egg",
			serialization_name: "minecraft:bogged_spawn_egg",
		},
		{
			command_name: "minecraft:bolt_armor_trim_smithing_template",
			name: "minecraft:bolt_armor_trim_smithing_template",
			raw_id: 734,
			serialization_id: "item.bolt_armor_trim_smithing_template",
			serialization_name: "minecraft:bolt_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:bone",
			name: "minecraft:bone",
			raw_id: 441,
			serialization_id: "item.bone",
			serialization_name: "minecraft:bone",
		},
		{
			command_name: "minecraft:bone_block",
			name: "minecraft:bone_block",
			raw_id: 216,
			serialization_id: "item.bone_block",
			serialization_name: "minecraft:bone_block",
		},
		{
			command_name: "minecraft:bone_meal",
			name: "minecraft:bone_meal",
			raw_id: 437,
			serialization_id: "item.bone_meal",
			serialization_name: "minecraft:bone_meal",
		},
		{
			command_name: "minecraft:book",
			name: "minecraft:book",
			raw_id: 413,
			serialization_id: "item.book",
			serialization_name: "minecraft:book",
		},
		{
			command_name: "minecraft:bookshelf",
			name: "minecraft:bookshelf",
			raw_id: 47,
			serialization_id: "item.bookshelf",
			serialization_name: "minecraft:bookshelf",
		},
		{
			command_name: "minecraft:border_block",
			name: "minecraft:border_block",
			raw_id: 212,
			serialization_id: "item.border_block",
			serialization_name: "minecraft:border_block",
		},
		{
			command_name: "minecraft:bordure_indented_banner_pattern",
			name: "minecraft:bordure_indented_banner_pattern",
			raw_id: 619,
			serialization_id: "item.bordure_indented_banner_pattern",
			serialization_name: "minecraft:bordure_indented_banner_pattern",
		},
		{
			command_name: "minecraft:bow",
			name: "minecraft:bow",
			raw_id: 324,
			serialization_id: "item.bow",
			serialization_name: "minecraft:bow",
		},
		{
			command_name: "minecraft:bowl",
			name: "minecraft:bowl",
			raw_id: 346,
			serialization_id: "item.bowl",
			serialization_name: "minecraft:bowl",
		},
		{
			command_name: "minecraft:brain_coral",
			name: "minecraft:brain_coral",
			raw_id: -581,
			serialization_id: "item.brain_coral",
			serialization_name: "minecraft:brain_coral",
		},
		{
			command_name: "minecraft:brain_coral_block",
			name: "minecraft:brain_coral_block",
			raw_id: -849,
			serialization_id: "item.brain_coral_block",
			serialization_name: "minecraft:brain_coral_block",
		},
		{
			command_name: "minecraft:brain_coral_fan",
			name: "minecraft:brain_coral_fan",
			raw_id: -840,
			serialization_id: "item.brain_coral_fan",
			serialization_name: "minecraft:brain_coral_fan",
		},
		{
			command_name: "minecraft:bread",
			name: "minecraft:bread",
			raw_id: 283,
			serialization_id: "item.bread",
			serialization_name: "minecraft:bread",
		},
		{
			command_name: "minecraft:breeze_rod",
			name: "minecraft:breeze_rod",
			raw_id: 274,
			serialization_id: "item.breeze_rod.name",
			serialization_name: "minecraft:breeze_rod",
		},
		{
			command_name: "minecraft:breeze_spawn_egg",
			name: "minecraft:breeze_spawn_egg",
			raw_id: 529,
			serialization_id: "item.breeze_spawn_egg",
			serialization_name: "minecraft:breeze_spawn_egg",
		},
		{
			command_name: "minecraft:brewer_pottery_sherd",
			name: "minecraft:brewer_pottery_sherd",
			raw_id: 696,
			serialization_id: "item.brewer_pottery_sherd",
			serialization_name: "minecraft:brewer_pottery_sherd",
		},
		{
			command_name: "minecraft:brewing_stand",
			name: "minecraft:brewing_stand",
			raw_id: 458,
			serialization_id: "item.brewing_stand",
			serialization_name: "minecraft:brewing_stand",
		},
		{
			command_name: "minecraft:brick",
			name: "minecraft:brick",
			raw_id: 409,
			serialization_id: "item.brick",
			serialization_name: "minecraft:brick",
		},
		{
			command_name: "minecraft:brick_block",
			name: "minecraft:brick_block",
			raw_id: 45,
			serialization_id: "item.brick_block",
			serialization_name: "minecraft:brick_block",
		},
		{
			command_name: "minecraft:brick_slab",
			name: "minecraft:brick_slab",
			raw_id: -874,
			serialization_id: "item.brick_slab",
			serialization_name: "minecraft:brick_slab",
		},
		{
			command_name: "minecraft:brick_stairs",
			name: "minecraft:brick_stairs",
			raw_id: 108,
			serialization_id: "item.brick_stairs",
			serialization_name: "minecraft:brick_stairs",
		},
		{
			command_name: "minecraft:brick_wall",
			name: "minecraft:brick_wall",
			raw_id: -976,
			serialization_id: "item.brick_wall",
			serialization_name: "minecraft:brick_wall",
		},
		{
			command_name: "minecraft:brown_bundle",
			name: "minecraft:brown_bundle",
			raw_id: 259,
			serialization_id: "item.brown_bundle",
			serialization_name: "minecraft:brown_bundle",
		},
		{
			command_name: "minecraft:brown_candle",
			name: "minecraft:brown_candle",
			raw_id: -425,
			serialization_id: "item.brown_candle",
			serialization_name: "minecraft:brown_candle",
		},
		{
			command_name: "minecraft:brown_carpet",
			name: "minecraft:brown_carpet",
			raw_id: -608,
			serialization_id: "item.brown_carpet",
			serialization_name: "minecraft:brown_carpet",
		},
		{
			command_name: "minecraft:brown_concrete",
			name: "minecraft:brown_concrete",
			raw_id: -639,
			serialization_id: "item.brown_concrete",
			serialization_name: "minecraft:brown_concrete",
		},
		{
			command_name: "minecraft:brown_concrete_powder",
			name: "minecraft:brown_concrete_powder",
			raw_id: -720,
			serialization_id: "item.brown_concrete_powder",
			serialization_name: "minecraft:brown_concrete_powder",
		},
		{
			command_name: "minecraft:brown_dye",
			name: "minecraft:brown_dye",
			raw_id: 424,
			serialization_id: "item.brown_dye",
			serialization_name: "minecraft:brown_dye",
		},
		{
			command_name: "minecraft:brown_glazed_terracotta",
			name: "minecraft:brown_glazed_terracotta",
			raw_id: 232,
			serialization_id: "item.brown_glazed_terracotta",
			serialization_name: "minecraft:brown_glazed_terracotta",
		},
		{
			command_name: "minecraft:brown_mushroom",
			name: "minecraft:brown_mushroom",
			raw_id: 39,
			serialization_id: "item.brown_mushroom",
			serialization_name: "minecraft:brown_mushroom",
		},
		{
			command_name: "minecraft:brown_mushroom_block",
			name: "minecraft:brown_mushroom_block",
			raw_id: 99,
			serialization_id: "item.brown_mushroom_block",
			serialization_name: "minecraft:brown_mushroom_block",
		},
		{
			command_name: "minecraft:brown_shulker_box",
			name: "minecraft:brown_shulker_box",
			raw_id: -624,
			serialization_id: "item.brown_shulker_box",
			serialization_name: "minecraft:brown_shulker_box",
		},
		{
			command_name: "minecraft:brown_stained_glass",
			name: "minecraft:brown_stained_glass",
			raw_id: -684,
			serialization_id: "item.brown_stained_glass",
			serialization_name: "minecraft:brown_stained_glass",
		},
		{
			command_name: "minecraft:brown_stained_glass_pane",
			name: "minecraft:brown_stained_glass_pane",
			raw_id: -654,
			serialization_id: "item.brown_stained_glass_pane",
			serialization_name: "minecraft:brown_stained_glass_pane",
		},
		{
			command_name: "minecraft:brown_terracotta",
			name: "minecraft:brown_terracotta",
			raw_id: -735,
			serialization_id: "item.brown_terracotta",
			serialization_name: "minecraft:brown_terracotta",
		},
		{
			command_name: "minecraft:brown_wool",
			name: "minecraft:brown_wool",
			raw_id: -555,
			serialization_id: "item.brown_wool",
			serialization_name: "minecraft:brown_wool",
		},
		{
			command_name: "minecraft:brush",
			name: "minecraft:brush",
			raw_id: 715,
			serialization_id: "item.brush",
			serialization_name: "minecraft:brush",
		},
		{
			command_name: "minecraft:bubble_coral",
			name: "minecraft:bubble_coral",
			raw_id: -582,
			serialization_id: "item.bubble_coral",
			serialization_name: "minecraft:bubble_coral",
		},
		{
			command_name: "minecraft:bubble_coral_block",
			name: "minecraft:bubble_coral_block",
			raw_id: -850,
			serialization_id: "item.bubble_coral_block",
			serialization_name: "minecraft:bubble_coral_block",
		},
		{
			command_name: "minecraft:bubble_coral_fan",
			name: "minecraft:bubble_coral_fan",
			raw_id: -841,
			serialization_id: "item.bubble_coral_fan",
			serialization_name: "minecraft:bubble_coral_fan",
		},
		{
			command_name: "minecraft:bucket",
			name: "minecraft:bucket",
			raw_id: 385,
			serialization_id: "item.bucket",
			serialization_name: "minecraft:bucket",
		},
		{
			command_name: "minecraft:budding_amethyst",
			name: "minecraft:budding_amethyst",
			raw_id: -328,
			serialization_id: "item.budding_amethyst",
			serialization_name: "minecraft:budding_amethyst",
		},
		{
			command_name: "minecraft:bundle",
			name: "minecraft:bundle",
			raw_id: 260,
			serialization_id: "item.bundle",
			serialization_name: "minecraft:bundle",
		},
		{
			command_name: "minecraft:burn_pottery_sherd",
			name: "minecraft:burn_pottery_sherd",
			raw_id: 697,
			serialization_id: "item.burn_pottery_sherd",
			serialization_name: "minecraft:burn_pottery_sherd",
		},
		{
			command_name: "minecraft:cactus",
			name: "minecraft:cactus",
			raw_id: 81,
			serialization_id: "item.cactus",
			serialization_name: "minecraft:cactus",
		},
		{
			command_name: "minecraft:cake",
			name: "minecraft:cake",
			raw_id: 443,
			serialization_id: "item.cake",
			serialization_name: "minecraft:cake",
		},
		{
			command_name: "minecraft:calcite",
			name: "minecraft:calcite",
			raw_id: -326,
			serialization_id: "item.calcite",
			serialization_name: "minecraft:calcite",
		},
		{
			command_name: "minecraft:calibrated_sculk_sensor",
			name: "minecraft:calibrated_sculk_sensor",
			raw_id: -580,
			serialization_id: "item.calibrated_sculk_sensor",
			serialization_name: "minecraft:calibrated_sculk_sensor",
		},
		{
			command_name: "minecraft:camel_spawn_egg",
			name: "minecraft:camel_spawn_egg",
			raw_id: 691,
			serialization_id: "item.camel_spawn_egg",
			serialization_name: "minecraft:camel_spawn_egg",
		},
		{
			command_name: "minecraft:campfire",
			name: "minecraft:campfire",
			raw_id: 624,
			serialization_id: "tile.campfire",
			serialization_name: "minecraft:campfire",
		},
		{
			command_name: "minecraft:candle",
			name: "minecraft:candle",
			raw_id: -412,
			serialization_id: "item.candle",
			serialization_name: "minecraft:candle",
		},
		{
			command_name: "minecraft:carrot",
			name: "minecraft:carrot",
			raw_id: 301,
			serialization_id: "item.carrot",
			serialization_name: "minecraft:carrot",
		},
		{
			command_name: "minecraft:carrot_on_a_stick",
			name: "minecraft:carrot_on_a_stick",
			raw_id: 550,
			serialization_id: "item.carrotOnAStick",
			serialization_name: "minecraft:carrot_on_a_stick",
		},
		{
			command_name: "minecraft:cartography_table",
			name: "minecraft:cartography_table",
			raw_id: -200,
			serialization_id: "item.cartography_table",
			serialization_name: "minecraft:cartography_table",
		},
		{
			command_name: "minecraft:carved_pumpkin",
			name: "minecraft:carved_pumpkin",
			raw_id: -155,
			serialization_id: "item.carved_pumpkin",
			serialization_name: "minecraft:carved_pumpkin",
		},
		{
			command_name: "minecraft:cat_spawn_egg",
			name: "minecraft:cat_spawn_egg",
			raw_id: 516,
			serialization_id: "item.cat_spawn_egg",
			serialization_name: "minecraft:cat_spawn_egg",
		},
		{
			command_name: "minecraft:cauldron",
			name: "minecraft:cauldron",
			raw_id: 459,
			serialization_id: "item.cauldron",
			serialization_name: "minecraft:cauldron",
		},
		{
			command_name: "minecraft:cave_spider_spawn_egg",
			name: "minecraft:cave_spider_spawn_egg",
			raw_id: 484,
			serialization_id: "item.cave_spider_spawn_egg",
			serialization_name: "minecraft:cave_spider_spawn_egg",
		},
		{
			command_name: "minecraft:chain",
			name: "minecraft:chain",
			raw_id: 655,
			serialization_id: "tile.chain",
			serialization_name: "minecraft:chain",
		},
		{
			command_name: "minecraft:chain_command_block",
			name: "minecraft:chain_command_block",
			raw_id: 189,
			serialization_id: "item.chain_command_block",
			serialization_name: "minecraft:chain_command_block",
		},
		{
			command_name: "minecraft:chainmail_boots",
			name: "minecraft:chainmail_boots",
			raw_id: 367,
			serialization_id: "item.chainmail_boots",
			serialization_name: "minecraft:chainmail_boots",
		},
		{
			command_name: "minecraft:chainmail_chestplate",
			name: "minecraft:chainmail_chestplate",
			raw_id: 365,
			serialization_id: "item.chainmail_chestplate",
			serialization_name: "minecraft:chainmail_chestplate",
		},
		{
			command_name: "minecraft:chainmail_helmet",
			name: "minecraft:chainmail_helmet",
			raw_id: 364,
			serialization_id: "item.chainmail_helmet",
			serialization_name: "minecraft:chainmail_helmet",
		},
		{
			command_name: "minecraft:chainmail_leggings",
			name: "minecraft:chainmail_leggings",
			raw_id: 366,
			serialization_id: "item.chainmail_leggings",
			serialization_name: "minecraft:chainmail_leggings",
		},
		{
			command_name: "minecraft:charcoal",
			name: "minecraft:charcoal",
			raw_id: 327,
			serialization_id: "item.charcoal",
			serialization_name: "minecraft:charcoal",
		},
		{
			command_name: "minecraft:cherry_boat",
			name: "minecraft:cherry_boat",
			raw_id: 685,
			serialization_id: "item.cherry_boat",
			serialization_name: "minecraft:cherry_boat",
		},
		{
			command_name: "minecraft:cherry_button",
			name: "minecraft:cherry_button",
			raw_id: -530,
			serialization_id: "item.cherry_button",
			serialization_name: "minecraft:cherry_button",
		},
		{
			command_name: "minecraft:cherry_chest_boat",
			name: "minecraft:cherry_chest_boat",
			raw_id: 686,
			serialization_id: "item.cherry_chest_boat",
			serialization_name: "minecraft:cherry_chest_boat",
		},
		{
			command_name: "minecraft:cherry_door",
			name: "minecraft:cherry_door",
			raw_id: -531,
			serialization_id: "item.cherry_door",
			serialization_name: "minecraft:cherry_door",
		},
		{
			command_name: "minecraft:cherry_fence",
			name: "minecraft:cherry_fence",
			raw_id: -532,
			serialization_id: "item.cherry_fence",
			serialization_name: "minecraft:cherry_fence",
		},
		{
			command_name: "minecraft:cherry_fence_gate",
			name: "minecraft:cherry_fence_gate",
			raw_id: -533,
			serialization_id: "item.cherry_fence_gate",
			serialization_name: "minecraft:cherry_fence_gate",
		},
		{
			command_name: "minecraft:cherry_hanging_sign",
			name: "minecraft:cherry_hanging_sign",
			raw_id: -534,
			serialization_id: "item.cherry_hanging_sign",
			serialization_name: "minecraft:cherry_hanging_sign",
		},
		{
			command_name: "minecraft:cherry_leaves",
			name: "minecraft:cherry_leaves",
			raw_id: -548,
			serialization_id: "item.cherry_leaves",
			serialization_name: "minecraft:cherry_leaves",
		},
		{
			command_name: "minecraft:cherry_log",
			name: "minecraft:cherry_log",
			raw_id: -536,
			serialization_id: "item.cherry_log",
			serialization_name: "minecraft:cherry_log",
		},
		{
			command_name: "minecraft:cherry_planks",
			name: "minecraft:cherry_planks",
			raw_id: -537,
			serialization_id: "item.cherry_planks",
			serialization_name: "minecraft:cherry_planks",
		},
		{
			command_name: "minecraft:cherry_pressure_plate",
			name: "minecraft:cherry_pressure_plate",
			raw_id: -538,
			serialization_id: "item.cherry_pressure_plate",
			serialization_name: "minecraft:cherry_pressure_plate",
		},
		{
			command_name: "minecraft:cherry_sapling",
			name: "minecraft:cherry_sapling",
			raw_id: -547,
			serialization_id: "item.cherry_sapling",
			serialization_name: "minecraft:cherry_sapling",
		},
		{
			command_name: "minecraft:cherry_sign",
			name: "minecraft:cherry_sign",
			raw_id: 687,
			serialization_id: "item.cherry_sign",
			serialization_name: "minecraft:cherry_sign",
		},
		{
			command_name: "minecraft:cherry_slab",
			name: "minecraft:cherry_slab",
			raw_id: -539,
			serialization_id: "item.cherry_slab",
			serialization_name: "minecraft:cherry_slab",
		},
		{
			command_name: "minecraft:cherry_stairs",
			name: "minecraft:cherry_stairs",
			raw_id: -541,
			serialization_id: "item.cherry_stairs",
			serialization_name: "minecraft:cherry_stairs",
		},
		{
			command_name: "minecraft:cherry_trapdoor",
			name: "minecraft:cherry_trapdoor",
			raw_id: -543,
			serialization_id: "item.cherry_trapdoor",
			serialization_name: "minecraft:cherry_trapdoor",
		},
		{
			command_name: "minecraft:cherry_wood",
			name: "minecraft:cherry_wood",
			raw_id: -546,
			serialization_id: "item.cherry_wood",
			serialization_name: "minecraft:cherry_wood",
		},
		{
			command_name: "minecraft:chest",
			name: "minecraft:chest",
			raw_id: 54,
			serialization_id: "item.chest",
			serialization_name: "minecraft:chest",
		},
		{
			command_name: "minecraft:chest_minecart",
			name: "minecraft:chest_minecart",
			raw_id: 415,
			serialization_id: "item.chest_minecart",
			serialization_name: "minecraft:chest_minecart",
		},
		{
			command_name: "minecraft:chicken",
			name: "minecraft:chicken",
			raw_id: 297,
			serialization_id: "item.chicken",
			serialization_name: "minecraft:chicken",
		},
		{
			command_name: "minecraft:chicken_spawn_egg",
			name: "minecraft:chicken_spawn_egg",
			raw_id: 462,
			serialization_id: "item.chicken_spawn_egg",
			serialization_name: "minecraft:chicken_spawn_egg",
		},
		{
			command_name: "minecraft:chipped_anvil",
			name: "minecraft:chipped_anvil",
			raw_id: -959,
			serialization_id: "item.chipped_anvil",
			serialization_name: "minecraft:chipped_anvil",
		},
		{
			command_name: "minecraft:chiseled_bookshelf",
			name: "minecraft:chiseled_bookshelf",
			raw_id: -526,
			serialization_id: "item.chiseled_bookshelf",
			serialization_name: "minecraft:chiseled_bookshelf",
		},
		{
			command_name: "minecraft:chiseled_copper",
			name: "minecraft:chiseled_copper",
			raw_id: -760,
			serialization_id: "item.chiseled_copper",
			serialization_name: "minecraft:chiseled_copper",
		},
		{
			command_name: "minecraft:chiseled_deepslate",
			name: "minecraft:chiseled_deepslate",
			raw_id: -395,
			serialization_id: "item.chiseled_deepslate",
			serialization_name: "minecraft:chiseled_deepslate",
		},
		{
			command_name: "minecraft:chiseled_nether_bricks",
			name: "minecraft:chiseled_nether_bricks",
			raw_id: -302,
			serialization_id: "item.chiseled_nether_bricks",
			serialization_name: "minecraft:chiseled_nether_bricks",
		},
		{
			command_name: "minecraft:chiseled_polished_blackstone",
			name: "minecraft:chiseled_polished_blackstone",
			raw_id: -279,
			serialization_id: "item.chiseled_polished_blackstone",
			serialization_name: "minecraft:chiseled_polished_blackstone",
		},
		{
			command_name: "minecraft:chiseled_quartz_block",
			name: "minecraft:chiseled_quartz_block",
			raw_id: -953,
			serialization_id: "item.chiseled_quartz_block",
			serialization_name: "minecraft:chiseled_quartz_block",
		},
		{
			command_name: "minecraft:chiseled_red_sandstone",
			name: "minecraft:chiseled_red_sandstone",
			raw_id: -956,
			serialization_id: "item.chiseled_red_sandstone",
			serialization_name: "minecraft:chiseled_red_sandstone",
		},
		{
			command_name: "minecraft:chiseled_sandstone",
			name: "minecraft:chiseled_sandstone",
			raw_id: -944,
			serialization_id: "item.chiseled_sandstone",
			serialization_name: "minecraft:chiseled_sandstone",
		},
		{
			command_name: "minecraft:chiseled_stone_bricks",
			name: "minecraft:chiseled_stone_bricks",
			raw_id: -870,
			serialization_id: "item.chiseled_stone_bricks",
			serialization_name: "minecraft:chiseled_stone_bricks",
		},
		{
			command_name: "minecraft:chiseled_tuff",
			name: "minecraft:chiseled_tuff",
			raw_id: -753,
			serialization_id: "item.chiseled_tuff",
			serialization_name: "minecraft:chiseled_tuff",
		},
		{
			command_name: "minecraft:chiseled_tuff_bricks",
			name: "minecraft:chiseled_tuff_bricks",
			raw_id: -759,
			serialization_id: "item.chiseled_tuff_bricks",
			serialization_name: "minecraft:chiseled_tuff_bricks",
		},
		{
			command_name: "minecraft:chorus_flower",
			name: "minecraft:chorus_flower",
			raw_id: 200,
			serialization_id: "item.chorus_flower",
			serialization_name: "minecraft:chorus_flower",
		},
		{
			command_name: "minecraft:chorus_fruit",
			name: "minecraft:chorus_fruit",
			raw_id: 591,
			serialization_id: "item.chorus_fruit",
			serialization_name: "minecraft:chorus_fruit",
		},
		{
			command_name: "minecraft:chorus_plant",
			name: "minecraft:chorus_plant",
			raw_id: 240,
			serialization_id: "item.chorus_plant",
			serialization_name: "minecraft:chorus_plant",
		},
		{
			command_name: "minecraft:clay",
			name: "minecraft:clay",
			raw_id: 82,
			serialization_id: "item.clay",
			serialization_name: "minecraft:clay",
		},
		{
			command_name: "minecraft:clay_ball",
			name: "minecraft:clay_ball",
			raw_id: 410,
			serialization_id: "item.clay_ball",
			serialization_name: "minecraft:clay_ball",
		},
		{
			command_name: "minecraft:clock",
			name: "minecraft:clock",
			raw_id: 419,
			serialization_id: "item.clock",
			serialization_name: "minecraft:clock",
		},
		{
			command_name: "minecraft:coal",
			name: "minecraft:coal",
			raw_id: 326,
			serialization_id: "item.coal",
			serialization_name: "minecraft:coal",
		},
		{
			command_name: "minecraft:coal_block",
			name: "minecraft:coal_block",
			raw_id: 173,
			serialization_id: "item.coal_block",
			serialization_name: "minecraft:coal_block",
		},
		{
			command_name: "minecraft:coal_ore",
			name: "minecraft:coal_ore",
			raw_id: 16,
			serialization_id: "item.coal_ore",
			serialization_name: "minecraft:coal_ore",
		},
		{
			command_name: "minecraft:coarse_dirt",
			name: "minecraft:coarse_dirt",
			raw_id: -962,
			serialization_id: "item.coarse_dirt",
			serialization_name: "minecraft:coarse_dirt",
		},
		{
			command_name: "minecraft:coast_armor_trim_smithing_template",
			name: "minecraft:coast_armor_trim_smithing_template",
			raw_id: 719,
			serialization_id: "item.coast_armor_trim_smithing_template",
			serialization_name: "minecraft:coast_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:cobbled_deepslate",
			name: "minecraft:cobbled_deepslate",
			raw_id: -379,
			serialization_id: "item.cobbled_deepslate",
			serialization_name: "minecraft:cobbled_deepslate",
		},
		{
			command_name: "minecraft:cobbled_deepslate_slab",
			name: "minecraft:cobbled_deepslate_slab",
			raw_id: -380,
			serialization_id: "item.cobbled_deepslate_slab",
			serialization_name: "minecraft:cobbled_deepslate_slab",
		},
		{
			command_name: "minecraft:cobbled_deepslate_stairs",
			name: "minecraft:cobbled_deepslate_stairs",
			raw_id: -381,
			serialization_id: "item.cobbled_deepslate_stairs",
			serialization_name: "minecraft:cobbled_deepslate_stairs",
		},
		{
			command_name: "minecraft:cobbled_deepslate_wall",
			name: "minecraft:cobbled_deepslate_wall",
			raw_id: -382,
			serialization_id: "item.cobbled_deepslate_wall",
			serialization_name: "minecraft:cobbled_deepslate_wall",
		},
		{
			command_name: "minecraft:cobblestone",
			name: "minecraft:cobblestone",
			raw_id: 4,
			serialization_id: "item.cobblestone",
			serialization_name: "minecraft:cobblestone",
		},
		{
			command_name: "minecraft:cobblestone_slab",
			name: "minecraft:cobblestone_slab",
			raw_id: -873,
			serialization_id: "item.cobblestone_slab",
			serialization_name: "minecraft:cobblestone_slab",
		},
		{
			command_name: "minecraft:cobblestone_wall",
			name: "minecraft:cobblestone_wall",
			raw_id: 139,
			serialization_id: "item.cobblestone_wall",
			serialization_name: "minecraft:cobblestone_wall",
		},
		{
			command_name: "minecraft:cocoa_beans",
			name: "minecraft:cocoa_beans",
			raw_id: 438,
			serialization_id: "item.cocoa_beans",
			serialization_name: "minecraft:cocoa_beans",
		},
		{
			command_name: "minecraft:cod",
			name: "minecraft:cod",
			raw_id: 286,
			serialization_id: "item.fish",
			serialization_name: "minecraft:cod",
		},
		{
			command_name: "minecraft:cod_bucket",
			name: "minecraft:cod_bucket",
			raw_id: 389,
			serialization_id: "item.cod_bucket",
			serialization_name: "minecraft:cod_bucket",
		},
		{
			command_name: "minecraft:cod_spawn_egg",
			name: "minecraft:cod_spawn_egg",
			raw_id: 508,
			serialization_id: "item.cod_spawn_egg",
			serialization_name: "minecraft:cod_spawn_egg",
		},
		{
			command_name: "minecraft:command_block",
			name: "minecraft:command_block",
			raw_id: 137,
			serialization_id: "item.command_block",
			serialization_name: "minecraft:command_block",
		},
		{
			command_name: "minecraft:command_block_minecart",
			name: "minecraft:command_block_minecart",
			raw_id: 596,
			serialization_id: "item.command_block_minecart",
			serialization_name: "minecraft:command_block_minecart",
		},
		{
			command_name: "minecraft:comparator",
			name: "minecraft:comparator",
			raw_id: 555,
			serialization_id: "item.comparator",
			serialization_name: "minecraft:comparator",
		},
		{
			command_name: "minecraft:compass",
			name: "minecraft:compass",
			raw_id: 417,
			serialization_id: "item.compass",
			serialization_name: "minecraft:compass",
		},
		{
			command_name: "minecraft:composter",
			name: "minecraft:composter",
			raw_id: -213,
			serialization_id: "item.composter",
			serialization_name: "minecraft:composter",
		},
		{
			command_name: "minecraft:conduit",
			name: "minecraft:conduit",
			raw_id: -157,
			serialization_id: "item.conduit",
			serialization_name: "minecraft:conduit",
		},
		{
			command_name: "minecraft:cooked_beef",
			name: "minecraft:cooked_beef",
			raw_id: 296,
			serialization_id: "item.cooked_beef",
			serialization_name: "minecraft:cooked_beef",
		},
		{
			command_name: "minecraft:cooked_chicken",
			name: "minecraft:cooked_chicken",
			raw_id: 298,
			serialization_id: "item.cooked_chicken",
			serialization_name: "minecraft:cooked_chicken",
		},
		{
			command_name: "minecraft:cooked_cod",
			name: "minecraft:cooked_cod",
			raw_id: 290,
			serialization_id: "item.cooked_fish",
			serialization_name: "minecraft:cooked_cod",
		},
		{
			command_name: "minecraft:cooked_mutton",
			name: "minecraft:cooked_mutton",
			raw_id: 584,
			serialization_id: "item.muttonCooked",
			serialization_name: "minecraft:cooked_mutton",
		},
		{
			command_name: "minecraft:cooked_porkchop",
			name: "minecraft:cooked_porkchop",
			raw_id: 285,
			serialization_id: "item.cooked_porkchop",
			serialization_name: "minecraft:cooked_porkchop",
		},
		{
			command_name: "minecraft:cooked_rabbit",
			name: "minecraft:cooked_rabbit",
			raw_id: 311,
			serialization_id: "item.cooked_rabbit",
			serialization_name: "minecraft:cooked_rabbit",
		},
		{
			command_name: "minecraft:cooked_salmon",
			name: "minecraft:cooked_salmon",
			raw_id: 291,
			serialization_id: "item.cooked_salmon",
			serialization_name: "minecraft:cooked_salmon",
		},
		{
			command_name: "minecraft:cookie",
			name: "minecraft:cookie",
			raw_id: 293,
			serialization_id: "item.cookie",
			serialization_name: "minecraft:cookie",
		},
		{
			command_name: "minecraft:copper_block",
			name: "minecraft:copper_block",
			raw_id: -340,
			serialization_id: "item.copper_block",
			serialization_name: "minecraft:copper_block",
		},
		{
			command_name: "minecraft:copper_bulb",
			name: "minecraft:copper_bulb",
			raw_id: -776,
			serialization_id: "item.copper_bulb",
			serialization_name: "minecraft:copper_bulb",
		},
		{
			command_name: "minecraft:copper_door",
			name: "minecraft:copper_door",
			raw_id: -784,
			serialization_id: "item.copper_door",
			serialization_name: "minecraft:copper_door",
		},
		{
			command_name: "minecraft:copper_grate",
			name: "minecraft:copper_grate",
			raw_id: -768,
			serialization_id: "item.copper_grate",
			serialization_name: "minecraft:copper_grate",
		},
		{
			command_name: "minecraft:copper_ingot",
			name: "minecraft:copper_ingot",
			raw_id: 538,
			serialization_id: "item.copper_ingot",
			serialization_name: "minecraft:copper_ingot",
		},
		{
			command_name: "minecraft:copper_ore",
			name: "minecraft:copper_ore",
			raw_id: -311,
			serialization_id: "item.copper_ore",
			serialization_name: "minecraft:copper_ore",
		},
		{
			command_name: "minecraft:copper_trapdoor",
			name: "minecraft:copper_trapdoor",
			raw_id: -792,
			serialization_id: "item.copper_trapdoor",
			serialization_name: "minecraft:copper_trapdoor",
		},
		{
			command_name: "minecraft:cornflower",
			name: "minecraft:cornflower",
			raw_id: -838,
			serialization_id: "item.cornflower",
			serialization_name: "minecraft:cornflower",
		},
		{
			command_name: "minecraft:cow_spawn_egg",
			name: "minecraft:cow_spawn_egg",
			raw_id: 463,
			serialization_id: "item.cow_spawn_egg",
			serialization_name: "minecraft:cow_spawn_egg",
		},
		{
			command_name: "minecraft:cracked_deepslate_bricks",
			name: "minecraft:cracked_deepslate_bricks",
			raw_id: -410,
			serialization_id: "item.cracked_deepslate_bricks",
			serialization_name: "minecraft:cracked_deepslate_bricks",
		},
		{
			command_name: "minecraft:cracked_deepslate_tiles",
			name: "minecraft:cracked_deepslate_tiles",
			raw_id: -409,
			serialization_id: "item.cracked_deepslate_tiles",
			serialization_name: "minecraft:cracked_deepslate_tiles",
		},
		{
			command_name: "minecraft:cracked_nether_bricks",
			name: "minecraft:cracked_nether_bricks",
			raw_id: -303,
			serialization_id: "item.cracked_nether_bricks",
			serialization_name: "minecraft:cracked_nether_bricks",
		},
		{
			command_name: "minecraft:cracked_polished_blackstone_bricks",
			name: "minecraft:cracked_polished_blackstone_bricks",
			raw_id: -280,
			serialization_id: "item.cracked_polished_blackstone_bricks",
			serialization_name: "minecraft:cracked_polished_blackstone_bricks",
		},
		{
			command_name: "minecraft:cracked_stone_bricks",
			name: "minecraft:cracked_stone_bricks",
			raw_id: -869,
			serialization_id: "item.cracked_stone_bricks",
			serialization_name: "minecraft:cracked_stone_bricks",
		},
		{
			command_name: "minecraft:crafter",
			name: "minecraft:crafter",
			raw_id: -313,
			serialization_id: "item.crafter",
			serialization_name: "minecraft:crafter",
		},
		{
			command_name: "minecraft:crafting_table",
			name: "minecraft:crafting_table",
			raw_id: 58,
			serialization_id: "item.crafting_table",
			serialization_name: "minecraft:crafting_table",
		},
		{
			command_name: "minecraft:creeper_banner_pattern",
			name: "minecraft:creeper_banner_pattern",
			raw_id: 615,
			serialization_id: "item.creeper_banner_pattern",
			serialization_name: "minecraft:creeper_banner_pattern",
		},
		{
			command_name: "minecraft:creeper_head",
			name: "minecraft:creeper_head",
			raw_id: -968,
			serialization_id: "item.creeper_head",
			serialization_name: "minecraft:creeper_head",
		},
		{
			command_name: "minecraft:creeper_spawn_egg",
			name: "minecraft:creeper_spawn_egg",
			raw_id: 468,
			serialization_id: "item.creeper_spawn_egg",
			serialization_name: "minecraft:creeper_spawn_egg",
		},
		{
			command_name: "minecraft:crimson_button",
			name: "minecraft:crimson_button",
			raw_id: -260,
			serialization_id: "item.crimson_button",
			serialization_name: "minecraft:crimson_button",
		},
		{
			command_name: "minecraft:crimson_door",
			name: "minecraft:crimson_door",
			raw_id: 652,
			serialization_id: "item.crimson_door",
			serialization_name: "minecraft:crimson_door",
		},
		{
			command_name: "minecraft:crimson_fence",
			name: "minecraft:crimson_fence",
			raw_id: -256,
			serialization_id: "item.crimson_fence",
			serialization_name: "minecraft:crimson_fence",
		},
		{
			command_name: "minecraft:crimson_fence_gate",
			name: "minecraft:crimson_fence_gate",
			raw_id: -258,
			serialization_id: "item.crimson_fence_gate",
			serialization_name: "minecraft:crimson_fence_gate",
		},
		{
			command_name: "minecraft:crimson_fungus",
			name: "minecraft:crimson_fungus",
			raw_id: -228,
			serialization_id: "item.crimson_fungus",
			serialization_name: "minecraft:crimson_fungus",
		},
		{
			command_name: "minecraft:crimson_hanging_sign",
			name: "minecraft:crimson_hanging_sign",
			raw_id: -506,
			serialization_id: "item.crimson_hanging_sign",
			serialization_name: "minecraft:crimson_hanging_sign",
		},
		{
			command_name: "minecraft:crimson_hyphae",
			name: "minecraft:crimson_hyphae",
			raw_id: -299,
			serialization_id: "item.crimson_hyphae",
			serialization_name: "minecraft:crimson_hyphae",
		},
		{
			command_name: "minecraft:crimson_nylium",
			name: "minecraft:crimson_nylium",
			raw_id: -232,
			serialization_id: "item.crimson_nylium",
			serialization_name: "minecraft:crimson_nylium",
		},
		{
			command_name: "minecraft:crimson_planks",
			name: "minecraft:crimson_planks",
			raw_id: -242,
			serialization_id: "item.crimson_planks",
			serialization_name: "minecraft:crimson_planks",
		},
		{
			command_name: "minecraft:crimson_pressure_plate",
			name: "minecraft:crimson_pressure_plate",
			raw_id: -262,
			serialization_id: "item.crimson_pressure_plate",
			serialization_name: "minecraft:crimson_pressure_plate",
		},
		{
			command_name: "minecraft:crimson_roots",
			name: "minecraft:crimson_roots",
			raw_id: -223,
			serialization_id: "item.crimson_roots",
			serialization_name: "minecraft:crimson_roots",
		},
		{
			command_name: "minecraft:crimson_sign",
			name: "minecraft:crimson_sign",
			raw_id: 650,
			serialization_id: "item.crimson_sign",
			serialization_name: "minecraft:crimson_sign",
		},
		{
			command_name: "minecraft:crimson_slab",
			name: "minecraft:crimson_slab",
			raw_id: -264,
			serialization_id: "item.crimson_slab",
			serialization_name: "minecraft:crimson_slab",
		},
		{
			command_name: "minecraft:crimson_stairs",
			name: "minecraft:crimson_stairs",
			raw_id: -254,
			serialization_id: "item.crimson_stairs",
			serialization_name: "minecraft:crimson_stairs",
		},
		{
			command_name: "minecraft:crimson_stem",
			name: "minecraft:crimson_stem",
			raw_id: -225,
			serialization_id: "item.crimson_stem",
			serialization_name: "minecraft:crimson_stem",
		},
		{
			command_name: "minecraft:crimson_trapdoor",
			name: "minecraft:crimson_trapdoor",
			raw_id: -246,
			serialization_id: "item.crimson_trapdoor",
			serialization_name: "minecraft:crimson_trapdoor",
		},
		{
			command_name: "minecraft:crossbow",
			name: "minecraft:crossbow",
			raw_id: 608,
			serialization_id: "item.crossbow",
			serialization_name: "minecraft:crossbow",
		},
		{
			command_name: "minecraft:crying_obsidian",
			name: "minecraft:crying_obsidian",
			raw_id: -289,
			serialization_id: "item.crying_obsidian",
			serialization_name: "minecraft:crying_obsidian",
		},
		{
			command_name: "minecraft:cut_copper",
			name: "minecraft:cut_copper",
			raw_id: -347,
			serialization_id: "item.cut_copper",
			serialization_name: "minecraft:cut_copper",
		},
		{
			command_name: "minecraft:cut_copper_slab",
			name: "minecraft:cut_copper_slab",
			raw_id: -361,
			serialization_id: "item.cut_copper_slab",
			serialization_name: "minecraft:cut_copper_slab",
		},
		{
			command_name: "minecraft:cut_copper_stairs",
			name: "minecraft:cut_copper_stairs",
			raw_id: -354,
			serialization_id: "item.cut_copper_stairs",
			serialization_name: "minecraft:cut_copper_stairs",
		},
		{
			command_name: "minecraft:cut_red_sandstone",
			name: "minecraft:cut_red_sandstone",
			raw_id: -957,
			serialization_id: "item.cut_red_sandstone",
			serialization_name: "minecraft:cut_red_sandstone",
		},
		{
			command_name: "minecraft:cut_red_sandstone_slab",
			name: "minecraft:cut_red_sandstone_slab",
			raw_id: -901,
			serialization_id: "item.cut_red_sandstone_slab",
			serialization_name: "minecraft:cut_red_sandstone_slab",
		},
		{
			command_name: "minecraft:cut_sandstone",
			name: "minecraft:cut_sandstone",
			raw_id: -945,
			serialization_id: "item.cut_sandstone",
			serialization_name: "minecraft:cut_sandstone",
		},
		{
			command_name: "minecraft:cut_sandstone_slab",
			name: "minecraft:cut_sandstone_slab",
			raw_id: -900,
			serialization_id: "item.cut_sandstone_slab",
			serialization_name: "minecraft:cut_sandstone_slab",
		},
		{
			command_name: "minecraft:cyan_bundle",
			name: "minecraft:cyan_bundle",
			raw_id: 261,
			serialization_id: "item.cyan_bundle",
			serialization_name: "minecraft:cyan_bundle",
		},
		{
			command_name: "minecraft:cyan_candle",
			name: "minecraft:cyan_candle",
			raw_id: -422,
			serialization_id: "item.cyan_candle",
			serialization_name: "minecraft:cyan_candle",
		},
		{
			command_name: "minecraft:cyan_carpet",
			name: "minecraft:cyan_carpet",
			raw_id: -605,
			serialization_id: "item.cyan_carpet",
			serialization_name: "minecraft:cyan_carpet",
		},
		{
			command_name: "minecraft:cyan_concrete",
			name: "minecraft:cyan_concrete",
			raw_id: -636,
			serialization_id: "item.cyan_concrete",
			serialization_name: "minecraft:cyan_concrete",
		},
		{
			command_name: "minecraft:cyan_concrete_powder",
			name: "minecraft:cyan_concrete_powder",
			raw_id: -717,
			serialization_id: "item.cyan_concrete_powder",
			serialization_name: "minecraft:cyan_concrete_powder",
		},
		{
			command_name: "minecraft:cyan_dye",
			name: "minecraft:cyan_dye",
			raw_id: 427,
			serialization_id: "item.cyan_dye",
			serialization_name: "minecraft:cyan_dye",
		},
		{
			command_name: "minecraft:cyan_glazed_terracotta",
			name: "minecraft:cyan_glazed_terracotta",
			raw_id: 229,
			serialization_id: "item.cyan_glazed_terracotta",
			serialization_name: "minecraft:cyan_glazed_terracotta",
		},
		{
			command_name: "minecraft:cyan_shulker_box",
			name: "minecraft:cyan_shulker_box",
			raw_id: -621,
			serialization_id: "item.cyan_shulker_box",
			serialization_name: "minecraft:cyan_shulker_box",
		},
		{
			command_name: "minecraft:cyan_stained_glass",
			name: "minecraft:cyan_stained_glass",
			raw_id: -681,
			serialization_id: "item.cyan_stained_glass",
			serialization_name: "minecraft:cyan_stained_glass",
		},
		{
			command_name: "minecraft:cyan_stained_glass_pane",
			name: "minecraft:cyan_stained_glass_pane",
			raw_id: -651,
			serialization_id: "item.cyan_stained_glass_pane",
			serialization_name: "minecraft:cyan_stained_glass_pane",
		},
		{
			command_name: "minecraft:cyan_terracotta",
			name: "minecraft:cyan_terracotta",
			raw_id: -732,
			serialization_id: "item.cyan_terracotta",
			serialization_name: "minecraft:cyan_terracotta",
		},
		{
			command_name: "minecraft:cyan_wool",
			name: "minecraft:cyan_wool",
			raw_id: -561,
			serialization_id: "item.cyan_wool",
			serialization_name: "minecraft:cyan_wool",
		},
		{
			command_name: "minecraft:damaged_anvil",
			name: "minecraft:damaged_anvil",
			raw_id: -960,
			serialization_id: "item.damaged_anvil",
			serialization_name: "minecraft:damaged_anvil",
		},
		{
			command_name: "minecraft:dandelion",
			name: "minecraft:dandelion",
			raw_id: 37,
			serialization_id: "item.dandelion",
			serialization_name: "minecraft:dandelion",
		},
		{
			command_name: "minecraft:danger_pottery_sherd",
			name: "minecraft:danger_pottery_sherd",
			raw_id: 698,
			serialization_id: "item.danger_pottery_sherd",
			serialization_name: "minecraft:danger_pottery_sherd",
		},
		{
			command_name: "minecraft:dark_oak_boat",
			name: "minecraft:dark_oak_boat",
			raw_id: 406,
			serialization_id: "item.dark_oak_boat",
			serialization_name: "minecraft:dark_oak_boat",
		},
		{
			command_name: "minecraft:dark_oak_button",
			name: "minecraft:dark_oak_button",
			raw_id: -142,
			serialization_id: "item.dark_oak_button",
			serialization_name: "minecraft:dark_oak_button",
		},
		{
			command_name: "minecraft:dark_oak_chest_boat",
			name: "minecraft:dark_oak_chest_boat",
			raw_id: 679,
			serialization_id: "item.dark_oak_chest_boat",
			serialization_name: "minecraft:dark_oak_chest_boat",
		},
		{
			command_name: "minecraft:dark_oak_door",
			name: "minecraft:dark_oak_door",
			raw_id: 590,
			serialization_id: "item.dark_oak_door",
			serialization_name: "minecraft:dark_oak_door",
		},
		{
			command_name: "minecraft:dark_oak_fence",
			name: "minecraft:dark_oak_fence",
			raw_id: -577,
			serialization_id: "item.dark_oak_fence",
			serialization_name: "minecraft:dark_oak_fence",
		},
		{
			command_name: "minecraft:dark_oak_fence_gate",
			name: "minecraft:dark_oak_fence_gate",
			raw_id: 186,
			serialization_id: "item.dark_oak_fence_gate",
			serialization_name: "minecraft:dark_oak_fence_gate",
		},
		{
			command_name: "minecraft:dark_oak_hanging_sign",
			name: "minecraft:dark_oak_hanging_sign",
			raw_id: -505,
			serialization_id: "item.dark_oak_hanging_sign",
			serialization_name: "minecraft:dark_oak_hanging_sign",
		},
		{
			command_name: "minecraft:dark_oak_leaves",
			name: "minecraft:dark_oak_leaves",
			raw_id: -803,
			serialization_id: "item.dark_oak_leaves",
			serialization_name: "minecraft:dark_oak_leaves",
		},
		{
			command_name: "minecraft:dark_oak_log",
			name: "minecraft:dark_oak_log",
			raw_id: -572,
			serialization_id: "item.dark_oak_log",
			serialization_name: "minecraft:dark_oak_log",
		},
		{
			command_name: "minecraft:dark_oak_planks",
			name: "minecraft:dark_oak_planks",
			raw_id: -743,
			serialization_id: "item.dark_oak_planks",
			serialization_name: "minecraft:dark_oak_planks",
		},
		{
			command_name: "minecraft:dark_oak_pressure_plate",
			name: "minecraft:dark_oak_pressure_plate",
			raw_id: -152,
			serialization_id: "item.dark_oak_pressure_plate",
			serialization_name: "minecraft:dark_oak_pressure_plate",
		},
		{
			command_name: "minecraft:dark_oak_sapling",
			name: "minecraft:dark_oak_sapling",
			raw_id: -829,
			serialization_id: "item.dark_oak_sapling",
			serialization_name: "minecraft:dark_oak_sapling",
		},
		{
			command_name: "minecraft:dark_oak_sign",
			name: "minecraft:dark_oak_sign",
			raw_id: 613,
			serialization_id: "item.darkoak_sign",
			serialization_name: "minecraft:dark_oak_sign",
		},
		{
			command_name: "minecraft:dark_oak_slab",
			name: "minecraft:dark_oak_slab",
			raw_id: -808,
			serialization_id: "item.dark_oak_slab",
			serialization_name: "minecraft:dark_oak_slab",
		},
		{
			command_name: "minecraft:dark_oak_stairs",
			name: "minecraft:dark_oak_stairs",
			raw_id: 164,
			serialization_id: "item.dark_oak_stairs",
			serialization_name: "minecraft:dark_oak_stairs",
		},
		{
			command_name: "minecraft:dark_oak_trapdoor",
			name: "minecraft:dark_oak_trapdoor",
			raw_id: -147,
			serialization_id: "item.dark_oak_trapdoor",
			serialization_name: "minecraft:dark_oak_trapdoor",
		},
		{
			command_name: "minecraft:dark_oak_wood",
			name: "minecraft:dark_oak_wood",
			raw_id: -818,
			serialization_id: "item.dark_oak_wood",
			serialization_name: "minecraft:dark_oak_wood",
		},
		{
			command_name: "minecraft:dark_prismarine",
			name: "minecraft:dark_prismarine",
			raw_id: -947,
			serialization_id: "item.dark_prismarine",
			serialization_name: "minecraft:dark_prismarine",
		},
		{
			command_name: "minecraft:dark_prismarine_slab",
			name: "minecraft:dark_prismarine_slab",
			raw_id: -886,
			serialization_id: "item.dark_prismarine_slab",
			serialization_name: "minecraft:dark_prismarine_slab",
		},
		{
			command_name: "minecraft:dark_prismarine_stairs",
			name: "minecraft:dark_prismarine_stairs",
			raw_id: -3,
			serialization_id: "item.dark_prismarine_stairs",
			serialization_name: "minecraft:dark_prismarine_stairs",
		},
		{
			command_name: "minecraft:daylight_detector",
			name: "minecraft:daylight_detector",
			raw_id: 151,
			serialization_id: "item.daylight_detector",
			serialization_name: "minecraft:daylight_detector",
		},
		{
			command_name: "minecraft:dead_brain_coral",
			name: "minecraft:dead_brain_coral",
			raw_id: -586,
			serialization_id: "item.dead_brain_coral",
			serialization_name: "minecraft:dead_brain_coral",
		},
		{
			command_name: "minecraft:dead_brain_coral_block",
			name: "minecraft:dead_brain_coral_block",
			raw_id: -854,
			serialization_id: "item.dead_brain_coral_block",
			serialization_name: "minecraft:dead_brain_coral_block",
		},
		{
			command_name: "minecraft:dead_brain_coral_fan",
			name: "minecraft:dead_brain_coral_fan",
			raw_id: -844,
			serialization_id: "item.dead_brain_coral_fan",
			serialization_name: "minecraft:dead_brain_coral_fan",
		},
		{
			command_name: "minecraft:dead_bubble_coral",
			name: "minecraft:dead_bubble_coral",
			raw_id: -587,
			serialization_id: "item.dead_bubble_coral",
			serialization_name: "minecraft:dead_bubble_coral",
		},
		{
			command_name: "minecraft:dead_bubble_coral_block",
			name: "minecraft:dead_bubble_coral_block",
			raw_id: -855,
			serialization_id: "item.dead_bubble_coral_block",
			serialization_name: "minecraft:dead_bubble_coral_block",
		},
		{
			command_name: "minecraft:dead_bubble_coral_fan",
			name: "minecraft:dead_bubble_coral_fan",
			raw_id: -845,
			serialization_id: "item.dead_bubble_coral_fan",
			serialization_name: "minecraft:dead_bubble_coral_fan",
		},
		{
			command_name: "minecraft:dead_fire_coral",
			name: "minecraft:dead_fire_coral",
			raw_id: -588,
			serialization_id: "item.dead_fire_coral",
			serialization_name: "minecraft:dead_fire_coral",
		},
		{
			command_name: "minecraft:dead_fire_coral_block",
			name: "minecraft:dead_fire_coral_block",
			raw_id: -856,
			serialization_id: "item.dead_fire_coral_block",
			serialization_name: "minecraft:dead_fire_coral_block",
		},
		{
			command_name: "minecraft:dead_fire_coral_fan",
			name: "minecraft:dead_fire_coral_fan",
			raw_id: -846,
			serialization_id: "item.dead_fire_coral_fan",
			serialization_name: "minecraft:dead_fire_coral_fan",
		},
		{
			command_name: "minecraft:dead_horn_coral",
			name: "minecraft:dead_horn_coral",
			raw_id: -589,
			serialization_id: "item.dead_horn_coral",
			serialization_name: "minecraft:dead_horn_coral",
		},
		{
			command_name: "minecraft:dead_horn_coral_block",
			name: "minecraft:dead_horn_coral_block",
			raw_id: -857,
			serialization_id: "item.dead_horn_coral_block",
			serialization_name: "minecraft:dead_horn_coral_block",
		},
		{
			command_name: "minecraft:dead_horn_coral_fan",
			name: "minecraft:dead_horn_coral_fan",
			raw_id: -847,
			serialization_id: "item.dead_horn_coral_fan",
			serialization_name: "minecraft:dead_horn_coral_fan",
		},
		{
			command_name: "minecraft:dead_tube_coral",
			name: "minecraft:dead_tube_coral",
			raw_id: -585,
			serialization_id: "item.dead_tube_coral",
			serialization_name: "minecraft:dead_tube_coral",
		},
		{
			command_name: "minecraft:dead_tube_coral_block",
			name: "minecraft:dead_tube_coral_block",
			raw_id: -853,
			serialization_id: "item.dead_tube_coral_block",
			serialization_name: "minecraft:dead_tube_coral_block",
		},
		{
			command_name: "minecraft:dead_tube_coral_fan",
			name: "minecraft:dead_tube_coral_fan",
			raw_id: -134,
			serialization_id: "item.dead_tube_coral_fan",
			serialization_name: "minecraft:dead_tube_coral_fan",
		},
		{
			command_name: "minecraft:deadbush",
			name: "minecraft:deadbush",
			raw_id: 32,
			serialization_id: "item.deadbush",
			serialization_name: "minecraft:deadbush",
		},
		{
			command_name: "minecraft:decorated_pot",
			name: "minecraft:decorated_pot",
			raw_id: -551,
			serialization_id: "item.decorated_pot",
			serialization_name: "minecraft:decorated_pot",
		},
		{
			command_name: "minecraft:deepslate",
			name: "minecraft:deepslate",
			raw_id: -378,
			serialization_id: "item.deepslate",
			serialization_name: "minecraft:deepslate",
		},
		{
			command_name: "minecraft:deepslate_brick_slab",
			name: "minecraft:deepslate_brick_slab",
			raw_id: -392,
			serialization_id: "item.deepslate_brick_slab",
			serialization_name: "minecraft:deepslate_brick_slab",
		},
		{
			command_name: "minecraft:deepslate_brick_stairs",
			name: "minecraft:deepslate_brick_stairs",
			raw_id: -393,
			serialization_id: "item.deepslate_brick_stairs",
			serialization_name: "minecraft:deepslate_brick_stairs",
		},
		{
			command_name: "minecraft:deepslate_brick_wall",
			name: "minecraft:deepslate_brick_wall",
			raw_id: -394,
			serialization_id: "item.deepslate_brick_wall",
			serialization_name: "minecraft:deepslate_brick_wall",
		},
		{
			command_name: "minecraft:deepslate_bricks",
			name: "minecraft:deepslate_bricks",
			raw_id: -391,
			serialization_id: "item.deepslate_bricks",
			serialization_name: "minecraft:deepslate_bricks",
		},
		{
			command_name: "minecraft:deepslate_coal_ore",
			name: "minecraft:deepslate_coal_ore",
			raw_id: -406,
			serialization_id: "item.deepslate_coal_ore",
			serialization_name: "minecraft:deepslate_coal_ore",
		},
		{
			command_name: "minecraft:deepslate_copper_ore",
			name: "minecraft:deepslate_copper_ore",
			raw_id: -408,
			serialization_id: "item.deepslate_copper_ore",
			serialization_name: "minecraft:deepslate_copper_ore",
		},
		{
			command_name: "minecraft:deepslate_diamond_ore",
			name: "minecraft:deepslate_diamond_ore",
			raw_id: -405,
			serialization_id: "item.deepslate_diamond_ore",
			serialization_name: "minecraft:deepslate_diamond_ore",
		},
		{
			command_name: "minecraft:deepslate_emerald_ore",
			name: "minecraft:deepslate_emerald_ore",
			raw_id: -407,
			serialization_id: "item.deepslate_emerald_ore",
			serialization_name: "minecraft:deepslate_emerald_ore",
		},
		{
			command_name: "minecraft:deepslate_gold_ore",
			name: "minecraft:deepslate_gold_ore",
			raw_id: -402,
			serialization_id: "item.deepslate_gold_ore",
			serialization_name: "minecraft:deepslate_gold_ore",
		},
		{
			command_name: "minecraft:deepslate_iron_ore",
			name: "minecraft:deepslate_iron_ore",
			raw_id: -401,
			serialization_id: "item.deepslate_iron_ore",
			serialization_name: "minecraft:deepslate_iron_ore",
		},
		{
			command_name: "minecraft:deepslate_lapis_ore",
			name: "minecraft:deepslate_lapis_ore",
			raw_id: -400,
			serialization_id: "item.deepslate_lapis_ore",
			serialization_name: "minecraft:deepslate_lapis_ore",
		},
		{
			command_name: "minecraft:deepslate_redstone_ore",
			name: "minecraft:deepslate_redstone_ore",
			raw_id: -403,
			serialization_id: "item.deepslate_redstone_ore",
			serialization_name: "minecraft:deepslate_redstone_ore",
		},
		{
			command_name: "minecraft:deepslate_tile_slab",
			name: "minecraft:deepslate_tile_slab",
			raw_id: -388,
			serialization_id: "item.deepslate_tile_slab",
			serialization_name: "minecraft:deepslate_tile_slab",
		},
		{
			command_name: "minecraft:deepslate_tile_stairs",
			name: "minecraft:deepslate_tile_stairs",
			raw_id: -389,
			serialization_id: "item.deepslate_tile_stairs",
			serialization_name: "minecraft:deepslate_tile_stairs",
		},
		{
			command_name: "minecraft:deepslate_tile_wall",
			name: "minecraft:deepslate_tile_wall",
			raw_id: -390,
			serialization_id: "item.deepslate_tile_wall",
			serialization_name: "minecraft:deepslate_tile_wall",
		},
		{
			command_name: "minecraft:deepslate_tiles",
			name: "minecraft:deepslate_tiles",
			raw_id: -387,
			serialization_id: "item.deepslate_tiles",
			serialization_name: "minecraft:deepslate_tiles",
		},
		{
			command_name: "minecraft:deny",
			name: "minecraft:deny",
			raw_id: 211,
			serialization_id: "item.deny",
			serialization_name: "minecraft:deny",
		},
		{
			command_name: "minecraft:detector_rail",
			name: "minecraft:detector_rail",
			raw_id: 28,
			serialization_id: "item.detector_rail",
			serialization_name: "minecraft:detector_rail",
		},
		{
			command_name: "minecraft:diamond",
			name: "minecraft:diamond",
			raw_id: 328,
			serialization_id: "item.diamond",
			serialization_name: "minecraft:diamond",
		},
		{
			command_name: "minecraft:diamond_axe",
			name: "minecraft:diamond_axe",
			raw_id: 343,
			serialization_id: "item.diamond_axe",
			serialization_name: "minecraft:diamond_axe",
		},
		{
			command_name: "minecraft:diamond_block",
			name: "minecraft:diamond_block",
			raw_id: 57,
			serialization_id: "item.diamond_block",
			serialization_name: "minecraft:diamond_block",
		},
		{
			command_name: "minecraft:diamond_boots",
			name: "minecraft:diamond_boots",
			raw_id: 375,
			serialization_id: "item.diamond_boots",
			serialization_name: "minecraft:diamond_boots",
		},
		{
			command_name: "minecraft:diamond_chestplate",
			name: "minecraft:diamond_chestplate",
			raw_id: 373,
			serialization_id: "item.diamond_chestplate",
			serialization_name: "minecraft:diamond_chestplate",
		},
		{
			command_name: "minecraft:diamond_helmet",
			name: "minecraft:diamond_helmet",
			raw_id: 372,
			serialization_id: "item.diamond_helmet",
			serialization_name: "minecraft:diamond_helmet",
		},
		{
			command_name: "minecraft:diamond_hoe",
			name: "minecraft:diamond_hoe",
			raw_id: 357,
			serialization_id: "item.diamond_hoe",
			serialization_name: "minecraft:diamond_hoe",
		},
		{
			command_name: "minecraft:diamond_horse_armor",
			name: "minecraft:diamond_horse_armor",
			raw_id: 566,
			serialization_id: "item.horsearmordiamond",
			serialization_name: "minecraft:diamond_horse_armor",
		},
		{
			command_name: "minecraft:diamond_leggings",
			name: "minecraft:diamond_leggings",
			raw_id: 374,
			serialization_id: "item.diamond_leggings",
			serialization_name: "minecraft:diamond_leggings",
		},
		{
			command_name: "minecraft:diamond_ore",
			name: "minecraft:diamond_ore",
			raw_id: 56,
			serialization_id: "item.diamond_ore",
			serialization_name: "minecraft:diamond_ore",
		},
		{
			command_name: "minecraft:diamond_pickaxe",
			name: "minecraft:diamond_pickaxe",
			raw_id: 342,
			serialization_id: "item.diamond_pickaxe",
			serialization_name: "minecraft:diamond_pickaxe",
		},
		{
			command_name: "minecraft:diamond_shovel",
			name: "minecraft:diamond_shovel",
			raw_id: 341,
			serialization_id: "item.diamond_shovel",
			serialization_name: "minecraft:diamond_shovel",
		},
		{
			command_name: "minecraft:diamond_sword",
			name: "minecraft:diamond_sword",
			raw_id: 340,
			serialization_id: "item.diamond_sword",
			serialization_name: "minecraft:diamond_sword",
		},
		{
			command_name: "minecraft:diorite",
			name: "minecraft:diorite",
			raw_id: -592,
			serialization_id: "item.diorite",
			serialization_name: "minecraft:diorite",
		},
		{
			command_name: "minecraft:diorite_slab",
			name: "minecraft:diorite_slab",
			raw_id: -894,
			serialization_id: "item.diorite_slab",
			serialization_name: "minecraft:diorite_slab",
		},
		{
			command_name: "minecraft:diorite_stairs",
			name: "minecraft:diorite_stairs",
			raw_id: -170,
			serialization_id: "item.diorite_stairs",
			serialization_name: "minecraft:diorite_stairs",
		},
		{
			command_name: "minecraft:diorite_wall",
			name: "minecraft:diorite_wall",
			raw_id: -973,
			serialization_id: "item.diorite_wall",
			serialization_name: "minecraft:diorite_wall",
		},
		{
			command_name: "minecraft:dirt",
			name: "minecraft:dirt",
			raw_id: 3,
			serialization_id: "item.dirt",
			serialization_name: "minecraft:dirt",
		},
		{
			command_name: "minecraft:dirt_with_roots",
			name: "minecraft:dirt_with_roots",
			raw_id: -318,
			serialization_id: "item.dirt_with_roots",
			serialization_name: "minecraft:dirt_with_roots",
		},
		{
			command_name: "minecraft:disc_fragment_5",
			name: "minecraft:disc_fragment_5",
			raw_id: 673,
			serialization_id: "item.disc_fragment_5",
			serialization_name: "minecraft:disc_fragment_5",
		},
		{
			command_name: "minecraft:dispenser",
			name: "minecraft:dispenser",
			raw_id: 23,
			serialization_id: "item.dispenser",
			serialization_name: "minecraft:dispenser",
		},
		{
			command_name: "minecraft:dolphin_spawn_egg",
			name: "minecraft:dolphin_spawn_egg",
			raw_id: 512,
			serialization_id: "item.dolphin_spawn_egg",
			serialization_name: "minecraft:dolphin_spawn_egg",
		},
		{
			command_name: "minecraft:donkey_spawn_egg",
			name: "minecraft:donkey_spawn_egg",
			raw_id: 493,
			serialization_id: "item.donkey_spawn_egg",
			serialization_name: "minecraft:donkey_spawn_egg",
		},
		{
			command_name: "minecraft:dragon_breath",
			name: "minecraft:dragon_breath",
			raw_id: 593,
			serialization_id: "item.dragon_breath",
			serialization_name: "minecraft:dragon_breath",
		},
		{
			command_name: "minecraft:dragon_egg",
			name: "minecraft:dragon_egg",
			raw_id: 122,
			serialization_id: "item.dragon_egg",
			serialization_name: "minecraft:dragon_egg",
		},
		{
			command_name: "minecraft:dragon_head",
			name: "minecraft:dragon_head",
			raw_id: -969,
			serialization_id: "item.dragon_head",
			serialization_name: "minecraft:dragon_head",
		},
		{
			command_name: "minecraft:dried_kelp",
			name: "minecraft:dried_kelp",
			raw_id: 292,
			serialization_id: "item.dried_kelp",
			serialization_name: "minecraft:dried_kelp",
		},
		{
			command_name: "minecraft:dried_kelp_block",
			name: "minecraft:dried_kelp_block",
			raw_id: -139,
			serialization_id: "item.dried_kelp_block",
			serialization_name: "minecraft:dried_kelp_block",
		},
		{
			command_name: "minecraft:dripstone_block",
			name: "minecraft:dripstone_block",
			raw_id: -317,
			serialization_id: "item.dripstone_block",
			serialization_name: "minecraft:dripstone_block",
		},
		{
			command_name: "minecraft:dropper",
			name: "minecraft:dropper",
			raw_id: 125,
			serialization_id: "item.dropper",
			serialization_name: "minecraft:dropper",
		},
		{
			command_name: "minecraft:drowned_spawn_egg",
			name: "minecraft:drowned_spawn_egg",
			raw_id: 511,
			serialization_id: "item.drowned_spawn_egg",
			serialization_name: "minecraft:drowned_spawn_egg",
		},
		{
			command_name: "minecraft:dune_armor_trim_smithing_template",
			name: "minecraft:dune_armor_trim_smithing_template",
			raw_id: 718,
			serialization_id: "item.dune_armor_trim_smithing_template",
			serialization_name: "minecraft:dune_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:echo_shard",
			name: "minecraft:echo_shard",
			raw_id: 683,
			serialization_id: "item.echo_shard",
			serialization_name: "minecraft:echo_shard",
		},
		{
			command_name: "minecraft:egg",
			name: "minecraft:egg",
			raw_id: 416,
			serialization_id: "item.egg",
			serialization_name: "minecraft:egg",
		},
		{
			command_name: "minecraft:elder_guardian_spawn_egg",
			name: "minecraft:elder_guardian_spawn_egg",
			raw_id: 499,
			serialization_id: "item.elder_guardian_spawn_egg",
			serialization_name: "minecraft:elder_guardian_spawn_egg",
		},
		{
			command_name: "minecraft:elytra",
			name: "minecraft:elytra",
			raw_id: 597,
			serialization_id: "item.elytra",
			serialization_name: "minecraft:elytra",
		},
		{
			command_name: "minecraft:emerald",
			name: "minecraft:emerald",
			raw_id: 546,
			serialization_id: "item.emerald",
			serialization_name: "minecraft:emerald",
		},
		{
			command_name: "minecraft:emerald_block",
			name: "minecraft:emerald_block",
			raw_id: 133,
			serialization_id: "item.emerald_block",
			serialization_name: "minecraft:emerald_block",
		},
		{
			command_name: "minecraft:emerald_ore",
			name: "minecraft:emerald_ore",
			raw_id: 129,
			serialization_id: "item.emerald_ore",
			serialization_name: "minecraft:emerald_ore",
		},
		{
			command_name: "minecraft:empty_map",
			name: "minecraft:empty_map",
			raw_id: 549,
			serialization_id: "item.emptymap",
			serialization_name: "minecraft:empty_map",
		},
		{
			command_name: "minecraft:enchanted_book",
			name: "minecraft:enchanted_book",
			raw_id: 554,
			serialization_id: "item.enchanted_book",
			serialization_name: "minecraft:enchanted_book",
		},
		{
			command_name: "minecraft:enchanted_golden_apple",
			name: "minecraft:enchanted_golden_apple",
			raw_id: 281,
			serialization_id: "item.appleEnchanted",
			serialization_name: "minecraft:enchanted_golden_apple",
		},
		{
			command_name: "minecraft:enchanting_table",
			name: "minecraft:enchanting_table",
			raw_id: 116,
			serialization_id: "item.enchanting_table",
			serialization_name: "minecraft:enchanting_table",
		},
		{
			command_name: "minecraft:end_brick_stairs",
			name: "minecraft:end_brick_stairs",
			raw_id: -178,
			serialization_id: "item.end_brick_stairs",
			serialization_name: "minecraft:end_brick_stairs",
		},
		{
			command_name: "minecraft:end_bricks",
			name: "minecraft:end_bricks",
			raw_id: 206,
			serialization_id: "item.end_bricks",
			serialization_name: "minecraft:end_bricks",
		},
		{
			command_name: "minecraft:end_crystal",
			name: "minecraft:end_crystal",
			raw_id: 789,
			serialization_id: "item.end_crystal",
			serialization_name: "minecraft:end_crystal",
		},
		{
			command_name: "minecraft:end_portal_frame",
			name: "minecraft:end_portal_frame",
			raw_id: 120,
			serialization_id: "item.end_portal_frame",
			serialization_name: "minecraft:end_portal_frame",
		},
		{
			command_name: "minecraft:end_rod",
			name: "minecraft:end_rod",
			raw_id: 208,
			serialization_id: "item.end_rod",
			serialization_name: "minecraft:end_rod",
		},
		{
			command_name: "minecraft:end_stone",
			name: "minecraft:end_stone",
			raw_id: 121,
			serialization_id: "item.end_stone",
			serialization_name: "minecraft:end_stone",
		},
		{
			command_name: "minecraft:end_stone_brick_slab",
			name: "minecraft:end_stone_brick_slab",
			raw_id: -162,
			serialization_id: "item.end_stone_brick_slab",
			serialization_name: "minecraft:end_stone_brick_slab",
		},
		{
			command_name: "minecraft:end_stone_brick_wall",
			name: "minecraft:end_stone_brick_wall",
			raw_id: -980,
			serialization_id: "item.end_stone_brick_wall",
			serialization_name: "minecraft:end_stone_brick_wall",
		},
		{
			command_name: "minecraft:ender_chest",
			name: "minecraft:ender_chest",
			raw_id: 130,
			serialization_id: "item.ender_chest",
			serialization_name: "minecraft:ender_chest",
		},
		{
			command_name: "minecraft:ender_dragon_spawn_egg",
			name: "minecraft:ender_dragon_spawn_egg",
			raw_id: 535,
			serialization_id: "item.ender_dragon_spawn_egg",
			serialization_name: "minecraft:ender_dragon_spawn_egg",
		},
		{
			command_name: "minecraft:ender_eye",
			name: "minecraft:ender_eye",
			raw_id: 460,
			serialization_id: "item.ender_eye",
			serialization_name: "minecraft:ender_eye",
		},
		{
			command_name: "minecraft:ender_pearl",
			name: "minecraft:ender_pearl",
			raw_id: 448,
			serialization_id: "item.ender_pearl",
			serialization_name: "minecraft:ender_pearl",
		},
		{
			command_name: "minecraft:enderman_spawn_egg",
			name: "minecraft:enderman_spawn_egg",
			raw_id: 469,
			serialization_id: "item.enderman_spawn_egg",
			serialization_name: "minecraft:enderman_spawn_egg",
		},
		{
			command_name: "minecraft:endermite_spawn_egg",
			name: "minecraft:endermite_spawn_egg",
			raw_id: 487,
			serialization_id: "item.endermite_spawn_egg",
			serialization_name: "minecraft:endermite_spawn_egg",
		},
		{
			command_name: "minecraft:evoker_spawn_egg",
			name: "minecraft:evoker_spawn_egg",
			raw_id: 503,
			serialization_id: "item.evoker_spawn_egg",
			serialization_name: "minecraft:evoker_spawn_egg",
		},
		{
			command_name: "minecraft:experience_bottle",
			name: "minecraft:experience_bottle",
			raw_id: 542,
			serialization_id: "item.experience_bottle",
			serialization_name: "minecraft:experience_bottle",
		},
		{
			command_name: "minecraft:explorer_pottery_sherd",
			name: "minecraft:explorer_pottery_sherd",
			raw_id: 699,
			serialization_id: "item.explorer_pottery_sherd",
			serialization_name: "minecraft:explorer_pottery_sherd",
		},
		{
			command_name: "minecraft:exposed_chiseled_copper",
			name: "minecraft:exposed_chiseled_copper",
			raw_id: -761,
			serialization_id: "item.exposed_chiseled_copper",
			serialization_name: "minecraft:exposed_chiseled_copper",
		},
		{
			command_name: "minecraft:exposed_copper",
			name: "minecraft:exposed_copper",
			raw_id: -341,
			serialization_id: "item.exposed_copper",
			serialization_name: "minecraft:exposed_copper",
		},
		{
			command_name: "minecraft:exposed_copper_bulb",
			name: "minecraft:exposed_copper_bulb",
			raw_id: -777,
			serialization_id: "item.exposed_copper_bulb",
			serialization_name: "minecraft:exposed_copper_bulb",
		},
		{
			command_name: "minecraft:exposed_copper_door",
			name: "minecraft:exposed_copper_door",
			raw_id: -785,
			serialization_id: "item.exposed_copper_door",
			serialization_name: "minecraft:exposed_copper_door",
		},
		{
			command_name: "minecraft:exposed_copper_grate",
			name: "minecraft:exposed_copper_grate",
			raw_id: -769,
			serialization_id: "item.exposed_copper_grate",
			serialization_name: "minecraft:exposed_copper_grate",
		},
		{
			command_name: "minecraft:exposed_copper_trapdoor",
			name: "minecraft:exposed_copper_trapdoor",
			raw_id: -793,
			serialization_id: "item.exposed_copper_trapdoor",
			serialization_name: "minecraft:exposed_copper_trapdoor",
		},
		{
			command_name: "minecraft:exposed_cut_copper",
			name: "minecraft:exposed_cut_copper",
			raw_id: -348,
			serialization_id: "item.exposed_cut_copper",
			serialization_name: "minecraft:exposed_cut_copper",
		},
		{
			command_name: "minecraft:exposed_cut_copper_slab",
			name: "minecraft:exposed_cut_copper_slab",
			raw_id: -362,
			serialization_id: "item.exposed_cut_copper_slab",
			serialization_name: "minecraft:exposed_cut_copper_slab",
		},
		{
			command_name: "minecraft:exposed_cut_copper_stairs",
			name: "minecraft:exposed_cut_copper_stairs",
			raw_id: -355,
			serialization_id: "item.exposed_cut_copper_stairs",
			serialization_name: "minecraft:exposed_cut_copper_stairs",
		},
		{
			command_name: "minecraft:eye_armor_trim_smithing_template",
			name: "minecraft:eye_armor_trim_smithing_template",
			raw_id: 722,
			serialization_id: "item.eye_armor_trim_smithing_template",
			serialization_name: "minecraft:eye_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:farmland",
			name: "minecraft:farmland",
			raw_id: 60,
			serialization_id: "item.farmland",
			serialization_name: "minecraft:farmland",
		},
		{
			command_name: "minecraft:feather",
			name: "minecraft:feather",
			raw_id: 352,
			serialization_id: "item.feather",
			serialization_name: "minecraft:feather",
		},
		{
			command_name: "minecraft:fence_gate",
			name: "minecraft:fence_gate",
			raw_id: 107,
			serialization_id: "item.fence_gate",
			serialization_name: "minecraft:fence_gate",
		},
		{
			command_name: "minecraft:fermented_spider_eye",
			name: "minecraft:fermented_spider_eye",
			raw_id: 455,
			serialization_id: "item.fermented_spider_eye",
			serialization_name: "minecraft:fermented_spider_eye",
		},
		{
			command_name: "minecraft:fern",
			name: "minecraft:fern",
			raw_id: -848,
			serialization_id: "item.fern",
			serialization_name: "minecraft:fern",
		},
		{
			command_name: "minecraft:field_masoned_banner_pattern",
			name: "minecraft:field_masoned_banner_pattern",
			raw_id: 618,
			serialization_id: "item.field_masoned_banner_pattern",
			serialization_name: "minecraft:field_masoned_banner_pattern",
		},
		{
			command_name: "minecraft:filled_map",
			name: "minecraft:filled_map",
			raw_id: 446,
			serialization_id: "item.map",
			serialization_name: "minecraft:filled_map",
		},
		{
			command_name: "minecraft:fire_charge",
			name: "minecraft:fire_charge",
			raw_id: 543,
			serialization_id: "item.fireball",
			serialization_name: "minecraft:fire_charge",
		},
		{
			command_name: "minecraft:fire_coral",
			name: "minecraft:fire_coral",
			raw_id: -583,
			serialization_id: "item.fire_coral",
			serialization_name: "minecraft:fire_coral",
		},
		{
			command_name: "minecraft:fire_coral_block",
			name: "minecraft:fire_coral_block",
			raw_id: -851,
			serialization_id: "item.fire_coral_block",
			serialization_name: "minecraft:fire_coral_block",
		},
		{
			command_name: "minecraft:fire_coral_fan",
			name: "minecraft:fire_coral_fan",
			raw_id: -842,
			serialization_id: "item.fire_coral_fan",
			serialization_name: "minecraft:fire_coral_fan",
		},
		{
			command_name: "minecraft:firework_rocket",
			name: "minecraft:firework_rocket",
			raw_id: 552,
			serialization_id: "item.fireworks",
			serialization_name: "minecraft:firework_rocket",
		},
		{
			command_name: "minecraft:firework_star",
			name: "minecraft:firework_star",
			raw_id: 553,
			serialization_id: "item.fireworksCharge",
			serialization_name: "minecraft:firework_star",
		},
		{
			command_name: "minecraft:fishing_rod",
			name: "minecraft:fishing_rod",
			raw_id: 418,
			serialization_id: "item.fishing_rod",
			serialization_name: "minecraft:fishing_rod",
		},
		{
			command_name: "minecraft:fletching_table",
			name: "minecraft:fletching_table",
			raw_id: -201,
			serialization_id: "item.fletching_table",
			serialization_name: "minecraft:fletching_table",
		},
		{
			command_name: "minecraft:flint",
			name: "minecraft:flint",
			raw_id: 381,
			serialization_id: "item.flint",
			serialization_name: "minecraft:flint",
		},
		{
			command_name: "minecraft:flint_and_steel",
			name: "minecraft:flint_and_steel",
			raw_id: 323,
			serialization_id: "item.flint_and_steel",
			serialization_name: "minecraft:flint_and_steel",
		},
		{
			command_name: "minecraft:flow_armor_trim_smithing_template",
			name: "minecraft:flow_armor_trim_smithing_template",
			raw_id: 733,
			serialization_id: "item.flow_armor_trim_smithing_template",
			serialization_name: "minecraft:flow_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:flow_banner_pattern",
			name: "minecraft:flow_banner_pattern",
			raw_id: 622,
			serialization_id: "item.flow_banner_pattern",
			serialization_name: "minecraft:flow_banner_pattern",
		},
		{
			command_name: "minecraft:flow_pottery_sherd",
			name: "minecraft:flow_pottery_sherd",
			raw_id: 700,
			serialization_id: "item.flow_pottery_sherd",
			serialization_name: "minecraft:flow_pottery_sherd",
		},
		{
			command_name: "minecraft:flower_banner_pattern",
			name: "minecraft:flower_banner_pattern",
			raw_id: 614,
			serialization_id: "item.flower_banner_pattern",
			serialization_name: "minecraft:flower_banner_pattern",
		},
		{
			command_name: "minecraft:flower_pot",
			name: "minecraft:flower_pot",
			raw_id: 548,
			serialization_id: "item.flower_pot",
			serialization_name: "minecraft:flower_pot",
		},
		{
			command_name: "minecraft:flowering_azalea",
			name: "minecraft:flowering_azalea",
			raw_id: -338,
			serialization_id: "item.flowering_azalea",
			serialization_name: "minecraft:flowering_azalea",
		},
		{
			command_name: "minecraft:fox_spawn_egg",
			name: "minecraft:fox_spawn_egg",
			raw_id: 518,
			serialization_id: "item.fox_spawn_egg",
			serialization_name: "minecraft:fox_spawn_egg",
		},
		{
			command_name: "minecraft:frame",
			name: "minecraft:frame",
			raw_id: 547,
			serialization_id: "item.frame",
			serialization_name: "minecraft:frame",
		},
		{
			command_name: "minecraft:friend_pottery_sherd",
			name: "minecraft:friend_pottery_sherd",
			raw_id: 701,
			serialization_id: "item.friend_pottery_sherd",
			serialization_name: "minecraft:friend_pottery_sherd",
		},
		{
			command_name: "minecraft:frog_spawn",
			name: "minecraft:frog_spawn",
			raw_id: -468,
			serialization_id: "item.frog_spawn",
			serialization_name: "minecraft:frog_spawn",
		},
		{
			command_name: "minecraft:frog_spawn_egg",
			name: "minecraft:frog_spawn_egg",
			raw_id: 664,
			serialization_id: "item.frog_spawn_egg",
			serialization_name: "minecraft:frog_spawn_egg",
		},
		{
			command_name: "minecraft:frosted_ice",
			name: "minecraft:frosted_ice",
			raw_id: 207,
			serialization_id: "item.frosted_ice",
			serialization_name: "minecraft:frosted_ice",
		},
		{
			command_name: "minecraft:furnace",
			name: "minecraft:furnace",
			raw_id: 61,
			serialization_id: "item.furnace",
			serialization_name: "minecraft:furnace",
		},
		{
			command_name: "minecraft:ghast_spawn_egg",
			name: "minecraft:ghast_spawn_egg",
			raw_id: 481,
			serialization_id: "item.ghast_spawn_egg",
			serialization_name: "minecraft:ghast_spawn_egg",
		},
		{
			command_name: "minecraft:ghast_tear",
			name: "minecraft:ghast_tear",
			raw_id: 451,
			serialization_id: "item.ghast_tear",
			serialization_name: "minecraft:ghast_tear",
		},
		{
			command_name: "minecraft:gilded_blackstone",
			name: "minecraft:gilded_blackstone",
			raw_id: -281,
			serialization_id: "item.gilded_blackstone",
			serialization_name: "minecraft:gilded_blackstone",
		},
		{
			command_name: "minecraft:glass",
			name: "minecraft:glass",
			raw_id: 20,
			serialization_id: "item.glass",
			serialization_name: "minecraft:glass",
		},
		{
			command_name: "minecraft:glass_bottle",
			name: "minecraft:glass_bottle",
			raw_id: 454,
			serialization_id: "item.glass_bottle",
			serialization_name: "minecraft:glass_bottle",
		},
		{
			command_name: "minecraft:glass_pane",
			name: "minecraft:glass_pane",
			raw_id: 102,
			serialization_id: "item.glass_pane",
			serialization_name: "minecraft:glass_pane",
		},
		{
			command_name: "minecraft:glistering_melon_slice",
			name: "minecraft:glistering_melon_slice",
			raw_id: 461,
			serialization_id: "item.speckled_melon",
			serialization_name: "minecraft:glistering_melon_slice",
		},
		{
			command_name: "minecraft:globe_banner_pattern",
			name: "minecraft:globe_banner_pattern",
			raw_id: 621,
			serialization_id: "item.globe_banner_pattern",
			serialization_name: "minecraft:globe_banner_pattern",
		},
		{
			command_name: "minecraft:glow_berries",
			name: "minecraft:glow_berries",
			raw_id: 790,
			serialization_id: "item.glow_berries",
			serialization_name: "minecraft:glow_berries",
		},
		{
			command_name: "minecraft:glow_frame",
			name: "minecraft:glow_frame",
			raw_id: 659,
			serialization_id: "item.glow_frame",
			serialization_name: "minecraft:glow_frame",
		},
		{
			command_name: "minecraft:glow_ink_sac",
			name: "minecraft:glow_ink_sac",
			raw_id: 537,
			serialization_id: "item.glow_ink_sac",
			serialization_name: "minecraft:glow_ink_sac",
		},
		{
			command_name: "minecraft:glow_lichen",
			name: "minecraft:glow_lichen",
			raw_id: -411,
			serialization_id: "item.glow_lichen",
			serialization_name: "minecraft:glow_lichen",
		},
		{
			command_name: "minecraft:glow_squid_spawn_egg",
			name: "minecraft:glow_squid_spawn_egg",
			raw_id: 532,
			serialization_id: "item.glow_squid_spawn_egg",
			serialization_name: "minecraft:glow_squid_spawn_egg",
		},
		{
			command_name: "minecraft:glowstone",
			name: "minecraft:glowstone",
			raw_id: 89,
			serialization_id: "item.glowstone",
			serialization_name: "minecraft:glowstone",
		},
		{
			command_name: "minecraft:glowstone_dust",
			name: "minecraft:glowstone_dust",
			raw_id: 420,
			serialization_id: "item.glowstone_dust",
			serialization_name: "minecraft:glowstone_dust",
		},
		{
			command_name: "minecraft:goat_horn",
			name: "minecraft:goat_horn",
			raw_id: 663,
			serialization_id: "item.goat_horn",
			serialization_name: "minecraft:goat_horn",
		},
		{
			command_name: "minecraft:goat_spawn_egg",
			name: "minecraft:goat_spawn_egg",
			raw_id: 531,
			serialization_id: "item.goat_spawn_egg",
			serialization_name: "minecraft:goat_spawn_egg",
		},
		{
			command_name: "minecraft:gold_block",
			name: "minecraft:gold_block",
			raw_id: 41,
			serialization_id: "item.gold_block",
			serialization_name: "minecraft:gold_block",
		},
		{
			command_name: "minecraft:gold_ingot",
			name: "minecraft:gold_ingot",
			raw_id: 330,
			serialization_id: "item.gold_ingot",
			serialization_name: "minecraft:gold_ingot",
		},
		{
			command_name: "minecraft:gold_nugget",
			name: "minecraft:gold_nugget",
			raw_id: 452,
			serialization_id: "item.gold_nugget",
			serialization_name: "minecraft:gold_nugget",
		},
		{
			command_name: "minecraft:gold_ore",
			name: "minecraft:gold_ore",
			raw_id: 14,
			serialization_id: "item.gold_ore",
			serialization_name: "minecraft:gold_ore",
		},
		{
			command_name: "minecraft:golden_apple",
			name: "minecraft:golden_apple",
			raw_id: 280,
			serialization_id: "item.golden_apple",
			serialization_name: "minecraft:golden_apple",
		},
		{
			command_name: "minecraft:golden_axe",
			name: "minecraft:golden_axe",
			raw_id: 350,
			serialization_id: "item.golden_axe",
			serialization_name: "minecraft:golden_axe",
		},
		{
			command_name: "minecraft:golden_boots",
			name: "minecraft:golden_boots",
			raw_id: 379,
			serialization_id: "item.golden_boots",
			serialization_name: "minecraft:golden_boots",
		},
		{
			command_name: "minecraft:golden_carrot",
			name: "minecraft:golden_carrot",
			raw_id: 305,
			serialization_id: "item.golden_carrot",
			serialization_name: "minecraft:golden_carrot",
		},
		{
			command_name: "minecraft:golden_chestplate",
			name: "minecraft:golden_chestplate",
			raw_id: 377,
			serialization_id: "item.golden_chestplate",
			serialization_name: "minecraft:golden_chestplate",
		},
		{
			command_name: "minecraft:golden_helmet",
			name: "minecraft:golden_helmet",
			raw_id: 376,
			serialization_id: "item.golden_helmet",
			serialization_name: "minecraft:golden_helmet",
		},
		{
			command_name: "minecraft:golden_hoe",
			name: "minecraft:golden_hoe",
			raw_id: 358,
			serialization_id: "item.golden_hoe",
			serialization_name: "minecraft:golden_hoe",
		},
		{
			command_name: "minecraft:golden_horse_armor",
			name: "minecraft:golden_horse_armor",
			raw_id: 565,
			serialization_id: "item.horsearmorgold",
			serialization_name: "minecraft:golden_horse_armor",
		},
		{
			command_name: "minecraft:golden_leggings",
			name: "minecraft:golden_leggings",
			raw_id: 378,
			serialization_id: "item.golden_leggings",
			serialization_name: "minecraft:golden_leggings",
		},
		{
			command_name: "minecraft:golden_pickaxe",
			name: "minecraft:golden_pickaxe",
			raw_id: 349,
			serialization_id: "item.golden_pickaxe",
			serialization_name: "minecraft:golden_pickaxe",
		},
		{
			command_name: "minecraft:golden_rail",
			name: "minecraft:golden_rail",
			raw_id: 27,
			serialization_id: "item.golden_rail",
			serialization_name: "minecraft:golden_rail",
		},
		{
			command_name: "minecraft:golden_shovel",
			name: "minecraft:golden_shovel",
			raw_id: 348,
			serialization_id: "item.golden_shovel",
			serialization_name: "minecraft:golden_shovel",
		},
		{
			command_name: "minecraft:golden_sword",
			name: "minecraft:golden_sword",
			raw_id: 347,
			serialization_id: "item.golden_sword",
			serialization_name: "minecraft:golden_sword",
		},
		{
			command_name: "minecraft:granite",
			name: "minecraft:granite",
			raw_id: -590,
			serialization_id: "item.granite",
			serialization_name: "minecraft:granite",
		},
		{
			command_name: "minecraft:granite_slab",
			name: "minecraft:granite_slab",
			raw_id: -896,
			serialization_id: "item.granite_slab",
			serialization_name: "minecraft:granite_slab",
		},
		{
			command_name: "minecraft:granite_stairs",
			name: "minecraft:granite_stairs",
			raw_id: -169,
			serialization_id: "item.granite_stairs",
			serialization_name: "minecraft:granite_stairs",
		},
		{
			command_name: "minecraft:granite_wall",
			name: "minecraft:granite_wall",
			raw_id: -972,
			serialization_id: "item.granite_wall",
			serialization_name: "minecraft:granite_wall",
		},
		{
			command_name: "minecraft:grass_block",
			name: "minecraft:grass_block",
			raw_id: 2,
			serialization_id: "item.grass_block",
			serialization_name: "minecraft:grass_block",
		},
		{
			command_name: "minecraft:grass_path",
			name: "minecraft:grass_path",
			raw_id: 198,
			serialization_id: "item.grass_path",
			serialization_name: "minecraft:grass_path",
		},
		{
			command_name: "minecraft:gravel",
			name: "minecraft:gravel",
			raw_id: 13,
			serialization_id: "item.gravel",
			serialization_name: "minecraft:gravel",
		},
		{
			command_name: "minecraft:gray_bundle",
			name: "minecraft:gray_bundle",
			raw_id: 262,
			serialization_id: "item.gray_bundle",
			serialization_name: "minecraft:gray_bundle",
		},
		{
			command_name: "minecraft:gray_candle",
			name: "minecraft:gray_candle",
			raw_id: -420,
			serialization_id: "item.gray_candle",
			serialization_name: "minecraft:gray_candle",
		},
		{
			command_name: "minecraft:gray_carpet",
			name: "minecraft:gray_carpet",
			raw_id: -603,
			serialization_id: "item.gray_carpet",
			serialization_name: "minecraft:gray_carpet",
		},
		{
			command_name: "minecraft:gray_concrete",
			name: "minecraft:gray_concrete",
			raw_id: -634,
			serialization_id: "item.gray_concrete",
			serialization_name: "minecraft:gray_concrete",
		},
		{
			command_name: "minecraft:gray_concrete_powder",
			name: "minecraft:gray_concrete_powder",
			raw_id: -715,
			serialization_id: "item.gray_concrete_powder",
			serialization_name: "minecraft:gray_concrete_powder",
		},
		{
			command_name: "minecraft:gray_dye",
			name: "minecraft:gray_dye",
			raw_id: 429,
			serialization_id: "item.gray_dye",
			serialization_name: "minecraft:gray_dye",
		},
		{
			command_name: "minecraft:gray_glazed_terracotta",
			name: "minecraft:gray_glazed_terracotta",
			raw_id: 227,
			serialization_id: "item.gray_glazed_terracotta",
			serialization_name: "minecraft:gray_glazed_terracotta",
		},
		{
			command_name: "minecraft:gray_shulker_box",
			name: "minecraft:gray_shulker_box",
			raw_id: -619,
			serialization_id: "item.gray_shulker_box",
			serialization_name: "minecraft:gray_shulker_box",
		},
		{
			command_name: "minecraft:gray_stained_glass",
			name: "minecraft:gray_stained_glass",
			raw_id: -679,
			serialization_id: "item.gray_stained_glass",
			serialization_name: "minecraft:gray_stained_glass",
		},
		{
			command_name: "minecraft:gray_stained_glass_pane",
			name: "minecraft:gray_stained_glass_pane",
			raw_id: -649,
			serialization_id: "item.gray_stained_glass_pane",
			serialization_name: "minecraft:gray_stained_glass_pane",
		},
		{
			command_name: "minecraft:gray_terracotta",
			name: "minecraft:gray_terracotta",
			raw_id: -730,
			serialization_id: "item.gray_terracotta",
			serialization_name: "minecraft:gray_terracotta",
		},
		{
			command_name: "minecraft:gray_wool",
			name: "minecraft:gray_wool",
			raw_id: -553,
			serialization_id: "item.gray_wool",
			serialization_name: "minecraft:gray_wool",
		},
		{
			command_name: "minecraft:green_bundle",
			name: "minecraft:green_bundle",
			raw_id: 263,
			serialization_id: "item.green_bundle",
			serialization_name: "minecraft:green_bundle",
		},
		{
			command_name: "minecraft:green_candle",
			name: "minecraft:green_candle",
			raw_id: -426,
			serialization_id: "item.green_candle",
			serialization_name: "minecraft:green_candle",
		},
		{
			command_name: "minecraft:green_carpet",
			name: "minecraft:green_carpet",
			raw_id: -609,
			serialization_id: "item.green_carpet",
			serialization_name: "minecraft:green_carpet",
		},
		{
			command_name: "minecraft:green_concrete",
			name: "minecraft:green_concrete",
			raw_id: -640,
			serialization_id: "item.green_concrete",
			serialization_name: "minecraft:green_concrete",
		},
		{
			command_name: "minecraft:green_concrete_powder",
			name: "minecraft:green_concrete_powder",
			raw_id: -721,
			serialization_id: "item.green_concrete_powder",
			serialization_name: "minecraft:green_concrete_powder",
		},
		{
			command_name: "minecraft:green_dye",
			name: "minecraft:green_dye",
			raw_id: 423,
			serialization_id: "item.green_dye",
			serialization_name: "minecraft:green_dye",
		},
		{
			command_name: "minecraft:green_glazed_terracotta",
			name: "minecraft:green_glazed_terracotta",
			raw_id: 233,
			serialization_id: "item.green_glazed_terracotta",
			serialization_name: "minecraft:green_glazed_terracotta",
		},
		{
			command_name: "minecraft:green_shulker_box",
			name: "minecraft:green_shulker_box",
			raw_id: -625,
			serialization_id: "item.green_shulker_box",
			serialization_name: "minecraft:green_shulker_box",
		},
		{
			command_name: "minecraft:green_stained_glass",
			name: "minecraft:green_stained_glass",
			raw_id: -685,
			serialization_id: "item.green_stained_glass",
			serialization_name: "minecraft:green_stained_glass",
		},
		{
			command_name: "minecraft:green_stained_glass_pane",
			name: "minecraft:green_stained_glass_pane",
			raw_id: -655,
			serialization_id: "item.green_stained_glass_pane",
			serialization_name: "minecraft:green_stained_glass_pane",
		},
		{
			command_name: "minecraft:green_terracotta",
			name: "minecraft:green_terracotta",
			raw_id: -736,
			serialization_id: "item.green_terracotta",
			serialization_name: "minecraft:green_terracotta",
		},
		{
			command_name: "minecraft:green_wool",
			name: "minecraft:green_wool",
			raw_id: -560,
			serialization_id: "item.green_wool",
			serialization_name: "minecraft:green_wool",
		},
		{
			command_name: "minecraft:grindstone",
			name: "minecraft:grindstone",
			raw_id: -195,
			serialization_id: "item.grindstone",
			serialization_name: "minecraft:grindstone",
		},
		{
			command_name: "minecraft:guardian_spawn_egg",
			name: "minecraft:guardian_spawn_egg",
			raw_id: 488,
			serialization_id: "item.guardian_spawn_egg",
			serialization_name: "minecraft:guardian_spawn_egg",
		},
		{
			command_name: "minecraft:gunpowder",
			name: "minecraft:gunpowder",
			raw_id: 353,
			serialization_id: "item.gunpowder",
			serialization_name: "minecraft:gunpowder",
		},
		{
			command_name: "minecraft:guster_banner_pattern",
			name: "minecraft:guster_banner_pattern",
			raw_id: 623,
			serialization_id: "item.guster_banner_pattern",
			serialization_name: "minecraft:guster_banner_pattern",
		},
		{
			command_name: "minecraft:guster_pottery_sherd",
			name: "minecraft:guster_pottery_sherd",
			raw_id: 702,
			serialization_id: "item.guster_pottery_sherd",
			serialization_name: "minecraft:guster_pottery_sherd",
		},
		{
			command_name: "minecraft:hanging_roots",
			name: "minecraft:hanging_roots",
			raw_id: -319,
			serialization_id: "item.hanging_roots",
			serialization_name: "minecraft:hanging_roots",
		},
		{
			command_name: "minecraft:hardened_clay",
			name: "minecraft:hardened_clay",
			raw_id: 172,
			serialization_id: "item.hardened_clay",
			serialization_name: "minecraft:hardened_clay",
		},
		{
			command_name: "minecraft:hay_block",
			name: "minecraft:hay_block",
			raw_id: 170,
			serialization_id: "item.hay_block",
			serialization_name: "minecraft:hay_block",
		},
		{
			command_name: "minecraft:heart_of_the_sea",
			name: "minecraft:heart_of_the_sea",
			raw_id: 604,
			serialization_id: "item.heart_of_the_sea",
			serialization_name: "minecraft:heart_of_the_sea",
		},
		{
			command_name: "minecraft:heart_pottery_sherd",
			name: "minecraft:heart_pottery_sherd",
			raw_id: 703,
			serialization_id: "item.heart_pottery_sherd",
			serialization_name: "minecraft:heart_pottery_sherd",
		},
		{
			command_name: "minecraft:heartbreak_pottery_sherd",
			name: "minecraft:heartbreak_pottery_sherd",
			raw_id: 704,
			serialization_id: "item.heartbreak_pottery_sherd",
			serialization_name: "minecraft:heartbreak_pottery_sherd",
		},
		{
			command_name: "minecraft:heavy_core",
			name: "minecraft:heavy_core",
			raw_id: -316,
			serialization_id: "item.heavy_core",
			serialization_name: "minecraft:heavy_core",
		},
		{
			command_name: "minecraft:heavy_weighted_pressure_plate",
			name: "minecraft:heavy_weighted_pressure_plate",
			raw_id: 148,
			serialization_id: "item.heavy_weighted_pressure_plate",
			serialization_name: "minecraft:heavy_weighted_pressure_plate",
		},
		{
			command_name: "minecraft:hoglin_spawn_egg",
			name: "minecraft:hoglin_spawn_egg",
			raw_id: 524,
			serialization_id: "item.hoglin_spawn_egg",
			serialization_name: "minecraft:hoglin_spawn_egg",
		},
		{
			command_name: "minecraft:honey_block",
			name: "minecraft:honey_block",
			raw_id: -220,
			serialization_id: "item.honey_block",
			serialization_name: "minecraft:honey_block",
		},
		{
			command_name: "minecraft:honey_bottle",
			name: "minecraft:honey_bottle",
			raw_id: 627,
			serialization_id: "item.honey_bottle",
			serialization_name: "minecraft:honey_bottle",
		},
		{
			command_name: "minecraft:honeycomb",
			name: "minecraft:honeycomb",
			raw_id: 626,
			serialization_id: "item.honeycomb",
			serialization_name: "minecraft:honeycomb",
		},
		{
			command_name: "minecraft:honeycomb_block",
			name: "minecraft:honeycomb_block",
			raw_id: -221,
			serialization_id: "item.honeycomb_block",
			serialization_name: "minecraft:honeycomb_block",
		},
		{
			command_name: "minecraft:hopper",
			name: "minecraft:hopper",
			raw_id: 560,
			serialization_id: "tile.hopper",
			serialization_name: "minecraft:hopper",
		},
		{
			command_name: "minecraft:hopper_minecart",
			name: "minecraft:hopper_minecart",
			raw_id: 559,
			serialization_id: "item.hopper_minecart",
			serialization_name: "minecraft:hopper_minecart",
		},
		{
			command_name: "minecraft:horn_coral",
			name: "minecraft:horn_coral",
			raw_id: -584,
			serialization_id: "item.horn_coral",
			serialization_name: "minecraft:horn_coral",
		},
		{
			command_name: "minecraft:horn_coral_block",
			name: "minecraft:horn_coral_block",
			raw_id: -852,
			serialization_id: "item.horn_coral_block",
			serialization_name: "minecraft:horn_coral_block",
		},
		{
			command_name: "minecraft:horn_coral_fan",
			name: "minecraft:horn_coral_fan",
			raw_id: -843,
			serialization_id: "item.horn_coral_fan",
			serialization_name: "minecraft:horn_coral_fan",
		},
		{
			command_name: "minecraft:horse_spawn_egg",
			name: "minecraft:horse_spawn_egg",
			raw_id: 485,
			serialization_id: "item.horse_spawn_egg",
			serialization_name: "minecraft:horse_spawn_egg",
		},
		{
			command_name: "minecraft:host_armor_trim_smithing_template",
			name: "minecraft:host_armor_trim_smithing_template",
			raw_id: 732,
			serialization_id: "item.host_armor_trim_smithing_template",
			serialization_name: "minecraft:host_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:howl_pottery_sherd",
			name: "minecraft:howl_pottery_sherd",
			raw_id: 705,
			serialization_id: "item.howl_pottery_sherd",
			serialization_name: "minecraft:howl_pottery_sherd",
		},
		{
			command_name: "minecraft:husk_spawn_egg",
			name: "minecraft:husk_spawn_egg",
			raw_id: 491,
			serialization_id: "item.husk_spawn_egg",
			serialization_name: "minecraft:husk_spawn_egg",
		},
		{
			command_name: "minecraft:ice",
			name: "minecraft:ice",
			raw_id: 79,
			serialization_id: "item.ice",
			serialization_name: "minecraft:ice",
		},
		{
			command_name: "minecraft:infested_chiseled_stone_bricks",
			name: "minecraft:infested_chiseled_stone_bricks",
			raw_id: -862,
			serialization_id: "item.infested_chiseled_stone_bricks",
			serialization_name: "minecraft:infested_chiseled_stone_bricks",
		},
		{
			command_name: "minecraft:infested_cobblestone",
			name: "minecraft:infested_cobblestone",
			raw_id: -858,
			serialization_id: "item.infested_cobblestone",
			serialization_name: "minecraft:infested_cobblestone",
		},
		{
			command_name: "minecraft:infested_cracked_stone_bricks",
			name: "minecraft:infested_cracked_stone_bricks",
			raw_id: -861,
			serialization_id: "item.infested_cracked_stone_bricks",
			serialization_name: "minecraft:infested_cracked_stone_bricks",
		},
		{
			command_name: "minecraft:infested_deepslate",
			name: "minecraft:infested_deepslate",
			raw_id: -454,
			serialization_id: "item.infested_deepslate",
			serialization_name: "minecraft:infested_deepslate",
		},
		{
			command_name: "minecraft:infested_mossy_stone_bricks",
			name: "minecraft:infested_mossy_stone_bricks",
			raw_id: -860,
			serialization_id: "item.infested_mossy_stone_bricks",
			serialization_name: "minecraft:infested_mossy_stone_bricks",
		},
		{
			command_name: "minecraft:infested_stone",
			name: "minecraft:infested_stone",
			raw_id: 97,
			serialization_id: "item.infested_stone",
			serialization_name: "minecraft:infested_stone",
		},
		{
			command_name: "minecraft:infested_stone_bricks",
			name: "minecraft:infested_stone_bricks",
			raw_id: -859,
			serialization_id: "item.infested_stone_bricks",
			serialization_name: "minecraft:infested_stone_bricks",
		},
		{
			command_name: "minecraft:ink_sac",
			name: "minecraft:ink_sac",
			raw_id: 439,
			serialization_id: "item.ink_sac",
			serialization_name: "minecraft:ink_sac",
		},
		{
			command_name: "minecraft:iron_axe",
			name: "minecraft:iron_axe",
			raw_id: 322,
			serialization_id: "item.iron_axe",
			serialization_name: "minecraft:iron_axe",
		},
		{
			command_name: "minecraft:iron_bars",
			name: "minecraft:iron_bars",
			raw_id: 101,
			serialization_id: "item.iron_bars",
			serialization_name: "minecraft:iron_bars",
		},
		{
			command_name: "minecraft:iron_block",
			name: "minecraft:iron_block",
			raw_id: 42,
			serialization_id: "item.iron_block",
			serialization_name: "minecraft:iron_block",
		},
		{
			command_name: "minecraft:iron_boots",
			name: "minecraft:iron_boots",
			raw_id: 371,
			serialization_id: "item.iron_boots",
			serialization_name: "minecraft:iron_boots",
		},
		{
			command_name: "minecraft:iron_chestplate",
			name: "minecraft:iron_chestplate",
			raw_id: 369,
			serialization_id: "item.iron_chestplate",
			serialization_name: "minecraft:iron_chestplate",
		},
		{
			command_name: "minecraft:iron_door",
			name: "minecraft:iron_door",
			raw_id: 397,
			serialization_id: "item.iron_door",
			serialization_name: "minecraft:iron_door",
		},
		{
			command_name: "minecraft:iron_golem_spawn_egg",
			name: "minecraft:iron_golem_spawn_egg",
			raw_id: 533,
			serialization_id: "item.iron_golem_spawn_egg",
			serialization_name: "minecraft:iron_golem_spawn_egg",
		},
		{
			command_name: "minecraft:iron_helmet",
			name: "minecraft:iron_helmet",
			raw_id: 368,
			serialization_id: "item.iron_helmet",
			serialization_name: "minecraft:iron_helmet",
		},
		{
			command_name: "minecraft:iron_hoe",
			name: "minecraft:iron_hoe",
			raw_id: 356,
			serialization_id: "item.iron_hoe",
			serialization_name: "minecraft:iron_hoe",
		},
		{
			command_name: "minecraft:iron_horse_armor",
			name: "minecraft:iron_horse_armor",
			raw_id: 564,
			serialization_id: "item.horsearmoriron",
			serialization_name: "minecraft:iron_horse_armor",
		},
		{
			command_name: "minecraft:iron_ingot",
			name: "minecraft:iron_ingot",
			raw_id: 329,
			serialization_id: "item.iron_ingot",
			serialization_name: "minecraft:iron_ingot",
		},
		{
			command_name: "minecraft:iron_leggings",
			name: "minecraft:iron_leggings",
			raw_id: 370,
			serialization_id: "item.iron_leggings",
			serialization_name: "minecraft:iron_leggings",
		},
		{
			command_name: "minecraft:iron_nugget",
			name: "minecraft:iron_nugget",
			raw_id: 602,
			serialization_id: "item.iron_nugget",
			serialization_name: "minecraft:iron_nugget",
		},
		{
			command_name: "minecraft:iron_ore",
			name: "minecraft:iron_ore",
			raw_id: 15,
			serialization_id: "item.iron_ore",
			serialization_name: "minecraft:iron_ore",
		},
		{
			command_name: "minecraft:iron_pickaxe",
			name: "minecraft:iron_pickaxe",
			raw_id: 321,
			serialization_id: "item.iron_pickaxe",
			serialization_name: "minecraft:iron_pickaxe",
		},
		{
			command_name: "minecraft:iron_shovel",
			name: "minecraft:iron_shovel",
			raw_id: 320,
			serialization_id: "item.iron_shovel",
			serialization_name: "minecraft:iron_shovel",
		},
		{
			command_name: "minecraft:iron_sword",
			name: "minecraft:iron_sword",
			raw_id: 331,
			serialization_id: "item.iron_sword",
			serialization_name: "minecraft:iron_sword",
		},
		{
			command_name: "minecraft:iron_trapdoor",
			name: "minecraft:iron_trapdoor",
			raw_id: 167,
			serialization_id: "item.iron_trapdoor",
			serialization_name: "minecraft:iron_trapdoor",
		},
		{
			command_name: "minecraft:jigsaw",
			name: "minecraft:jigsaw",
			raw_id: -211,
			serialization_id: "item.jigsaw",
			serialization_name: "minecraft:jigsaw",
		},
		{
			command_name: "minecraft:jukebox",
			name: "minecraft:jukebox",
			raw_id: 84,
			serialization_id: "item.jukebox",
			serialization_name: "minecraft:jukebox",
		},
		{
			command_name: "minecraft:jungle_boat",
			name: "minecraft:jungle_boat",
			raw_id: 403,
			serialization_id: "item.jungle_boat",
			serialization_name: "minecraft:jungle_boat",
		},
		{
			command_name: "minecraft:jungle_button",
			name: "minecraft:jungle_button",
			raw_id: -143,
			serialization_id: "item.jungle_button",
			serialization_name: "minecraft:jungle_button",
		},
		{
			command_name: "minecraft:jungle_chest_boat",
			name: "minecraft:jungle_chest_boat",
			raw_id: 676,
			serialization_id: "item.jungle_chest_boat",
			serialization_name: "minecraft:jungle_chest_boat",
		},
		{
			command_name: "minecraft:jungle_door",
			name: "minecraft:jungle_door",
			raw_id: 588,
			serialization_id: "item.jungle_door",
			serialization_name: "minecraft:jungle_door",
		},
		{
			command_name: "minecraft:jungle_fence",
			name: "minecraft:jungle_fence",
			raw_id: -578,
			serialization_id: "item.jungle_fence",
			serialization_name: "minecraft:jungle_fence",
		},
		{
			command_name: "minecraft:jungle_fence_gate",
			name: "minecraft:jungle_fence_gate",
			raw_id: 185,
			serialization_id: "item.jungle_fence_gate",
			serialization_name: "minecraft:jungle_fence_gate",
		},
		{
			command_name: "minecraft:jungle_hanging_sign",
			name: "minecraft:jungle_hanging_sign",
			raw_id: -503,
			serialization_id: "item.jungle_hanging_sign",
			serialization_name: "minecraft:jungle_hanging_sign",
		},
		{
			command_name: "minecraft:jungle_leaves",
			name: "minecraft:jungle_leaves",
			raw_id: -802,
			serialization_id: "item.jungle_leaves",
			serialization_name: "minecraft:jungle_leaves",
		},
		{
			command_name: "minecraft:jungle_log",
			name: "minecraft:jungle_log",
			raw_id: -571,
			serialization_id: "item.jungle_log",
			serialization_name: "minecraft:jungle_log",
		},
		{
			command_name: "minecraft:jungle_planks",
			name: "minecraft:jungle_planks",
			raw_id: -741,
			serialization_id: "item.jungle_planks",
			serialization_name: "minecraft:jungle_planks",
		},
		{
			command_name: "minecraft:jungle_pressure_plate",
			name: "minecraft:jungle_pressure_plate",
			raw_id: -153,
			serialization_id: "item.jungle_pressure_plate",
			serialization_name: "minecraft:jungle_pressure_plate",
		},
		{
			command_name: "minecraft:jungle_sapling",
			name: "minecraft:jungle_sapling",
			raw_id: -827,
			serialization_id: "item.jungle_sapling",
			serialization_name: "minecraft:jungle_sapling",
		},
		{
			command_name: "minecraft:jungle_sign",
			name: "minecraft:jungle_sign",
			raw_id: 611,
			serialization_id: "item.jungle_sign",
			serialization_name: "minecraft:jungle_sign",
		},
		{
			command_name: "minecraft:jungle_slab",
			name: "minecraft:jungle_slab",
			raw_id: -806,
			serialization_id: "item.jungle_slab",
			serialization_name: "minecraft:jungle_slab",
		},
		{
			command_name: "minecraft:jungle_stairs",
			name: "minecraft:jungle_stairs",
			raw_id: 136,
			serialization_id: "item.jungle_stairs",
			serialization_name: "minecraft:jungle_stairs",
		},
		{
			command_name: "minecraft:jungle_trapdoor",
			name: "minecraft:jungle_trapdoor",
			raw_id: -148,
			serialization_id: "item.jungle_trapdoor",
			serialization_name: "minecraft:jungle_trapdoor",
		},
		{
			command_name: "minecraft:jungle_wood",
			name: "minecraft:jungle_wood",
			raw_id: -816,
			serialization_id: "item.jungle_wood",
			serialization_name: "minecraft:jungle_wood",
		},
		{
			command_name: "minecraft:kelp",
			name: "minecraft:kelp",
			raw_id: 408,
			serialization_id: "item.kelp",
			serialization_name: "minecraft:kelp",
		},
		{
			command_name: "minecraft:ladder",
			name: "minecraft:ladder",
			raw_id: 65,
			serialization_id: "item.ladder",
			serialization_name: "minecraft:ladder",
		},
		{
			command_name: "minecraft:lantern",
			name: "minecraft:lantern",
			raw_id: -208,
			serialization_id: "item.lantern",
			serialization_name: "minecraft:lantern",
		},
		{
			command_name: "minecraft:lapis_block",
			name: "minecraft:lapis_block",
			raw_id: 22,
			serialization_id: "item.lapis_block",
			serialization_name: "minecraft:lapis_block",
		},
		{
			command_name: "minecraft:lapis_lazuli",
			name: "minecraft:lapis_lazuli",
			raw_id: 440,
			serialization_id: "item.lapis_lazuli",
			serialization_name: "minecraft:lapis_lazuli",
		},
		{
			command_name: "minecraft:lapis_ore",
			name: "minecraft:lapis_ore",
			raw_id: 21,
			serialization_id: "item.lapis_ore",
			serialization_name: "minecraft:lapis_ore",
		},
		{
			command_name: "minecraft:large_amethyst_bud",
			name: "minecraft:large_amethyst_bud",
			raw_id: -330,
			serialization_id: "item.large_amethyst_bud",
			serialization_name: "minecraft:large_amethyst_bud",
		},
		{
			command_name: "minecraft:large_fern",
			name: "minecraft:large_fern",
			raw_id: -865,
			serialization_id: "item.large_fern",
			serialization_name: "minecraft:large_fern",
		},
		{
			command_name: "minecraft:lava_bucket",
			name: "minecraft:lava_bucket",
			raw_id: 388,
			serialization_id: "item.lava_bucket",
			serialization_name: "minecraft:lava_bucket",
		},
		{
			command_name: "minecraft:lead",
			name: "minecraft:lead",
			raw_id: 580,
			serialization_id: "item.lead",
			serialization_name: "minecraft:lead",
		},
		{
			command_name: "minecraft:leather",
			name: "minecraft:leather",
			raw_id: 407,
			serialization_id: "item.leather",
			serialization_name: "minecraft:leather",
		},
		{
			command_name: "minecraft:leather_boots",
			name: "minecraft:leather_boots",
			raw_id: 363,
			serialization_id: "item.leather_boots",
			serialization_name: "minecraft:leather_boots",
		},
		{
			command_name: "minecraft:leather_chestplate",
			name: "minecraft:leather_chestplate",
			raw_id: 361,
			serialization_id: "item.leather_chestplate",
			serialization_name: "minecraft:leather_chestplate",
		},
		{
			command_name: "minecraft:leather_helmet",
			name: "minecraft:leather_helmet",
			raw_id: 360,
			serialization_id: "item.leather_helmet",
			serialization_name: "minecraft:leather_helmet",
		},
		{
			command_name: "minecraft:leather_horse_armor",
			name: "minecraft:leather_horse_armor",
			raw_id: 563,
			serialization_id: "item.horsearmorleather",
			serialization_name: "minecraft:leather_horse_armor",
		},
		{
			command_name: "minecraft:leather_leggings",
			name: "minecraft:leather_leggings",
			raw_id: 362,
			serialization_id: "item.leather_leggings",
			serialization_name: "minecraft:leather_leggings",
		},
		{
			command_name: "minecraft:lectern",
			name: "minecraft:lectern",
			raw_id: -194,
			serialization_id: "item.lectern",
			serialization_name: "minecraft:lectern",
		},
		{
			command_name: "minecraft:lever",
			name: "minecraft:lever",
			raw_id: 69,
			serialization_id: "item.lever",
			serialization_name: "minecraft:lever",
		},
		{
			command_name: "minecraft:light_block_0",
			name: "minecraft:light_block_0",
			raw_id: -215,
			serialization_id: "item.light_block_0",
			serialization_name: "minecraft:light_block_0",
		},
		{
			command_name: "minecraft:light_block_1",
			name: "minecraft:light_block_1",
			raw_id: -929,
			serialization_id: "item.light_block_1",
			serialization_name: "minecraft:light_block_1",
		},
		{
			command_name: "minecraft:light_block_10",
			name: "minecraft:light_block_10",
			raw_id: -938,
			serialization_id: "item.light_block_10",
			serialization_name: "minecraft:light_block_10",
		},
		{
			command_name: "minecraft:light_block_11",
			name: "minecraft:light_block_11",
			raw_id: -939,
			serialization_id: "item.light_block_11",
			serialization_name: "minecraft:light_block_11",
		},
		{
			command_name: "minecraft:light_block_12",
			name: "minecraft:light_block_12",
			raw_id: -940,
			serialization_id: "item.light_block_12",
			serialization_name: "minecraft:light_block_12",
		},
		{
			command_name: "minecraft:light_block_13",
			name: "minecraft:light_block_13",
			raw_id: -941,
			serialization_id: "item.light_block_13",
			serialization_name: "minecraft:light_block_13",
		},
		{
			command_name: "minecraft:light_block_14",
			name: "minecraft:light_block_14",
			raw_id: -942,
			serialization_id: "item.light_block_14",
			serialization_name: "minecraft:light_block_14",
		},
		{
			command_name: "minecraft:light_block_15",
			name: "minecraft:light_block_15",
			raw_id: -943,
			serialization_id: "item.light_block_15",
			serialization_name: "minecraft:light_block_15",
		},
		{
			command_name: "minecraft:light_block_2",
			name: "minecraft:light_block_2",
			raw_id: -930,
			serialization_id: "item.light_block_2",
			serialization_name: "minecraft:light_block_2",
		},
		{
			command_name: "minecraft:light_block_3",
			name: "minecraft:light_block_3",
			raw_id: -931,
			serialization_id: "item.light_block_3",
			serialization_name: "minecraft:light_block_3",
		},
		{
			command_name: "minecraft:light_block_4",
			name: "minecraft:light_block_4",
			raw_id: -932,
			serialization_id: "item.light_block_4",
			serialization_name: "minecraft:light_block_4",
		},
		{
			command_name: "minecraft:light_block_5",
			name: "minecraft:light_block_5",
			raw_id: -933,
			serialization_id: "item.light_block_5",
			serialization_name: "minecraft:light_block_5",
		},
		{
			command_name: "minecraft:light_block_6",
			name: "minecraft:light_block_6",
			raw_id: -934,
			serialization_id: "item.light_block_6",
			serialization_name: "minecraft:light_block_6",
		},
		{
			command_name: "minecraft:light_block_7",
			name: "minecraft:light_block_7",
			raw_id: -935,
			serialization_id: "item.light_block_7",
			serialization_name: "minecraft:light_block_7",
		},
		{
			command_name: "minecraft:light_block_8",
			name: "minecraft:light_block_8",
			raw_id: -936,
			serialization_id: "item.light_block_8",
			serialization_name: "minecraft:light_block_8",
		},
		{
			command_name: "minecraft:light_block_9",
			name: "minecraft:light_block_9",
			raw_id: -937,
			serialization_id: "item.light_block_9",
			serialization_name: "minecraft:light_block_9",
		},
		{
			command_name: "minecraft:light_blue_bundle",
			name: "minecraft:light_blue_bundle",
			raw_id: 264,
			serialization_id: "item.light_blue_bundle",
			serialization_name: "minecraft:light_blue_bundle",
		},
		{
			command_name: "minecraft:light_blue_candle",
			name: "minecraft:light_blue_candle",
			raw_id: -416,
			serialization_id: "item.light_blue_candle",
			serialization_name: "minecraft:light_blue_candle",
		},
		{
			command_name: "minecraft:light_blue_carpet",
			name: "minecraft:light_blue_carpet",
			raw_id: -599,
			serialization_id: "item.light_blue_carpet",
			serialization_name: "minecraft:light_blue_carpet",
		},
		{
			command_name: "minecraft:light_blue_concrete",
			name: "minecraft:light_blue_concrete",
			raw_id: -630,
			serialization_id: "item.light_blue_concrete",
			serialization_name: "minecraft:light_blue_concrete",
		},
		{
			command_name: "minecraft:light_blue_concrete_powder",
			name: "minecraft:light_blue_concrete_powder",
			raw_id: -711,
			serialization_id: "item.light_blue_concrete_powder",
			serialization_name: "minecraft:light_blue_concrete_powder",
		},
		{
			command_name: "minecraft:light_blue_dye",
			name: "minecraft:light_blue_dye",
			raw_id: 433,
			serialization_id: "item.light_blue_dye",
			serialization_name: "minecraft:light_blue_dye",
		},
		{
			command_name: "minecraft:light_blue_glazed_terracotta",
			name: "minecraft:light_blue_glazed_terracotta",
			raw_id: 223,
			serialization_id: "item.light_blue_glazed_terracotta",
			serialization_name: "minecraft:light_blue_glazed_terracotta",
		},
		{
			command_name: "minecraft:light_blue_shulker_box",
			name: "minecraft:light_blue_shulker_box",
			raw_id: -615,
			serialization_id: "item.light_blue_shulker_box",
			serialization_name: "minecraft:light_blue_shulker_box",
		},
		{
			command_name: "minecraft:light_blue_stained_glass",
			name: "minecraft:light_blue_stained_glass",
			raw_id: -675,
			serialization_id: "item.light_blue_stained_glass",
			serialization_name: "minecraft:light_blue_stained_glass",
		},
		{
			command_name: "minecraft:light_blue_stained_glass_pane",
			name: "minecraft:light_blue_stained_glass_pane",
			raw_id: -645,
			serialization_id: "item.light_blue_stained_glass_pane",
			serialization_name: "minecraft:light_blue_stained_glass_pane",
		},
		{
			command_name: "minecraft:light_blue_terracotta",
			name: "minecraft:light_blue_terracotta",
			raw_id: -726,
			serialization_id: "item.light_blue_terracotta",
			serialization_name: "minecraft:light_blue_terracotta",
		},
		{
			command_name: "minecraft:light_blue_wool",
			name: "minecraft:light_blue_wool",
			raw_id: -562,
			serialization_id: "item.light_blue_wool",
			serialization_name: "minecraft:light_blue_wool",
		},
		{
			command_name: "minecraft:light_gray_bundle",
			name: "minecraft:light_gray_bundle",
			raw_id: 265,
			serialization_id: "item.light_gray_bundle",
			serialization_name: "minecraft:light_gray_bundle",
		},
		{
			command_name: "minecraft:light_gray_candle",
			name: "minecraft:light_gray_candle",
			raw_id: -421,
			serialization_id: "item.light_gray_candle",
			serialization_name: "minecraft:light_gray_candle",
		},
		{
			command_name: "minecraft:light_gray_carpet",
			name: "minecraft:light_gray_carpet",
			raw_id: -604,
			serialization_id: "item.light_gray_carpet",
			serialization_name: "minecraft:light_gray_carpet",
		},
		{
			command_name: "minecraft:light_gray_concrete",
			name: "minecraft:light_gray_concrete",
			raw_id: -635,
			serialization_id: "item.light_gray_concrete",
			serialization_name: "minecraft:light_gray_concrete",
		},
		{
			command_name: "minecraft:light_gray_concrete_powder",
			name: "minecraft:light_gray_concrete_powder",
			raw_id: -716,
			serialization_id: "item.light_gray_concrete_powder",
			serialization_name: "minecraft:light_gray_concrete_powder",
		},
		{
			command_name: "minecraft:light_gray_dye",
			name: "minecraft:light_gray_dye",
			raw_id: 428,
			serialization_id: "item.light_gray_dye",
			serialization_name: "minecraft:light_gray_dye",
		},
		{
			command_name: "minecraft:light_gray_shulker_box",
			name: "minecraft:light_gray_shulker_box",
			raw_id: -620,
			serialization_id: "item.light_gray_shulker_box",
			serialization_name: "minecraft:light_gray_shulker_box",
		},
		{
			command_name: "minecraft:light_gray_stained_glass",
			name: "minecraft:light_gray_stained_glass",
			raw_id: -680,
			serialization_id: "item.light_gray_stained_glass",
			serialization_name: "minecraft:light_gray_stained_glass",
		},
		{
			command_name: "minecraft:light_gray_stained_glass_pane",
			name: "minecraft:light_gray_stained_glass_pane",
			raw_id: -650,
			serialization_id: "item.light_gray_stained_glass_pane",
			serialization_name: "minecraft:light_gray_stained_glass_pane",
		},
		{
			command_name: "minecraft:light_gray_terracotta",
			name: "minecraft:light_gray_terracotta",
			raw_id: -731,
			serialization_id: "item.light_gray_terracotta",
			serialization_name: "minecraft:light_gray_terracotta",
		},
		{
			command_name: "minecraft:light_gray_wool",
			name: "minecraft:light_gray_wool",
			raw_id: -552,
			serialization_id: "item.light_gray_wool",
			serialization_name: "minecraft:light_gray_wool",
		},
		{
			command_name: "minecraft:light_weighted_pressure_plate",
			name: "minecraft:light_weighted_pressure_plate",
			raw_id: 147,
			serialization_id: "item.light_weighted_pressure_plate",
			serialization_name: "minecraft:light_weighted_pressure_plate",
		},
		{
			command_name: "minecraft:lightning_rod",
			name: "minecraft:lightning_rod",
			raw_id: -312,
			serialization_id: "item.lightning_rod",
			serialization_name: "minecraft:lightning_rod",
		},
		{
			command_name: "minecraft:lilac",
			name: "minecraft:lilac",
			raw_id: -863,
			serialization_id: "item.lilac",
			serialization_name: "minecraft:lilac",
		},
		{
			command_name: "minecraft:lily_of_the_valley",
			name: "minecraft:lily_of_the_valley",
			raw_id: -839,
			serialization_id: "item.lily_of_the_valley",
			serialization_name: "minecraft:lily_of_the_valley",
		},
		{
			command_name: "minecraft:lime_bundle",
			name: "minecraft:lime_bundle",
			raw_id: 266,
			serialization_id: "item.lime_bundle",
			serialization_name: "minecraft:lime_bundle",
		},
		{
			command_name: "minecraft:lime_candle",
			name: "minecraft:lime_candle",
			raw_id: -418,
			serialization_id: "item.lime_candle",
			serialization_name: "minecraft:lime_candle",
		},
		{
			command_name: "minecraft:lime_carpet",
			name: "minecraft:lime_carpet",
			raw_id: -601,
			serialization_id: "item.lime_carpet",
			serialization_name: "minecraft:lime_carpet",
		},
		{
			command_name: "minecraft:lime_concrete",
			name: "minecraft:lime_concrete",
			raw_id: -632,
			serialization_id: "item.lime_concrete",
			serialization_name: "minecraft:lime_concrete",
		},
		{
			command_name: "minecraft:lime_concrete_powder",
			name: "minecraft:lime_concrete_powder",
			raw_id: -713,
			serialization_id: "item.lime_concrete_powder",
			serialization_name: "minecraft:lime_concrete_powder",
		},
		{
			command_name: "minecraft:lime_dye",
			name: "minecraft:lime_dye",
			raw_id: 431,
			serialization_id: "item.lime_dye",
			serialization_name: "minecraft:lime_dye",
		},
		{
			command_name: "minecraft:lime_glazed_terracotta",
			name: "minecraft:lime_glazed_terracotta",
			raw_id: 225,
			serialization_id: "item.lime_glazed_terracotta",
			serialization_name: "minecraft:lime_glazed_terracotta",
		},
		{
			command_name: "minecraft:lime_shulker_box",
			name: "minecraft:lime_shulker_box",
			raw_id: -617,
			serialization_id: "item.lime_shulker_box",
			serialization_name: "minecraft:lime_shulker_box",
		},
		{
			command_name: "minecraft:lime_stained_glass",
			name: "minecraft:lime_stained_glass",
			raw_id: -677,
			serialization_id: "item.lime_stained_glass",
			serialization_name: "minecraft:lime_stained_glass",
		},
		{
			command_name: "minecraft:lime_stained_glass_pane",
			name: "minecraft:lime_stained_glass_pane",
			raw_id: -647,
			serialization_id: "item.lime_stained_glass_pane",
			serialization_name: "minecraft:lime_stained_glass_pane",
		},
		{
			command_name: "minecraft:lime_terracotta",
			name: "minecraft:lime_terracotta",
			raw_id: -728,
			serialization_id: "item.lime_terracotta",
			serialization_name: "minecraft:lime_terracotta",
		},
		{
			command_name: "minecraft:lime_wool",
			name: "minecraft:lime_wool",
			raw_id: -559,
			serialization_id: "item.lime_wool",
			serialization_name: "minecraft:lime_wool",
		},
		{
			command_name: "minecraft:lingering_potion",
			name: "minecraft:lingering_potion",
			raw_id: 595,
			serialization_id: "item.lingering_potion",
			serialization_name: "minecraft:lingering_potion",
		},
		{
			command_name: "minecraft:lit_pumpkin",
			name: "minecraft:lit_pumpkin",
			raw_id: 91,
			serialization_id: "item.lit_pumpkin",
			serialization_name: "minecraft:lit_pumpkin",
		},
		{
			command_name: "minecraft:llama_spawn_egg",
			name: "minecraft:llama_spawn_egg",
			raw_id: 501,
			serialization_id: "item.llama_spawn_egg",
			serialization_name: "minecraft:llama_spawn_egg",
		},
		{
			command_name: "minecraft:lodestone",
			name: "minecraft:lodestone",
			raw_id: -222,
			serialization_id: "item.lodestone",
			serialization_name: "minecraft:lodestone",
		},
		{
			command_name: "minecraft:lodestone_compass",
			name: "minecraft:lodestone_compass",
			raw_id: 638,
			serialization_id: "item.lodestonecompass",
			serialization_name: "minecraft:lodestone_compass",
		},
		{
			command_name: "minecraft:loom",
			name: "minecraft:loom",
			raw_id: -204,
			serialization_id: "item.loom",
			serialization_name: "minecraft:loom",
		},
		{
			command_name: "minecraft:mace",
			name: "minecraft:mace",
			raw_id: 344,
			serialization_id: "item.mace",
			serialization_name: "minecraft:mace",
		},
		{
			command_name: "minecraft:magenta_bundle",
			name: "minecraft:magenta_bundle",
			raw_id: 267,
			serialization_id: "item.magenta_bundle",
			serialization_name: "minecraft:magenta_bundle",
		},
		{
			command_name: "minecraft:magenta_candle",
			name: "minecraft:magenta_candle",
			raw_id: -415,
			serialization_id: "item.magenta_candle",
			serialization_name: "minecraft:magenta_candle",
		},
		{
			command_name: "minecraft:magenta_carpet",
			name: "minecraft:magenta_carpet",
			raw_id: -598,
			serialization_id: "item.magenta_carpet",
			serialization_name: "minecraft:magenta_carpet",
		},
		{
			command_name: "minecraft:magenta_concrete",
			name: "minecraft:magenta_concrete",
			raw_id: -629,
			serialization_id: "item.magenta_concrete",
			serialization_name: "minecraft:magenta_concrete",
		},
		{
			command_name: "minecraft:magenta_concrete_powder",
			name: "minecraft:magenta_concrete_powder",
			raw_id: -710,
			serialization_id: "item.magenta_concrete_powder",
			serialization_name: "minecraft:magenta_concrete_powder",
		},
		{
			command_name: "minecraft:magenta_dye",
			name: "minecraft:magenta_dye",
			raw_id: 434,
			serialization_id: "item.magenta_dye",
			serialization_name: "minecraft:magenta_dye",
		},
		{
			command_name: "minecraft:magenta_glazed_terracotta",
			name: "minecraft:magenta_glazed_terracotta",
			raw_id: 222,
			serialization_id: "item.magenta_glazed_terracotta",
			serialization_name: "minecraft:magenta_glazed_terracotta",
		},
		{
			command_name: "minecraft:magenta_shulker_box",
			name: "minecraft:magenta_shulker_box",
			raw_id: -614,
			serialization_id: "item.magenta_shulker_box",
			serialization_name: "minecraft:magenta_shulker_box",
		},
		{
			command_name: "minecraft:magenta_stained_glass",
			name: "minecraft:magenta_stained_glass",
			raw_id: -674,
			serialization_id: "item.magenta_stained_glass",
			serialization_name: "minecraft:magenta_stained_glass",
		},
		{
			command_name: "minecraft:magenta_stained_glass_pane",
			name: "minecraft:magenta_stained_glass_pane",
			raw_id: -644,
			serialization_id: "item.magenta_stained_glass_pane",
			serialization_name: "minecraft:magenta_stained_glass_pane",
		},
		{
			command_name: "minecraft:magenta_terracotta",
			name: "minecraft:magenta_terracotta",
			raw_id: -725,
			serialization_id: "item.magenta_terracotta",
			serialization_name: "minecraft:magenta_terracotta",
		},
		{
			command_name: "minecraft:magenta_wool",
			name: "minecraft:magenta_wool",
			raw_id: -565,
			serialization_id: "item.magenta_wool",
			serialization_name: "minecraft:magenta_wool",
		},
		{
			command_name: "minecraft:magma",
			name: "minecraft:magma",
			raw_id: 213,
			serialization_id: "item.magma",
			serialization_name: "minecraft:magma",
		},
		{
			command_name: "minecraft:magma_cream",
			name: "minecraft:magma_cream",
			raw_id: 457,
			serialization_id: "item.magma_cream",
			serialization_name: "minecraft:magma_cream",
		},
		{
			command_name: "minecraft:magma_cube_spawn_egg",
			name: "minecraft:magma_cube_spawn_egg",
			raw_id: 482,
			serialization_id: "item.magma_cube_spawn_egg",
			serialization_name: "minecraft:magma_cube_spawn_egg",
		},
		{
			command_name: "minecraft:mangrove_boat",
			name: "minecraft:mangrove_boat",
			raw_id: 671,
			serialization_id: "item.mangrove_boat",
			serialization_name: "minecraft:mangrove_boat",
		},
		{
			command_name: "minecraft:mangrove_button",
			name: "minecraft:mangrove_button",
			raw_id: -487,
			serialization_id: "item.mangrove_button",
			serialization_name: "minecraft:mangrove_button",
		},
		{
			command_name: "minecraft:mangrove_chest_boat",
			name: "minecraft:mangrove_chest_boat",
			raw_id: 680,
			serialization_id: "item.mangrove_chest_boat",
			serialization_name: "minecraft:mangrove_chest_boat",
		},
		{
			command_name: "minecraft:mangrove_door",
			name: "minecraft:mangrove_door",
			raw_id: 669,
			serialization_id: "item.mangrove_door",
			serialization_name: "minecraft:mangrove_door",
		},
		{
			command_name: "minecraft:mangrove_fence",
			name: "minecraft:mangrove_fence",
			raw_id: -491,
			serialization_id: "item.mangrove_fence",
			serialization_name: "minecraft:mangrove_fence",
		},
		{
			command_name: "minecraft:mangrove_fence_gate",
			name: "minecraft:mangrove_fence_gate",
			raw_id: -492,
			serialization_id: "item.mangrove_fence_gate",
			serialization_name: "minecraft:mangrove_fence_gate",
		},
		{
			command_name: "minecraft:mangrove_hanging_sign",
			name: "minecraft:mangrove_hanging_sign",
			raw_id: -508,
			serialization_id: "item.mangrove_hanging_sign",
			serialization_name: "minecraft:mangrove_hanging_sign",
		},
		{
			command_name: "minecraft:mangrove_leaves",
			name: "minecraft:mangrove_leaves",
			raw_id: -472,
			serialization_id: "item.mangrove_leaves",
			serialization_name: "minecraft:mangrove_leaves",
		},
		{
			command_name: "minecraft:mangrove_log",
			name: "minecraft:mangrove_log",
			raw_id: -484,
			serialization_id: "item.mangrove_log",
			serialization_name: "minecraft:mangrove_log",
		},
		{
			command_name: "minecraft:mangrove_planks",
			name: "minecraft:mangrove_planks",
			raw_id: -486,
			serialization_id: "item.mangrove_planks",
			serialization_name: "minecraft:mangrove_planks",
		},
		{
			command_name: "minecraft:mangrove_pressure_plate",
			name: "minecraft:mangrove_pressure_plate",
			raw_id: -490,
			serialization_id: "item.mangrove_pressure_plate",
			serialization_name: "minecraft:mangrove_pressure_plate",
		},
		{
			command_name: "minecraft:mangrove_propagule",
			name: "minecraft:mangrove_propagule",
			raw_id: -474,
			serialization_id: "item.mangrove_propagule",
			serialization_name: "minecraft:mangrove_propagule",
		},
		{
			command_name: "minecraft:mangrove_roots",
			name: "minecraft:mangrove_roots",
			raw_id: -482,
			serialization_id: "item.mangrove_roots",
			serialization_name: "minecraft:mangrove_roots",
		},
		{
			command_name: "minecraft:mangrove_sign",
			name: "minecraft:mangrove_sign",
			raw_id: 670,
			serialization_id: "item.mangrove_sign",
			serialization_name: "minecraft:mangrove_sign",
		},
		{
			command_name: "minecraft:mangrove_slab",
			name: "minecraft:mangrove_slab",
			raw_id: -489,
			serialization_id: "item.mangrove_slab",
			serialization_name: "minecraft:mangrove_slab",
		},
		{
			command_name: "minecraft:mangrove_stairs",
			name: "minecraft:mangrove_stairs",
			raw_id: -488,
			serialization_id: "item.mangrove_stairs",
			serialization_name: "minecraft:mangrove_stairs",
		},
		{
			command_name: "minecraft:mangrove_trapdoor",
			name: "minecraft:mangrove_trapdoor",
			raw_id: -496,
			serialization_id: "item.mangrove_trapdoor",
			serialization_name: "minecraft:mangrove_trapdoor",
		},
		{
			command_name: "minecraft:mangrove_wood",
			name: "minecraft:mangrove_wood",
			raw_id: -497,
			serialization_id: "item.mangrove_wood",
			serialization_name: "minecraft:mangrove_wood",
		},
		{
			command_name: "minecraft:medium_amethyst_bud",
			name: "minecraft:medium_amethyst_bud",
			raw_id: -331,
			serialization_id: "item.medium_amethyst_bud",
			serialization_name: "minecraft:medium_amethyst_bud",
		},
		{
			command_name: "minecraft:melon_block",
			name: "minecraft:melon_block",
			raw_id: 103,
			serialization_id: "item.melon_block",
			serialization_name: "minecraft:melon_block",
		},
		{
			command_name: "minecraft:melon_seeds",
			name: "minecraft:melon_seeds",
			raw_id: 315,
			serialization_id: "item.melon_seeds",
			serialization_name: "minecraft:melon_seeds",
		},
		{
			command_name: "minecraft:melon_slice",
			name: "minecraft:melon_slice",
			raw_id: 294,
			serialization_id: "item.melon",
			serialization_name: "minecraft:melon_slice",
		},
		{
			command_name: "minecraft:milk_bucket",
			name: "minecraft:milk_bucket",
			raw_id: 386,
			serialization_id: "item.milk_bucket",
			serialization_name: "minecraft:milk_bucket",
		},
		{
			command_name: "minecraft:minecart",
			name: "minecraft:minecart",
			raw_id: 395,
			serialization_id: "item.minecart",
			serialization_name: "minecraft:minecart",
		},
		{
			command_name: "minecraft:miner_pottery_sherd",
			name: "minecraft:miner_pottery_sherd",
			raw_id: 706,
			serialization_id: "item.miner_pottery_sherd",
			serialization_name: "minecraft:miner_pottery_sherd",
		},
		{
			command_name: "minecraft:mob_spawner",
			name: "minecraft:mob_spawner",
			raw_id: 52,
			serialization_id: "item.mob_spawner",
			serialization_name: "minecraft:mob_spawner",
		},
		{
			command_name: "minecraft:mojang_banner_pattern",
			name: "minecraft:mojang_banner_pattern",
			raw_id: 617,
			serialization_id: "item.mojang_banner_pattern",
			serialization_name: "minecraft:mojang_banner_pattern",
		},
		{
			command_name: "minecraft:mooshroom_spawn_egg",
			name: "minecraft:mooshroom_spawn_egg",
			raw_id: 467,
			serialization_id: "item.mooshroom_spawn_egg",
			serialization_name: "minecraft:mooshroom_spawn_egg",
		},
		{
			command_name: "minecraft:moss_block",
			name: "minecraft:moss_block",
			raw_id: -320,
			serialization_id: "item.moss_block",
			serialization_name: "minecraft:moss_block",
		},
		{
			command_name: "minecraft:moss_carpet",
			name: "minecraft:moss_carpet",
			raw_id: -335,
			serialization_id: "item.moss_carpet",
			serialization_name: "minecraft:moss_carpet",
		},
		{
			command_name: "minecraft:mossy_cobblestone",
			name: "minecraft:mossy_cobblestone",
			raw_id: 48,
			serialization_id: "item.mossy_cobblestone",
			serialization_name: "minecraft:mossy_cobblestone",
		},
		{
			command_name: "minecraft:mossy_cobblestone_slab",
			name: "minecraft:mossy_cobblestone_slab",
			raw_id: -888,
			serialization_id: "item.mossy_cobblestone_slab",
			serialization_name: "minecraft:mossy_cobblestone_slab",
		},
		{
			command_name: "minecraft:mossy_cobblestone_stairs",
			name: "minecraft:mossy_cobblestone_stairs",
			raw_id: -179,
			serialization_id: "item.mossy_cobblestone_stairs",
			serialization_name: "minecraft:mossy_cobblestone_stairs",
		},
		{
			command_name: "minecraft:mossy_cobblestone_wall",
			name: "minecraft:mossy_cobblestone_wall",
			raw_id: -971,
			serialization_id: "item.mossy_cobblestone_wall",
			serialization_name: "minecraft:mossy_cobblestone_wall",
		},
		{
			command_name: "minecraft:mossy_stone_brick_slab",
			name: "minecraft:mossy_stone_brick_slab",
			raw_id: -166,
			serialization_id: "item.mossy_stone_brick_slab",
			serialization_name: "minecraft:mossy_stone_brick_slab",
		},
		{
			command_name: "minecraft:mossy_stone_brick_stairs",
			name: "minecraft:mossy_stone_brick_stairs",
			raw_id: -175,
			serialization_id: "item.mossy_stone_brick_stairs",
			serialization_name: "minecraft:mossy_stone_brick_stairs",
		},
		{
			command_name: "minecraft:mossy_stone_brick_wall",
			name: "minecraft:mossy_stone_brick_wall",
			raw_id: -978,
			serialization_id: "item.mossy_stone_brick_wall",
			serialization_name: "minecraft:mossy_stone_brick_wall",
		},
		{
			command_name: "minecraft:mossy_stone_bricks",
			name: "minecraft:mossy_stone_bricks",
			raw_id: -868,
			serialization_id: "item.mossy_stone_bricks",
			serialization_name: "minecraft:mossy_stone_bricks",
		},
		{
			command_name: "minecraft:mourner_pottery_sherd",
			name: "minecraft:mourner_pottery_sherd",
			raw_id: 707,
			serialization_id: "item.mourner_pottery_sherd",
			serialization_name: "minecraft:mourner_pottery_sherd",
		},
		{
			command_name: "minecraft:mud",
			name: "minecraft:mud",
			raw_id: -473,
			serialization_id: "item.mud",
			serialization_name: "minecraft:mud",
		},
		{
			command_name: "minecraft:mud_brick_slab",
			name: "minecraft:mud_brick_slab",
			raw_id: -478,
			serialization_id: "item.mud_brick_slab",
			serialization_name: "minecraft:mud_brick_slab",
		},
		{
			command_name: "minecraft:mud_brick_stairs",
			name: "minecraft:mud_brick_stairs",
			raw_id: -480,
			serialization_id: "item.mud_brick_stairs",
			serialization_name: "minecraft:mud_brick_stairs",
		},
		{
			command_name: "minecraft:mud_brick_wall",
			name: "minecraft:mud_brick_wall",
			raw_id: -481,
			serialization_id: "item.mud_brick_wall",
			serialization_name: "minecraft:mud_brick_wall",
		},
		{
			command_name: "minecraft:mud_bricks",
			name: "minecraft:mud_bricks",
			raw_id: -475,
			serialization_id: "item.mud_bricks",
			serialization_name: "minecraft:mud_bricks",
		},
		{
			command_name: "minecraft:muddy_mangrove_roots",
			name: "minecraft:muddy_mangrove_roots",
			raw_id: -483,
			serialization_id: "item.muddy_mangrove_roots",
			serialization_name: "minecraft:muddy_mangrove_roots",
		},
		{
			command_name: "minecraft:mule_spawn_egg",
			name: "minecraft:mule_spawn_egg",
			raw_id: 494,
			serialization_id: "item.mule_spawn_egg",
			serialization_name: "minecraft:mule_spawn_egg",
		},
		{
			command_name: "minecraft:mushroom_stem",
			name: "minecraft:mushroom_stem",
			raw_id: -1008,
			serialization_id: "item.mushroom_stem",
			serialization_name: "minecraft:mushroom_stem",
		},
		{
			command_name: "minecraft:mushroom_stew",
			name: "minecraft:mushroom_stew",
			raw_id: 282,
			serialization_id: "item.mushroom_stew",
			serialization_name: "minecraft:mushroom_stew",
		},
		{
			command_name: "minecraft:music_disc_11",
			name: "minecraft:music_disc_11",
			raw_id: 577,
			serialization_id: "item.record_11",
			serialization_name: "minecraft:music_disc_11",
		},
		{
			command_name: "minecraft:music_disc_13",
			name: "minecraft:music_disc_13",
			raw_id: 567,
			serialization_id: "item.record_13",
			serialization_name: "minecraft:music_disc_13",
		},
		{
			command_name: "minecraft:music_disc_5",
			name: "minecraft:music_disc_5",
			raw_id: 672,
			serialization_id: "item.record_5",
			serialization_name: "minecraft:music_disc_5",
		},
		{
			command_name: "minecraft:music_disc_blocks",
			name: "minecraft:music_disc_blocks",
			raw_id: 569,
			serialization_id: "item.record_blocks",
			serialization_name: "minecraft:music_disc_blocks",
		},
		{
			command_name: "minecraft:music_disc_cat",
			name: "minecraft:music_disc_cat",
			raw_id: 568,
			serialization_id: "item.record_cat",
			serialization_name: "minecraft:music_disc_cat",
		},
		{
			command_name: "minecraft:music_disc_chirp",
			name: "minecraft:music_disc_chirp",
			raw_id: 570,
			serialization_id: "item.record_chirp",
			serialization_name: "minecraft:music_disc_chirp",
		},
		{
			command_name: "minecraft:music_disc_creator",
			name: "minecraft:music_disc_creator",
			raw_id: 776,
			serialization_id: "item.record_creator",
			serialization_name: "minecraft:music_disc_creator",
		},
		{
			command_name: "minecraft:music_disc_creator_music_box",
			name: "minecraft:music_disc_creator_music_box",
			raw_id: 777,
			serialization_id: "item.record_creator_music_box",
			serialization_name: "minecraft:music_disc_creator_music_box",
		},
		{
			command_name: "minecraft:music_disc_far",
			name: "minecraft:music_disc_far",
			raw_id: 571,
			serialization_id: "item.record_far",
			serialization_name: "minecraft:music_disc_far",
		},
		{
			command_name: "minecraft:music_disc_mall",
			name: "minecraft:music_disc_mall",
			raw_id: 572,
			serialization_id: "item.record_mall",
			serialization_name: "minecraft:music_disc_mall",
		},
		{
			command_name: "minecraft:music_disc_mellohi",
			name: "minecraft:music_disc_mellohi",
			raw_id: 573,
			serialization_id: "item.record_mellohi",
			serialization_name: "minecraft:music_disc_mellohi",
		},
		{
			command_name: "minecraft:music_disc_otherside",
			name: "minecraft:music_disc_otherside",
			raw_id: 662,
			serialization_id: "item.record_otherside",
			serialization_name: "minecraft:music_disc_otherside",
		},
		{
			command_name: "minecraft:music_disc_pigstep",
			name: "minecraft:music_disc_pigstep",
			raw_id: 656,
			serialization_id: "item.record_pigstep",
			serialization_name: "minecraft:music_disc_pigstep",
		},
		{
			command_name: "minecraft:music_disc_precipice",
			name: "minecraft:music_disc_precipice",
			raw_id: 778,
			serialization_id: "item.record_precipice",
			serialization_name: "minecraft:music_disc_precipice",
		},
		{
			command_name: "minecraft:music_disc_relic",
			name: "minecraft:music_disc_relic",
			raw_id: 735,
			serialization_id: "item.record_relic",
			serialization_name: "minecraft:music_disc_relic",
		},
		{
			command_name: "minecraft:music_disc_stal",
			name: "minecraft:music_disc_stal",
			raw_id: 574,
			serialization_id: "item.record_stal",
			serialization_name: "minecraft:music_disc_stal",
		},
		{
			command_name: "minecraft:music_disc_strad",
			name: "minecraft:music_disc_strad",
			raw_id: 575,
			serialization_id: "item.record_strad",
			serialization_name: "minecraft:music_disc_strad",
		},
		{
			command_name: "minecraft:music_disc_wait",
			name: "minecraft:music_disc_wait",
			raw_id: 578,
			serialization_id: "item.record_wait",
			serialization_name: "minecraft:music_disc_wait",
		},
		{
			command_name: "minecraft:music_disc_ward",
			name: "minecraft:music_disc_ward",
			raw_id: 576,
			serialization_id: "item.record_ward",
			serialization_name: "minecraft:music_disc_ward",
		},
		{
			command_name: "minecraft:mutton",
			name: "minecraft:mutton",
			raw_id: 583,
			serialization_id: "item.muttonRaw",
			serialization_name: "minecraft:mutton",
		},
		{
			command_name: "minecraft:mycelium",
			name: "minecraft:mycelium",
			raw_id: 110,
			serialization_id: "item.mycelium",
			serialization_name: "minecraft:mycelium",
		},
		{
			command_name: "minecraft:name_tag",
			name: "minecraft:name_tag",
			raw_id: 581,
			serialization_id: "item.name_tag",
			serialization_name: "minecraft:name_tag",
		},
		{
			command_name: "minecraft:nautilus_shell",
			name: "minecraft:nautilus_shell",
			raw_id: 603,
			serialization_id: "item.nautilus_shell",
			serialization_name: "minecraft:nautilus_shell",
		},
		{
			command_name: "minecraft:nether_brick",
			name: "minecraft:nether_brick",
			raw_id: 112,
			serialization_id: "item.nether_brick",
			serialization_name: "minecraft:nether_brick",
		},
		{
			command_name: "minecraft:nether_brick_fence",
			name: "minecraft:nether_brick_fence",
			raw_id: 113,
			serialization_id: "item.nether_brick_fence",
			serialization_name: "minecraft:nether_brick_fence",
		},
		{
			command_name: "minecraft:nether_brick_slab",
			name: "minecraft:nether_brick_slab",
			raw_id: -877,
			serialization_id: "item.nether_brick_slab",
			serialization_name: "minecraft:nether_brick_slab",
		},
		{
			command_name: "minecraft:nether_brick_stairs",
			name: "minecraft:nether_brick_stairs",
			raw_id: 114,
			serialization_id: "item.nether_brick_stairs",
			serialization_name: "minecraft:nether_brick_stairs",
		},
		{
			command_name: "minecraft:nether_brick_wall",
			name: "minecraft:nether_brick_wall",
			raw_id: -979,
			serialization_id: "item.nether_brick_wall",
			serialization_name: "minecraft:nether_brick_wall",
		},
		{
			command_name: "minecraft:nether_gold_ore",
			name: "minecraft:nether_gold_ore",
			raw_id: -288,
			serialization_id: "item.nether_gold_ore",
			serialization_name: "minecraft:nether_gold_ore",
		},
		{
			command_name: "minecraft:nether_sprouts",
			name: "minecraft:nether_sprouts",
			raw_id: 657,
			serialization_id: "tile.nether_sprouts",
			serialization_name: "minecraft:nether_sprouts",
		},
		{
			command_name: "minecraft:nether_star",
			name: "minecraft:nether_star",
			raw_id: 551,
			serialization_id: "item.netherStar",
			serialization_name: "minecraft:nether_star",
		},
		{
			command_name: "minecraft:nether_wart",
			name: "minecraft:nether_wart",
			raw_id: 316,
			serialization_id: "item.nether_wart",
			serialization_name: "minecraft:nether_wart",
		},
		{
			command_name: "minecraft:nether_wart_block",
			name: "minecraft:nether_wart_block",
			raw_id: 214,
			serialization_id: "item.nether_wart_block",
			serialization_name: "minecraft:nether_wart_block",
		},
		{
			command_name: "minecraft:netherbrick",
			name: "minecraft:netherbrick",
			raw_id: 556,
			serialization_id: "item.netherbrick",
			serialization_name: "minecraft:netherbrick",
		},
		{
			command_name: "minecraft:netherite_axe",
			name: "minecraft:netherite_axe",
			raw_id: 642,
			serialization_id: "item.netherite_axe",
			serialization_name: "minecraft:netherite_axe",
		},
		{
			command_name: "minecraft:netherite_block",
			name: "minecraft:netherite_block",
			raw_id: -270,
			serialization_id: "item.netherite_block",
			serialization_name: "minecraft:netherite_block",
		},
		{
			command_name: "minecraft:netherite_boots",
			name: "minecraft:netherite_boots",
			raw_id: 648,
			serialization_id: "item.netherite_boots",
			serialization_name: "minecraft:netherite_boots",
		},
		{
			command_name: "minecraft:netherite_chestplate",
			name: "minecraft:netherite_chestplate",
			raw_id: 646,
			serialization_id: "item.netherite_chestplate",
			serialization_name: "minecraft:netherite_chestplate",
		},
		{
			command_name: "minecraft:netherite_helmet",
			name: "minecraft:netherite_helmet",
			raw_id: 645,
			serialization_id: "item.netherite_helmet",
			serialization_name: "minecraft:netherite_helmet",
		},
		{
			command_name: "minecraft:netherite_hoe",
			name: "minecraft:netherite_hoe",
			raw_id: 643,
			serialization_id: "item.netherite_hoe",
			serialization_name: "minecraft:netherite_hoe",
		},
		{
			command_name: "minecraft:netherite_ingot",
			name: "minecraft:netherite_ingot",
			raw_id: 644,
			serialization_id: "item.netherite_ingot",
			serialization_name: "minecraft:netherite_ingot",
		},
		{
			command_name: "minecraft:netherite_leggings",
			name: "minecraft:netherite_leggings",
			raw_id: 647,
			serialization_id: "item.netherite_leggings",
			serialization_name: "minecraft:netherite_leggings",
		},
		{
			command_name: "minecraft:netherite_pickaxe",
			name: "minecraft:netherite_pickaxe",
			raw_id: 641,
			serialization_id: "item.netherite_pickaxe",
			serialization_name: "minecraft:netherite_pickaxe",
		},
		{
			command_name: "minecraft:netherite_scrap",
			name: "minecraft:netherite_scrap",
			raw_id: 649,
			serialization_id: "item.netherite_scrap",
			serialization_name: "minecraft:netherite_scrap",
		},
		{
			command_name: "minecraft:netherite_shovel",
			name: "minecraft:netherite_shovel",
			raw_id: 640,
			serialization_id: "item.netherite_shovel",
			serialization_name: "minecraft:netherite_shovel",
		},
		{
			command_name: "minecraft:netherite_sword",
			name: "minecraft:netherite_sword",
			raw_id: 639,
			serialization_id: "item.netherite_sword",
			serialization_name: "minecraft:netherite_sword",
		},
		{
			command_name: "minecraft:netherite_upgrade_smithing_template",
			name: "minecraft:netherite_upgrade_smithing_template",
			raw_id: 716,
			serialization_id: "item.netherite_upgrade_smithing_template",
			serialization_name: "minecraft:netherite_upgrade_smithing_template",
		},
		{
			command_name: "minecraft:netherrack",
			name: "minecraft:netherrack",
			raw_id: 87,
			serialization_id: "item.netherrack",
			serialization_name: "minecraft:netherrack",
		},
		{
			command_name: "minecraft:normal_stone_slab",
			name: "minecraft:normal_stone_slab",
			raw_id: -899,
			serialization_id: "item.normal_stone_slab",
			serialization_name: "minecraft:normal_stone_slab",
		},
		{
			command_name: "minecraft:normal_stone_stairs",
			name: "minecraft:normal_stone_stairs",
			raw_id: -180,
			serialization_id: "item.normal_stone_stairs",
			serialization_name: "minecraft:normal_stone_stairs",
		},
		{
			command_name: "minecraft:noteblock",
			name: "minecraft:noteblock",
			raw_id: 25,
			serialization_id: "item.noteblock",
			serialization_name: "minecraft:noteblock",
		},
		{
			command_name: "minecraft:oak_boat",
			name: "minecraft:oak_boat",
			raw_id: 401,
			serialization_id: "item.oak_boat",
			serialization_name: "minecraft:oak_boat",
		},
		{
			command_name: "minecraft:oak_chest_boat",
			name: "minecraft:oak_chest_boat",
			raw_id: 674,
			serialization_id: "item.oak_chest_boat",
			serialization_name: "minecraft:oak_chest_boat",
		},
		{
			command_name: "minecraft:oak_fence",
			name: "minecraft:oak_fence",
			raw_id: 85,
			serialization_id: "item.oak_fence",
			serialization_name: "minecraft:oak_fence",
		},
		{
			command_name: "minecraft:oak_hanging_sign",
			name: "minecraft:oak_hanging_sign",
			raw_id: -500,
			serialization_id: "item.oak_hanging_sign",
			serialization_name: "minecraft:oak_hanging_sign",
		},
		{
			command_name: "minecraft:oak_leaves",
			name: "minecraft:oak_leaves",
			raw_id: 18,
			serialization_id: "item.oak_leaves",
			serialization_name: "minecraft:oak_leaves",
		},
		{
			command_name: "minecraft:oak_log",
			name: "minecraft:oak_log",
			raw_id: 17,
			serialization_id: "item.oak_log",
			serialization_name: "minecraft:oak_log",
		},
		{
			command_name: "minecraft:oak_planks",
			name: "minecraft:oak_planks",
			raw_id: 5,
			serialization_id: "item.oak_planks",
			serialization_name: "minecraft:oak_planks",
		},
		{
			command_name: "minecraft:oak_sapling",
			name: "minecraft:oak_sapling",
			raw_id: 6,
			serialization_id: "item.oak_sapling",
			serialization_name: "minecraft:oak_sapling",
		},
		{
			command_name: "minecraft:oak_sign",
			name: "minecraft:oak_sign",
			raw_id: 383,
			serialization_id: "item.sign",
			serialization_name: "minecraft:oak_sign",
		},
		{
			command_name: "minecraft:oak_slab",
			name: "minecraft:oak_slab",
			raw_id: 158,
			serialization_id: "item.oak_slab",
			serialization_name: "minecraft:oak_slab",
		},
		{
			command_name: "minecraft:oak_stairs",
			name: "minecraft:oak_stairs",
			raw_id: 53,
			serialization_id: "item.oak_stairs",
			serialization_name: "minecraft:oak_stairs",
		},
		{
			command_name: "minecraft:oak_wood",
			name: "minecraft:oak_wood",
			raw_id: -212,
			serialization_id: "item.oak_wood",
			serialization_name: "minecraft:oak_wood",
		},
		{
			command_name: "minecraft:observer",
			name: "minecraft:observer",
			raw_id: 251,
			serialization_id: "item.observer",
			serialization_name: "minecraft:observer",
		},
		{
			command_name: "minecraft:obsidian",
			name: "minecraft:obsidian",
			raw_id: 49,
			serialization_id: "item.obsidian",
			serialization_name: "minecraft:obsidian",
		},
		{
			command_name: "minecraft:ocelot_spawn_egg",
			name: "minecraft:ocelot_spawn_egg",
			raw_id: 478,
			serialization_id: "item.ocelot_spawn_egg",
			serialization_name: "minecraft:ocelot_spawn_egg",
		},
		{
			command_name: "minecraft:ochre_froglight",
			name: "minecraft:ochre_froglight",
			raw_id: -471,
			serialization_id: "item.ochre_froglight",
			serialization_name: "minecraft:ochre_froglight",
		},
		{
			command_name: "minecraft:ominous_bottle",
			name: "minecraft:ominous_bottle",
			raw_id: 628,
			serialization_id: "item.ominous_bottle",
			serialization_name: "minecraft:ominous_bottle",
		},
		{
			command_name: "minecraft:ominous_trial_key",
			name: "minecraft:ominous_trial_key",
			raw_id: 275,
			serialization_id: "item.ominous_trial_key.name",
			serialization_name: "minecraft:ominous_trial_key",
		},
		{
			command_name: "minecraft:orange_bundle",
			name: "minecraft:orange_bundle",
			raw_id: 268,
			serialization_id: "item.orange_bundle",
			serialization_name: "minecraft:orange_bundle",
		},
		{
			command_name: "minecraft:orange_candle",
			name: "minecraft:orange_candle",
			raw_id: -414,
			serialization_id: "item.orange_candle",
			serialization_name: "minecraft:orange_candle",
		},
		{
			command_name: "minecraft:orange_carpet",
			name: "minecraft:orange_carpet",
			raw_id: -597,
			serialization_id: "item.orange_carpet",
			serialization_name: "minecraft:orange_carpet",
		},
		{
			command_name: "minecraft:orange_concrete",
			name: "minecraft:orange_concrete",
			raw_id: -628,
			serialization_id: "item.orange_concrete",
			serialization_name: "minecraft:orange_concrete",
		},
		{
			command_name: "minecraft:orange_concrete_powder",
			name: "minecraft:orange_concrete_powder",
			raw_id: -709,
			serialization_id: "item.orange_concrete_powder",
			serialization_name: "minecraft:orange_concrete_powder",
		},
		{
			command_name: "minecraft:orange_dye",
			name: "minecraft:orange_dye",
			raw_id: 435,
			serialization_id: "item.orange_dye",
			serialization_name: "minecraft:orange_dye",
		},
		{
			command_name: "minecraft:orange_glazed_terracotta",
			name: "minecraft:orange_glazed_terracotta",
			raw_id: 221,
			serialization_id: "item.orange_glazed_terracotta",
			serialization_name: "minecraft:orange_glazed_terracotta",
		},
		{
			command_name: "minecraft:orange_shulker_box",
			name: "minecraft:orange_shulker_box",
			raw_id: -613,
			serialization_id: "item.orange_shulker_box",
			serialization_name: "minecraft:orange_shulker_box",
		},
		{
			command_name: "minecraft:orange_stained_glass",
			name: "minecraft:orange_stained_glass",
			raw_id: -673,
			serialization_id: "item.orange_stained_glass",
			serialization_name: "minecraft:orange_stained_glass",
		},
		{
			command_name: "minecraft:orange_stained_glass_pane",
			name: "minecraft:orange_stained_glass_pane",
			raw_id: -643,
			serialization_id: "item.orange_stained_glass_pane",
			serialization_name: "minecraft:orange_stained_glass_pane",
		},
		{
			command_name: "minecraft:orange_terracotta",
			name: "minecraft:orange_terracotta",
			raw_id: -724,
			serialization_id: "item.orange_terracotta",
			serialization_name: "minecraft:orange_terracotta",
		},
		{
			command_name: "minecraft:orange_tulip",
			name: "minecraft:orange_tulip",
			raw_id: -834,
			serialization_id: "item.orange_tulip",
			serialization_name: "minecraft:orange_tulip",
		},
		{
			command_name: "minecraft:orange_wool",
			name: "minecraft:orange_wool",
			raw_id: -557,
			serialization_id: "item.orange_wool",
			serialization_name: "minecraft:orange_wool",
		},
		{
			command_name: "minecraft:oxeye_daisy",
			name: "minecraft:oxeye_daisy",
			raw_id: -837,
			serialization_id: "item.oxeye_daisy",
			serialization_name: "minecraft:oxeye_daisy",
		},
		{
			command_name: "minecraft:oxidized_chiseled_copper",
			name: "minecraft:oxidized_chiseled_copper",
			raw_id: -763,
			serialization_id: "item.oxidized_chiseled_copper",
			serialization_name: "minecraft:oxidized_chiseled_copper",
		},
		{
			command_name: "minecraft:oxidized_copper",
			name: "minecraft:oxidized_copper",
			raw_id: -343,
			serialization_id: "item.oxidized_copper",
			serialization_name: "minecraft:oxidized_copper",
		},
		{
			command_name: "minecraft:oxidized_copper_bulb",
			name: "minecraft:oxidized_copper_bulb",
			raw_id: -779,
			serialization_id: "item.oxidized_copper_bulb",
			serialization_name: "minecraft:oxidized_copper_bulb",
		},
		{
			command_name: "minecraft:oxidized_copper_door",
			name: "minecraft:oxidized_copper_door",
			raw_id: -787,
			serialization_id: "item.oxidized_copper_door",
			serialization_name: "minecraft:oxidized_copper_door",
		},
		{
			command_name: "minecraft:oxidized_copper_grate",
			name: "minecraft:oxidized_copper_grate",
			raw_id: -771,
			serialization_id: "item.oxidized_copper_grate",
			serialization_name: "minecraft:oxidized_copper_grate",
		},
		{
			command_name: "minecraft:oxidized_copper_trapdoor",
			name: "minecraft:oxidized_copper_trapdoor",
			raw_id: -795,
			serialization_id: "item.oxidized_copper_trapdoor",
			serialization_name: "minecraft:oxidized_copper_trapdoor",
		},
		{
			command_name: "minecraft:oxidized_cut_copper",
			name: "minecraft:oxidized_cut_copper",
			raw_id: -350,
			serialization_id: "item.oxidized_cut_copper",
			serialization_name: "minecraft:oxidized_cut_copper",
		},
		{
			command_name: "minecraft:oxidized_cut_copper_slab",
			name: "minecraft:oxidized_cut_copper_slab",
			raw_id: -364,
			serialization_id: "item.oxidized_cut_copper_slab",
			serialization_name: "minecraft:oxidized_cut_copper_slab",
		},
		{
			command_name: "minecraft:oxidized_cut_copper_stairs",
			name: "minecraft:oxidized_cut_copper_stairs",
			raw_id: -357,
			serialization_id: "item.oxidized_cut_copper_stairs",
			serialization_name: "minecraft:oxidized_cut_copper_stairs",
		},
		{
			command_name: "minecraft:packed_ice",
			name: "minecraft:packed_ice",
			raw_id: 174,
			serialization_id: "item.packed_ice",
			serialization_name: "minecraft:packed_ice",
		},
		{
			command_name: "minecraft:packed_mud",
			name: "minecraft:packed_mud",
			raw_id: -477,
			serialization_id: "item.packed_mud",
			serialization_name: "minecraft:packed_mud",
		},
		{
			command_name: "minecraft:painting",
			name: "minecraft:painting",
			raw_id: 382,
			serialization_id: "item.painting",
			serialization_name: "minecraft:painting",
		},
		{
			command_name: "minecraft:panda_spawn_egg",
			name: "minecraft:panda_spawn_egg",
			raw_id: 517,
			serialization_id: "item.panda_spawn_egg",
			serialization_name: "minecraft:panda_spawn_egg",
		},
		{
			command_name: "minecraft:paper",
			name: "minecraft:paper",
			raw_id: 412,
			serialization_id: "item.paper",
			serialization_name: "minecraft:paper",
		},
		{
			command_name: "minecraft:parrot_spawn_egg",
			name: "minecraft:parrot_spawn_egg",
			raw_id: 506,
			serialization_id: "item.parrot_spawn_egg",
			serialization_name: "minecraft:parrot_spawn_egg",
		},
		{
			command_name: "minecraft:pearlescent_froglight",
			name: "minecraft:pearlescent_froglight",
			raw_id: -469,
			serialization_id: "item.pearlescent_froglight",
			serialization_name: "minecraft:pearlescent_froglight",
		},
		{
			command_name: "minecraft:peony",
			name: "minecraft:peony",
			raw_id: -867,
			serialization_id: "item.peony",
			serialization_name: "minecraft:peony",
		},
		{
			command_name: "minecraft:petrified_oak_slab",
			name: "minecraft:petrified_oak_slab",
			raw_id: -902,
			serialization_id: "item.petrified_oak_slab",
			serialization_name: "minecraft:petrified_oak_slab",
		},
		{
			command_name: "minecraft:phantom_membrane",
			name: "minecraft:phantom_membrane",
			raw_id: 607,
			serialization_id: "item.phantom_membrane",
			serialization_name: "minecraft:phantom_membrane",
		},
		{
			command_name: "minecraft:phantom_spawn_egg",
			name: "minecraft:phantom_spawn_egg",
			raw_id: 514,
			serialization_id: "item.phantom_spawn_egg",
			serialization_name: "minecraft:phantom_spawn_egg",
		},
		{
			command_name: "minecraft:pig_spawn_egg",
			name: "minecraft:pig_spawn_egg",
			raw_id: 464,
			serialization_id: "item.pig_spawn_egg",
			serialization_name: "minecraft:pig_spawn_egg",
		},
		{
			command_name: "minecraft:piglin_banner_pattern",
			name: "minecraft:piglin_banner_pattern",
			raw_id: 620,
			serialization_id: "item.piglin_banner_pattern",
			serialization_name: "minecraft:piglin_banner_pattern",
		},
		{
			command_name: "minecraft:piglin_brute_spawn_egg",
			name: "minecraft:piglin_brute_spawn_egg",
			raw_id: 527,
			serialization_id: "item.piglin_brute_spawn_egg",
			serialization_name: "minecraft:piglin_brute_spawn_egg",
		},
		{
			command_name: "minecraft:piglin_head",
			name: "minecraft:piglin_head",
			raw_id: -970,
			serialization_id: "item.piglin_head",
			serialization_name: "minecraft:piglin_head",
		},
		{
			command_name: "minecraft:piglin_spawn_egg",
			name: "minecraft:piglin_spawn_egg",
			raw_id: 525,
			serialization_id: "item.piglin_spawn_egg",
			serialization_name: "minecraft:piglin_spawn_egg",
		},
		{
			command_name: "minecraft:pillager_spawn_egg",
			name: "minecraft:pillager_spawn_egg",
			raw_id: 519,
			serialization_id: "item.pillager_spawn_egg",
			serialization_name: "minecraft:pillager_spawn_egg",
		},
		{
			command_name: "minecraft:pink_bundle",
			name: "minecraft:pink_bundle",
			raw_id: 269,
			serialization_id: "item.pink_bundle",
			serialization_name: "minecraft:pink_bundle",
		},
		{
			command_name: "minecraft:pink_candle",
			name: "minecraft:pink_candle",
			raw_id: -419,
			serialization_id: "item.pink_candle",
			serialization_name: "minecraft:pink_candle",
		},
		{
			command_name: "minecraft:pink_carpet",
			name: "minecraft:pink_carpet",
			raw_id: -602,
			serialization_id: "item.pink_carpet",
			serialization_name: "minecraft:pink_carpet",
		},
		{
			command_name: "minecraft:pink_concrete",
			name: "minecraft:pink_concrete",
			raw_id: -633,
			serialization_id: "item.pink_concrete",
			serialization_name: "minecraft:pink_concrete",
		},
		{
			command_name: "minecraft:pink_concrete_powder",
			name: "minecraft:pink_concrete_powder",
			raw_id: -714,
			serialization_id: "item.pink_concrete_powder",
			serialization_name: "minecraft:pink_concrete_powder",
		},
		{
			command_name: "minecraft:pink_dye",
			name: "minecraft:pink_dye",
			raw_id: 430,
			serialization_id: "item.pink_dye",
			serialization_name: "minecraft:pink_dye",
		},
		{
			command_name: "minecraft:pink_glazed_terracotta",
			name: "minecraft:pink_glazed_terracotta",
			raw_id: 226,
			serialization_id: "item.pink_glazed_terracotta",
			serialization_name: "minecraft:pink_glazed_terracotta",
		},
		{
			command_name: "minecraft:pink_petals",
			name: "minecraft:pink_petals",
			raw_id: -549,
			serialization_id: "item.pink_petals",
			serialization_name: "minecraft:pink_petals",
		},
		{
			command_name: "minecraft:pink_shulker_box",
			name: "minecraft:pink_shulker_box",
			raw_id: -618,
			serialization_id: "item.pink_shulker_box",
			serialization_name: "minecraft:pink_shulker_box",
		},
		{
			command_name: "minecraft:pink_stained_glass",
			name: "minecraft:pink_stained_glass",
			raw_id: -678,
			serialization_id: "item.pink_stained_glass",
			serialization_name: "minecraft:pink_stained_glass",
		},
		{
			command_name: "minecraft:pink_stained_glass_pane",
			name: "minecraft:pink_stained_glass_pane",
			raw_id: -648,
			serialization_id: "item.pink_stained_glass_pane",
			serialization_name: "minecraft:pink_stained_glass_pane",
		},
		{
			command_name: "minecraft:pink_terracotta",
			name: "minecraft:pink_terracotta",
			raw_id: -729,
			serialization_id: "item.pink_terracotta",
			serialization_name: "minecraft:pink_terracotta",
		},
		{
			command_name: "minecraft:pink_tulip",
			name: "minecraft:pink_tulip",
			raw_id: -836,
			serialization_id: "item.pink_tulip",
			serialization_name: "minecraft:pink_tulip",
		},
		{
			command_name: "minecraft:pink_wool",
			name: "minecraft:pink_wool",
			raw_id: -566,
			serialization_id: "item.pink_wool",
			serialization_name: "minecraft:pink_wool",
		},
		{
			command_name: "minecraft:piston",
			name: "minecraft:piston",
			raw_id: 33,
			serialization_id: "item.piston",
			serialization_name: "minecraft:piston",
		},
		{
			command_name: "minecraft:pitcher_plant",
			name: "minecraft:pitcher_plant",
			raw_id: -612,
			serialization_id: "item.pitcher_plant",
			serialization_name: "minecraft:pitcher_plant",
		},
		{
			command_name: "minecraft:pitcher_pod",
			name: "minecraft:pitcher_pod",
			raw_id: 319,
			serialization_id: "item.pitcher_pod",
			serialization_name: "minecraft:pitcher_pod",
		},
		{
			command_name: "minecraft:player_head",
			name: "minecraft:player_head",
			raw_id: -967,
			serialization_id: "item.player_head",
			serialization_name: "minecraft:player_head",
		},
		{
			command_name: "minecraft:plenty_pottery_sherd",
			name: "minecraft:plenty_pottery_sherd",
			raw_id: 708,
			serialization_id: "item.plenty_pottery_sherd",
			serialization_name: "minecraft:plenty_pottery_sherd",
		},
		{
			command_name: "minecraft:podzol",
			name: "minecraft:podzol",
			raw_id: 243,
			serialization_id: "item.podzol",
			serialization_name: "minecraft:podzol",
		},
		{
			command_name: "minecraft:pointed_dripstone",
			name: "minecraft:pointed_dripstone",
			raw_id: -308,
			serialization_id: "item.pointed_dripstone",
			serialization_name: "minecraft:pointed_dripstone",
		},
		{
			command_name: "minecraft:poisonous_potato",
			name: "minecraft:poisonous_potato",
			raw_id: 304,
			serialization_id: "item.poisonous_potato",
			serialization_name: "minecraft:poisonous_potato",
		},
		{
			command_name: "minecraft:polar_bear_spawn_egg",
			name: "minecraft:polar_bear_spawn_egg",
			raw_id: 500,
			serialization_id: "item.polar_bear_spawn_egg",
			serialization_name: "minecraft:polar_bear_spawn_egg",
		},
		{
			command_name: "minecraft:polished_andesite",
			name: "minecraft:polished_andesite",
			raw_id: -595,
			serialization_id: "item.polished_andesite",
			serialization_name: "minecraft:polished_andesite",
		},
		{
			command_name: "minecraft:polished_andesite_slab",
			name: "minecraft:polished_andesite_slab",
			raw_id: -892,
			serialization_id: "item.polished_andesite_slab",
			serialization_name: "minecraft:polished_andesite_slab",
		},
		{
			command_name: "minecraft:polished_andesite_stairs",
			name: "minecraft:polished_andesite_stairs",
			raw_id: -174,
			serialization_id: "item.polished_andesite_stairs",
			serialization_name: "minecraft:polished_andesite_stairs",
		},
		{
			command_name: "minecraft:polished_basalt",
			name: "minecraft:polished_basalt",
			raw_id: -235,
			serialization_id: "item.polished_basalt",
			serialization_name: "minecraft:polished_basalt",
		},
		{
			command_name: "minecraft:polished_blackstone",
			name: "minecraft:polished_blackstone",
			raw_id: -291,
			serialization_id: "item.polished_blackstone",
			serialization_name: "minecraft:polished_blackstone",
		},
		{
			command_name: "minecraft:polished_blackstone_brick_slab",
			name: "minecraft:polished_blackstone_brick_slab",
			raw_id: -284,
			serialization_id: "item.polished_blackstone_brick_slab",
			serialization_name: "minecraft:polished_blackstone_brick_slab",
		},
		{
			command_name: "minecraft:polished_blackstone_brick_stairs",
			name: "minecraft:polished_blackstone_brick_stairs",
			raw_id: -275,
			serialization_id: "item.polished_blackstone_brick_stairs",
			serialization_name: "minecraft:polished_blackstone_brick_stairs",
		},
		{
			command_name: "minecraft:polished_blackstone_brick_wall",
			name: "minecraft:polished_blackstone_brick_wall",
			raw_id: -278,
			serialization_id: "item.polished_blackstone_brick_wall",
			serialization_name: "minecraft:polished_blackstone_brick_wall",
		},
		{
			command_name: "minecraft:polished_blackstone_bricks",
			name: "minecraft:polished_blackstone_bricks",
			raw_id: -274,
			serialization_id: "item.polished_blackstone_bricks",
			serialization_name: "minecraft:polished_blackstone_bricks",
		},
		{
			command_name: "minecraft:polished_blackstone_button",
			name: "minecraft:polished_blackstone_button",
			raw_id: -296,
			serialization_id: "item.polished_blackstone_button",
			serialization_name: "minecraft:polished_blackstone_button",
		},
		{
			command_name: "minecraft:polished_blackstone_pressure_plate",
			name: "minecraft:polished_blackstone_pressure_plate",
			raw_id: -295,
			serialization_id: "item.polished_blackstone_pressure_plate",
			serialization_name: "minecraft:polished_blackstone_pressure_plate",
		},
		{
			command_name: "minecraft:polished_blackstone_slab",
			name: "minecraft:polished_blackstone_slab",
			raw_id: -293,
			serialization_id: "item.polished_blackstone_slab",
			serialization_name: "minecraft:polished_blackstone_slab",
		},
		{
			command_name: "minecraft:polished_blackstone_stairs",
			name: "minecraft:polished_blackstone_stairs",
			raw_id: -292,
			serialization_id: "item.polished_blackstone_stairs",
			serialization_name: "minecraft:polished_blackstone_stairs",
		},
		{
			command_name: "minecraft:polished_blackstone_wall",
			name: "minecraft:polished_blackstone_wall",
			raw_id: -297,
			serialization_id: "item.polished_blackstone_wall",
			serialization_name: "minecraft:polished_blackstone_wall",
		},
		{
			command_name: "minecraft:polished_deepslate",
			name: "minecraft:polished_deepslate",
			raw_id: -383,
			serialization_id: "item.polished_deepslate",
			serialization_name: "minecraft:polished_deepslate",
		},
		{
			command_name: "minecraft:polished_deepslate_slab",
			name: "minecraft:polished_deepslate_slab",
			raw_id: -384,
			serialization_id: "item.polished_deepslate_slab",
			serialization_name: "minecraft:polished_deepslate_slab",
		},
		{
			command_name: "minecraft:polished_deepslate_stairs",
			name: "minecraft:polished_deepslate_stairs",
			raw_id: -385,
			serialization_id: "item.polished_deepslate_stairs",
			serialization_name: "minecraft:polished_deepslate_stairs",
		},
		{
			command_name: "minecraft:polished_deepslate_wall",
			name: "minecraft:polished_deepslate_wall",
			raw_id: -386,
			serialization_id: "item.polished_deepslate_wall",
			serialization_name: "minecraft:polished_deepslate_wall",
		},
		{
			command_name: "minecraft:polished_diorite",
			name: "minecraft:polished_diorite",
			raw_id: -593,
			serialization_id: "item.polished_diorite",
			serialization_name: "minecraft:polished_diorite",
		},
		{
			command_name: "minecraft:polished_diorite_slab",
			name: "minecraft:polished_diorite_slab",
			raw_id: -895,
			serialization_id: "item.polished_diorite_slab",
			serialization_name: "minecraft:polished_diorite_slab",
		},
		{
			command_name: "minecraft:polished_diorite_stairs",
			name: "minecraft:polished_diorite_stairs",
			raw_id: -173,
			serialization_id: "item.polished_diorite_stairs",
			serialization_name: "minecraft:polished_diorite_stairs",
		},
		{
			command_name: "minecraft:polished_granite",
			name: "minecraft:polished_granite",
			raw_id: -591,
			serialization_id: "item.polished_granite",
			serialization_name: "minecraft:polished_granite",
		},
		{
			command_name: "minecraft:polished_granite_slab",
			name: "minecraft:polished_granite_slab",
			raw_id: -897,
			serialization_id: "item.polished_granite_slab",
			serialization_name: "minecraft:polished_granite_slab",
		},
		{
			command_name: "minecraft:polished_granite_stairs",
			name: "minecraft:polished_granite_stairs",
			raw_id: -172,
			serialization_id: "item.polished_granite_stairs",
			serialization_name: "minecraft:polished_granite_stairs",
		},
		{
			command_name: "minecraft:polished_tuff",
			name: "minecraft:polished_tuff",
			raw_id: -748,
			serialization_id: "item.polished_tuff",
			serialization_name: "minecraft:polished_tuff",
		},
		{
			command_name: "minecraft:polished_tuff_slab",
			name: "minecraft:polished_tuff_slab",
			raw_id: -749,
			serialization_id: "item.polished_tuff_slab",
			serialization_name: "minecraft:polished_tuff_slab",
		},
		{
			command_name: "minecraft:polished_tuff_stairs",
			name: "minecraft:polished_tuff_stairs",
			raw_id: -751,
			serialization_id: "item.polished_tuff_stairs",
			serialization_name: "minecraft:polished_tuff_stairs",
		},
		{
			command_name: "minecraft:polished_tuff_wall",
			name: "minecraft:polished_tuff_wall",
			raw_id: -752,
			serialization_id: "item.polished_tuff_wall",
			serialization_name: "minecraft:polished_tuff_wall",
		},
		{
			command_name: "minecraft:popped_chorus_fruit",
			name: "minecraft:popped_chorus_fruit",
			raw_id: 592,
			serialization_id: "item.chorus_fruit_popped",
			serialization_name: "minecraft:popped_chorus_fruit",
		},
		{
			command_name: "minecraft:poppy",
			name: "minecraft:poppy",
			raw_id: 38,
			serialization_id: "item.poppy",
			serialization_name: "minecraft:poppy",
		},
		{
			command_name: "minecraft:porkchop",
			name: "minecraft:porkchop",
			raw_id: 284,
			serialization_id: "item.porkchop",
			serialization_name: "minecraft:porkchop",
		},
		{
			command_name: "minecraft:potato",
			name: "minecraft:potato",
			raw_id: 302,
			serialization_id: "item.potato",
			serialization_name: "minecraft:potato",
		},
		{
			command_name: "minecraft:potion",
			name: "minecraft:potion",
			raw_id: 453,
			serialization_id: "item.potion",
			serialization_name: "minecraft:potion",
		},
		{
			command_name: "minecraft:powder_snow_bucket",
			name: "minecraft:powder_snow_bucket",
			raw_id: 393,
			serialization_id: "item.powder_snow_bucket",
			serialization_name: "minecraft:powder_snow_bucket",
		},
		{
			command_name: "minecraft:prismarine",
			name: "minecraft:prismarine",
			raw_id: 168,
			serialization_id: "item.prismarine",
			serialization_name: "minecraft:prismarine",
		},
		{
			command_name: "minecraft:prismarine_brick_slab",
			name: "minecraft:prismarine_brick_slab",
			raw_id: -887,
			serialization_id: "item.prismarine_brick_slab",
			serialization_name: "minecraft:prismarine_brick_slab",
		},
		{
			command_name: "minecraft:prismarine_bricks",
			name: "minecraft:prismarine_bricks",
			raw_id: -948,
			serialization_id: "item.prismarine_bricks",
			serialization_name: "minecraft:prismarine_bricks",
		},
		{
			command_name: "minecraft:prismarine_bricks_stairs",
			name: "minecraft:prismarine_bricks_stairs",
			raw_id: -4,
			serialization_id: "item.prismarine_bricks_stairs",
			serialization_name: "minecraft:prismarine_bricks_stairs",
		},
		{
			command_name: "minecraft:prismarine_crystals",
			name: "minecraft:prismarine_crystals",
			raw_id: 582,
			serialization_id: "item.prismarine_crystals",
			serialization_name: "minecraft:prismarine_crystals",
		},
		{
			command_name: "minecraft:prismarine_shard",
			name: "minecraft:prismarine_shard",
			raw_id: 598,
			serialization_id: "item.prismarine_shard",
			serialization_name: "minecraft:prismarine_shard",
		},
		{
			command_name: "minecraft:prismarine_slab",
			name: "minecraft:prismarine_slab",
			raw_id: -885,
			serialization_id: "item.prismarine_slab",
			serialization_name: "minecraft:prismarine_slab",
		},
		{
			command_name: "minecraft:prismarine_stairs",
			name: "minecraft:prismarine_stairs",
			raw_id: -2,
			serialization_id: "item.prismarine_stairs",
			serialization_name: "minecraft:prismarine_stairs",
		},
		{
			command_name: "minecraft:prismarine_wall",
			name: "minecraft:prismarine_wall",
			raw_id: -981,
			serialization_id: "item.prismarine_wall",
			serialization_name: "minecraft:prismarine_wall",
		},
		{
			command_name: "minecraft:prize_pottery_sherd",
			name: "minecraft:prize_pottery_sherd",
			raw_id: 709,
			serialization_id: "item.prize_pottery_sherd",
			serialization_name: "minecraft:prize_pottery_sherd",
		},
		{
			command_name: "minecraft:pufferfish",
			name: "minecraft:pufferfish",
			raw_id: 289,
			serialization_id: "item.pufferfish",
			serialization_name: "minecraft:pufferfish",
		},
		{
			command_name: "minecraft:pufferfish_bucket",
			name: "minecraft:pufferfish_bucket",
			raw_id: 392,
			serialization_id: "item.pufferfish_bucket",
			serialization_name: "minecraft:pufferfish_bucket",
		},
		{
			command_name: "minecraft:pufferfish_spawn_egg",
			name: "minecraft:pufferfish_spawn_egg",
			raw_id: 509,
			serialization_id: "item.pufferfish_spawn_egg",
			serialization_name: "minecraft:pufferfish_spawn_egg",
		},
		{
			command_name: "minecraft:pumpkin",
			name: "minecraft:pumpkin",
			raw_id: 86,
			serialization_id: "item.pumpkin",
			serialization_name: "minecraft:pumpkin",
		},
		{
			command_name: "minecraft:pumpkin_pie",
			name: "minecraft:pumpkin_pie",
			raw_id: 306,
			serialization_id: "item.pumpkin_pie",
			serialization_name: "minecraft:pumpkin_pie",
		},
		{
			command_name: "minecraft:pumpkin_seeds",
			name: "minecraft:pumpkin_seeds",
			raw_id: 314,
			serialization_id: "item.pumpkin_seeds",
			serialization_name: "minecraft:pumpkin_seeds",
		},
		{
			command_name: "minecraft:purple_bundle",
			name: "minecraft:purple_bundle",
			raw_id: 270,
			serialization_id: "item.purple_bundle",
			serialization_name: "minecraft:purple_bundle",
		},
		{
			command_name: "minecraft:purple_candle",
			name: "minecraft:purple_candle",
			raw_id: -423,
			serialization_id: "item.purple_candle",
			serialization_name: "minecraft:purple_candle",
		},
		{
			command_name: "minecraft:purple_carpet",
			name: "minecraft:purple_carpet",
			raw_id: -606,
			serialization_id: "item.purple_carpet",
			serialization_name: "minecraft:purple_carpet",
		},
		{
			command_name: "minecraft:purple_concrete",
			name: "minecraft:purple_concrete",
			raw_id: -637,
			serialization_id: "item.purple_concrete",
			serialization_name: "minecraft:purple_concrete",
		},
		{
			command_name: "minecraft:purple_concrete_powder",
			name: "minecraft:purple_concrete_powder",
			raw_id: -718,
			serialization_id: "item.purple_concrete_powder",
			serialization_name: "minecraft:purple_concrete_powder",
		},
		{
			command_name: "minecraft:purple_dye",
			name: "minecraft:purple_dye",
			raw_id: 426,
			serialization_id: "item.purple_dye",
			serialization_name: "minecraft:purple_dye",
		},
		{
			command_name: "minecraft:purple_glazed_terracotta",
			name: "minecraft:purple_glazed_terracotta",
			raw_id: 219,
			serialization_id: "item.purple_glazed_terracotta",
			serialization_name: "minecraft:purple_glazed_terracotta",
		},
		{
			command_name: "minecraft:purple_shulker_box",
			name: "minecraft:purple_shulker_box",
			raw_id: -622,
			serialization_id: "item.purple_shulker_box",
			serialization_name: "minecraft:purple_shulker_box",
		},
		{
			command_name: "minecraft:purple_stained_glass",
			name: "minecraft:purple_stained_glass",
			raw_id: -682,
			serialization_id: "item.purple_stained_glass",
			serialization_name: "minecraft:purple_stained_glass",
		},
		{
			command_name: "minecraft:purple_stained_glass_pane",
			name: "minecraft:purple_stained_glass_pane",
			raw_id: -652,
			serialization_id: "item.purple_stained_glass_pane",
			serialization_name: "minecraft:purple_stained_glass_pane",
		},
		{
			command_name: "minecraft:purple_terracotta",
			name: "minecraft:purple_terracotta",
			raw_id: -733,
			serialization_id: "item.purple_terracotta",
			serialization_name: "minecraft:purple_terracotta",
		},
		{
			command_name: "minecraft:purple_wool",
			name: "minecraft:purple_wool",
			raw_id: -564,
			serialization_id: "item.purple_wool",
			serialization_name: "minecraft:purple_wool",
		},
		{
			command_name: "minecraft:purpur_block",
			name: "minecraft:purpur_block",
			raw_id: 201,
			serialization_id: "item.purpur_block",
			serialization_name: "minecraft:purpur_block",
		},
		{
			command_name: "minecraft:purpur_pillar",
			name: "minecraft:purpur_pillar",
			raw_id: -951,
			serialization_id: "item.purpur_pillar",
			serialization_name: "minecraft:purpur_pillar",
		},
		{
			command_name: "minecraft:purpur_slab",
			name: "minecraft:purpur_slab",
			raw_id: -884,
			serialization_id: "item.purpur_slab",
			serialization_name: "minecraft:purpur_slab",
		},
		{
			command_name: "minecraft:purpur_stairs",
			name: "minecraft:purpur_stairs",
			raw_id: 203,
			serialization_id: "item.purpur_stairs",
			serialization_name: "minecraft:purpur_stairs",
		},
		{
			command_name: "minecraft:quartz",
			name: "minecraft:quartz",
			raw_id: 557,
			serialization_id: "item.quartz",
			serialization_name: "minecraft:quartz",
		},
		{
			command_name: "minecraft:quartz_block",
			name: "minecraft:quartz_block",
			raw_id: 155,
			serialization_id: "item.quartz_block",
			serialization_name: "minecraft:quartz_block",
		},
		{
			command_name: "minecraft:quartz_bricks",
			name: "minecraft:quartz_bricks",
			raw_id: -304,
			serialization_id: "item.quartz_bricks",
			serialization_name: "minecraft:quartz_bricks",
		},
		{
			command_name: "minecraft:quartz_ore",
			name: "minecraft:quartz_ore",
			raw_id: 153,
			serialization_id: "item.quartz_ore",
			serialization_name: "minecraft:quartz_ore",
		},
		{
			command_name: "minecraft:quartz_pillar",
			name: "minecraft:quartz_pillar",
			raw_id: -954,
			serialization_id: "item.quartz_pillar",
			serialization_name: "minecraft:quartz_pillar",
		},
		{
			command_name: "minecraft:quartz_slab",
			name: "minecraft:quartz_slab",
			raw_id: -876,
			serialization_id: "item.quartz_slab",
			serialization_name: "minecraft:quartz_slab",
		},
		{
			command_name: "minecraft:quartz_stairs",
			name: "minecraft:quartz_stairs",
			raw_id: 156,
			serialization_id: "item.quartz_stairs",
			serialization_name: "minecraft:quartz_stairs",
		},
		{
			command_name: "minecraft:rabbit",
			name: "minecraft:rabbit",
			raw_id: 310,
			serialization_id: "item.rabbit",
			serialization_name: "minecraft:rabbit",
		},
		{
			command_name: "minecraft:rabbit_foot",
			name: "minecraft:rabbit_foot",
			raw_id: 561,
			serialization_id: "item.rabbit_foot",
			serialization_name: "minecraft:rabbit_foot",
		},
		{
			command_name: "minecraft:rabbit_hide",
			name: "minecraft:rabbit_hide",
			raw_id: 562,
			serialization_id: "item.rabbit_hide",
			serialization_name: "minecraft:rabbit_hide",
		},
		{
			command_name: "minecraft:rabbit_spawn_egg",
			name: "minecraft:rabbit_spawn_egg",
			raw_id: 486,
			serialization_id: "item.rabbit_spawn_egg",
			serialization_name: "minecraft:rabbit_spawn_egg",
		},
		{
			command_name: "minecraft:rabbit_stew",
			name: "minecraft:rabbit_stew",
			raw_id: 312,
			serialization_id: "item.rabbit_stew",
			serialization_name: "minecraft:rabbit_stew",
		},
		{
			command_name: "minecraft:rail",
			name: "minecraft:rail",
			raw_id: 66,
			serialization_id: "item.rail",
			serialization_name: "minecraft:rail",
		},
		{
			command_name: "minecraft:raiser_armor_trim_smithing_template",
			name: "minecraft:raiser_armor_trim_smithing_template",
			raw_id: 730,
			serialization_id: "item.raiser_armor_trim_smithing_template",
			serialization_name: "minecraft:raiser_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:ravager_spawn_egg",
			name: "minecraft:ravager_spawn_egg",
			raw_id: 521,
			serialization_id: "item.ravager_spawn_egg",
			serialization_name: "minecraft:ravager_spawn_egg",
		},
		{
			command_name: "minecraft:raw_copper",
			name: "minecraft:raw_copper",
			raw_id: 541,
			serialization_id: "item.raw_copper",
			serialization_name: "minecraft:raw_copper",
		},
		{
			command_name: "minecraft:raw_copper_block",
			name: "minecraft:raw_copper_block",
			raw_id: -452,
			serialization_id: "item.raw_copper_block",
			serialization_name: "minecraft:raw_copper_block",
		},
		{
			command_name: "minecraft:raw_gold",
			name: "minecraft:raw_gold",
			raw_id: 540,
			serialization_id: "item.raw_gold",
			serialization_name: "minecraft:raw_gold",
		},
		{
			command_name: "minecraft:raw_gold_block",
			name: "minecraft:raw_gold_block",
			raw_id: -453,
			serialization_id: "item.raw_gold_block",
			serialization_name: "minecraft:raw_gold_block",
		},
		{
			command_name: "minecraft:raw_iron",
			name: "minecraft:raw_iron",
			raw_id: 539,
			serialization_id: "item.raw_iron",
			serialization_name: "minecraft:raw_iron",
		},
		{
			command_name: "minecraft:raw_iron_block",
			name: "minecraft:raw_iron_block",
			raw_id: -451,
			serialization_id: "item.raw_iron_block",
			serialization_name: "minecraft:raw_iron_block",
		},
		{
			command_name: "minecraft:recovery_compass",
			name: "minecraft:recovery_compass",
			raw_id: 682,
			serialization_id: "item.recovery_compass",
			serialization_name: "minecraft:recovery_compass",
		},
		{
			command_name: "minecraft:red_bundle",
			name: "minecraft:red_bundle",
			raw_id: 271,
			serialization_id: "item.red_bundle",
			serialization_name: "minecraft:red_bundle",
		},
		{
			command_name: "minecraft:red_candle",
			name: "minecraft:red_candle",
			raw_id: -427,
			serialization_id: "item.red_candle",
			serialization_name: "minecraft:red_candle",
		},
		{
			command_name: "minecraft:red_carpet",
			name: "minecraft:red_carpet",
			raw_id: -610,
			serialization_id: "item.red_carpet",
			serialization_name: "minecraft:red_carpet",
		},
		{
			command_name: "minecraft:red_concrete",
			name: "minecraft:red_concrete",
			raw_id: -641,
			serialization_id: "item.red_concrete",
			serialization_name: "minecraft:red_concrete",
		},
		{
			command_name: "minecraft:red_concrete_powder",
			name: "minecraft:red_concrete_powder",
			raw_id: -722,
			serialization_id: "item.red_concrete_powder",
			serialization_name: "minecraft:red_concrete_powder",
		},
		{
			command_name: "minecraft:red_dye",
			name: "minecraft:red_dye",
			raw_id: 422,
			serialization_id: "item.red_dye",
			serialization_name: "minecraft:red_dye",
		},
		{
			command_name: "minecraft:red_glazed_terracotta",
			name: "minecraft:red_glazed_terracotta",
			raw_id: 234,
			serialization_id: "item.red_glazed_terracotta",
			serialization_name: "minecraft:red_glazed_terracotta",
		},
		{
			command_name: "minecraft:red_mushroom",
			name: "minecraft:red_mushroom",
			raw_id: 40,
			serialization_id: "item.red_mushroom",
			serialization_name: "minecraft:red_mushroom",
		},
		{
			command_name: "minecraft:red_mushroom_block",
			name: "minecraft:red_mushroom_block",
			raw_id: 100,
			serialization_id: "item.red_mushroom_block",
			serialization_name: "minecraft:red_mushroom_block",
		},
		{
			command_name: "minecraft:red_nether_brick",
			name: "minecraft:red_nether_brick",
			raw_id: 215,
			serialization_id: "item.red_nether_brick",
			serialization_name: "minecraft:red_nether_brick",
		},
		{
			command_name: "minecraft:red_nether_brick_slab",
			name: "minecraft:red_nether_brick_slab",
			raw_id: -890,
			serialization_id: "item.red_nether_brick_slab",
			serialization_name: "minecraft:red_nether_brick_slab",
		},
		{
			command_name: "minecraft:red_nether_brick_stairs",
			name: "minecraft:red_nether_brick_stairs",
			raw_id: -184,
			serialization_id: "item.red_nether_brick_stairs",
			serialization_name: "minecraft:red_nether_brick_stairs",
		},
		{
			command_name: "minecraft:red_nether_brick_wall",
			name: "minecraft:red_nether_brick_wall",
			raw_id: -983,
			serialization_id: "item.red_nether_brick_wall",
			serialization_name: "minecraft:red_nether_brick_wall",
		},
		{
			command_name: "minecraft:red_sand",
			name: "minecraft:red_sand",
			raw_id: -949,
			serialization_id: "item.red_sand",
			serialization_name: "minecraft:red_sand",
		},
		{
			command_name: "minecraft:red_sandstone",
			name: "minecraft:red_sandstone",
			raw_id: 179,
			serialization_id: "item.red_sandstone",
			serialization_name: "minecraft:red_sandstone",
		},
		{
			command_name: "minecraft:red_sandstone_slab",
			name: "minecraft:red_sandstone_slab",
			raw_id: 182,
			serialization_id: "item.red_sandstone_slab",
			serialization_name: "minecraft:red_sandstone_slab",
		},
		{
			command_name: "minecraft:red_sandstone_stairs",
			name: "minecraft:red_sandstone_stairs",
			raw_id: 180,
			serialization_id: "item.red_sandstone_stairs",
			serialization_name: "minecraft:red_sandstone_stairs",
		},
		{
			command_name: "minecraft:red_sandstone_wall",
			name: "minecraft:red_sandstone_wall",
			raw_id: -982,
			serialization_id: "item.red_sandstone_wall",
			serialization_name: "minecraft:red_sandstone_wall",
		},
		{
			command_name: "minecraft:red_shulker_box",
			name: "minecraft:red_shulker_box",
			raw_id: -626,
			serialization_id: "item.red_shulker_box",
			serialization_name: "minecraft:red_shulker_box",
		},
		{
			command_name: "minecraft:red_stained_glass",
			name: "minecraft:red_stained_glass",
			raw_id: -686,
			serialization_id: "item.red_stained_glass",
			serialization_name: "minecraft:red_stained_glass",
		},
		{
			command_name: "minecraft:red_stained_glass_pane",
			name: "minecraft:red_stained_glass_pane",
			raw_id: -656,
			serialization_id: "item.red_stained_glass_pane",
			serialization_name: "minecraft:red_stained_glass_pane",
		},
		{
			command_name: "minecraft:red_terracotta",
			name: "minecraft:red_terracotta",
			raw_id: -737,
			serialization_id: "item.red_terracotta",
			serialization_name: "minecraft:red_terracotta",
		},
		{
			command_name: "minecraft:red_tulip",
			name: "minecraft:red_tulip",
			raw_id: -833,
			serialization_id: "item.red_tulip",
			serialization_name: "minecraft:red_tulip",
		},
		{
			command_name: "minecraft:red_wool",
			name: "minecraft:red_wool",
			raw_id: -556,
			serialization_id: "item.red_wool",
			serialization_name: "minecraft:red_wool",
		},
		{
			command_name: "minecraft:redstone",
			name: "minecraft:redstone",
			raw_id: 398,
			serialization_id: "item.redstone",
			serialization_name: "minecraft:redstone",
		},
		{
			command_name: "minecraft:redstone_block",
			name: "minecraft:redstone_block",
			raw_id: 152,
			serialization_id: "item.redstone_block",
			serialization_name: "minecraft:redstone_block",
		},
		{
			command_name: "minecraft:redstone_lamp",
			name: "minecraft:redstone_lamp",
			raw_id: 123,
			serialization_id: "item.redstone_lamp",
			serialization_name: "minecraft:redstone_lamp",
		},
		{
			command_name: "minecraft:redstone_ore",
			name: "minecraft:redstone_ore",
			raw_id: 73,
			serialization_id: "item.redstone_ore",
			serialization_name: "minecraft:redstone_ore",
		},
		{
			command_name: "minecraft:redstone_torch",
			name: "minecraft:redstone_torch",
			raw_id: 76,
			serialization_id: "item.redstone_torch",
			serialization_name: "minecraft:redstone_torch",
		},
		{
			command_name: "minecraft:reinforced_deepslate",
			name: "minecraft:reinforced_deepslate",
			raw_id: -466,
			serialization_id: "item.reinforced_deepslate",
			serialization_name: "minecraft:reinforced_deepslate",
		},
		{
			command_name: "minecraft:repeater",
			name: "minecraft:repeater",
			raw_id: 445,
			serialization_id: "item.repeater",
			serialization_name: "minecraft:repeater",
		},
		{
			command_name: "minecraft:repeating_command_block",
			name: "minecraft:repeating_command_block",
			raw_id: 188,
			serialization_id: "item.repeating_command_block",
			serialization_name: "minecraft:repeating_command_block",
		},
		{
			command_name: "minecraft:respawn_anchor",
			name: "minecraft:respawn_anchor",
			raw_id: -272,
			serialization_id: "item.respawn_anchor",
			serialization_name: "minecraft:respawn_anchor",
		},
		{
			command_name: "minecraft:rib_armor_trim_smithing_template",
			name: "minecraft:rib_armor_trim_smithing_template",
			raw_id: 726,
			serialization_id: "item.rib_armor_trim_smithing_template",
			serialization_name: "minecraft:rib_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:rose_bush",
			name: "minecraft:rose_bush",
			raw_id: -866,
			serialization_id: "item.rose_bush",
			serialization_name: "minecraft:rose_bush",
		},
		{
			command_name: "minecraft:rotten_flesh",
			name: "minecraft:rotten_flesh",
			raw_id: 299,
			serialization_id: "item.rotten_flesh",
			serialization_name: "minecraft:rotten_flesh",
		},
		{
			command_name: "minecraft:saddle",
			name: "minecraft:saddle",
			raw_id: 396,
			serialization_id: "item.saddle",
			serialization_name: "minecraft:saddle",
		},
		{
			command_name: "minecraft:salmon",
			name: "minecraft:salmon",
			raw_id: 287,
			serialization_id: "item.salmon",
			serialization_name: "minecraft:salmon",
		},
		{
			command_name: "minecraft:salmon_bucket",
			name: "minecraft:salmon_bucket",
			raw_id: 390,
			serialization_id: "item.salmon_bucket",
			serialization_name: "minecraft:salmon_bucket",
		},
		{
			command_name: "minecraft:salmon_spawn_egg",
			name: "minecraft:salmon_spawn_egg",
			raw_id: 510,
			serialization_id: "item.salmon_spawn_egg",
			serialization_name: "minecraft:salmon_spawn_egg",
		},
		{
			command_name: "minecraft:sand",
			name: "minecraft:sand",
			raw_id: 12,
			serialization_id: "item.sand",
			serialization_name: "minecraft:sand",
		},
		{
			command_name: "minecraft:sandstone",
			name: "minecraft:sandstone",
			raw_id: 24,
			serialization_id: "item.sandstone",
			serialization_name: "minecraft:sandstone",
		},
		{
			command_name: "minecraft:sandstone_slab",
			name: "minecraft:sandstone_slab",
			raw_id: -872,
			serialization_id: "item.sandstone_slab",
			serialization_name: "minecraft:sandstone_slab",
		},
		{
			command_name: "minecraft:sandstone_stairs",
			name: "minecraft:sandstone_stairs",
			raw_id: 128,
			serialization_id: "item.sandstone_stairs",
			serialization_name: "minecraft:sandstone_stairs",
		},
		{
			command_name: "minecraft:sandstone_wall",
			name: "minecraft:sandstone_wall",
			raw_id: -975,
			serialization_id: "item.sandstone_wall",
			serialization_name: "minecraft:sandstone_wall",
		},
		{
			command_name: "minecraft:scaffolding",
			name: "minecraft:scaffolding",
			raw_id: -165,
			serialization_id: "item.scaffolding",
			serialization_name: "minecraft:scaffolding",
		},
		{
			command_name: "minecraft:scrape_pottery_sherd",
			name: "minecraft:scrape_pottery_sherd",
			raw_id: 710,
			serialization_id: "item.scrape_pottery_sherd",
			serialization_name: "minecraft:scrape_pottery_sherd",
		},
		{
			command_name: "minecraft:sculk",
			name: "minecraft:sculk",
			raw_id: -458,
			serialization_id: "item.sculk",
			serialization_name: "minecraft:sculk",
		},
		{
			command_name: "minecraft:sculk_catalyst",
			name: "minecraft:sculk_catalyst",
			raw_id: -460,
			serialization_id: "item.sculk_catalyst",
			serialization_name: "minecraft:sculk_catalyst",
		},
		{
			command_name: "minecraft:sculk_sensor",
			name: "minecraft:sculk_sensor",
			raw_id: -307,
			serialization_id: "item.sculk_sensor",
			serialization_name: "minecraft:sculk_sensor",
		},
		{
			command_name: "minecraft:sculk_shrieker",
			name: "minecraft:sculk_shrieker",
			raw_id: -461,
			serialization_id: "item.sculk_shrieker",
			serialization_name: "minecraft:sculk_shrieker",
		},
		{
			command_name: "minecraft:sculk_vein",
			name: "minecraft:sculk_vein",
			raw_id: -459,
			serialization_id: "item.sculk_vein",
			serialization_name: "minecraft:sculk_vein",
		},
		{
			command_name: "minecraft:sea_lantern",
			name: "minecraft:sea_lantern",
			raw_id: 169,
			serialization_id: "item.sea_lantern",
			serialization_name: "minecraft:sea_lantern",
		},
		{
			command_name: "minecraft:sea_pickle",
			name: "minecraft:sea_pickle",
			raw_id: -156,
			serialization_id: "item.sea_pickle",
			serialization_name: "minecraft:sea_pickle",
		},
		{
			command_name: "minecraft:seagrass",
			name: "minecraft:seagrass",
			raw_id: -130,
			serialization_id: "item.seagrass",
			serialization_name: "minecraft:seagrass",
		},
		{
			command_name: "minecraft:sentry_armor_trim_smithing_template",
			name: "minecraft:sentry_armor_trim_smithing_template",
			raw_id: 717,
			serialization_id: "item.sentry_armor_trim_smithing_template",
			serialization_name: "minecraft:sentry_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:shaper_armor_trim_smithing_template",
			name: "minecraft:shaper_armor_trim_smithing_template",
			raw_id: 731,
			serialization_id: "item.shaper_armor_trim_smithing_template",
			serialization_name: "minecraft:shaper_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:sheaf_pottery_sherd",
			name: "minecraft:sheaf_pottery_sherd",
			raw_id: 711,
			serialization_id: "item.sheaf_pottery_sherd",
			serialization_name: "minecraft:sheaf_pottery_sherd",
		},
		{
			command_name: "minecraft:shears",
			name: "minecraft:shears",
			raw_id: 447,
			serialization_id: "item.shears",
			serialization_name: "minecraft:shears",
		},
		{
			command_name: "minecraft:sheep_spawn_egg",
			name: "minecraft:sheep_spawn_egg",
			raw_id: 465,
			serialization_id: "item.sheep_spawn_egg",
			serialization_name: "minecraft:sheep_spawn_egg",
		},
		{
			command_name: "minecraft:shelter_pottery_sherd",
			name: "minecraft:shelter_pottery_sherd",
			raw_id: 712,
			serialization_id: "item.shelter_pottery_sherd",
			serialization_name: "minecraft:shelter_pottery_sherd",
		},
		{
			command_name: "minecraft:shield",
			name: "minecraft:shield",
			raw_id: 380,
			serialization_id: "item.shield",
			serialization_name: "minecraft:shield",
		},
		{
			command_name: "minecraft:short_grass",
			name: "minecraft:short_grass",
			raw_id: 31,
			serialization_id: "item.short_grass",
			serialization_name: "minecraft:short_grass",
		},
		{
			command_name: "minecraft:shroomlight",
			name: "minecraft:shroomlight",
			raw_id: -230,
			serialization_id: "item.shroomlight",
			serialization_name: "minecraft:shroomlight",
		},
		{
			command_name: "minecraft:shulker_shell",
			name: "minecraft:shulker_shell",
			raw_id: 599,
			serialization_id: "item.shulker_shell",
			serialization_name: "minecraft:shulker_shell",
		},
		{
			command_name: "minecraft:shulker_spawn_egg",
			name: "minecraft:shulker_spawn_egg",
			raw_id: 497,
			serialization_id: "item.shulker_spawn_egg",
			serialization_name: "minecraft:shulker_spawn_egg",
		},
		{
			command_name: "minecraft:silence_armor_trim_smithing_template",
			name: "minecraft:silence_armor_trim_smithing_template",
			raw_id: 728,
			serialization_id: "item.silence_armor_trim_smithing_template",
			serialization_name: "minecraft:silence_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:silver_glazed_terracotta",
			name: "minecraft:silver_glazed_terracotta",
			raw_id: 228,
			serialization_id: "item.silver_glazed_terracotta",
			serialization_name: "minecraft:silver_glazed_terracotta",
		},
		{
			command_name: "minecraft:silverfish_spawn_egg",
			name: "minecraft:silverfish_spawn_egg",
			raw_id: 470,
			serialization_id: "item.silverfish_spawn_egg",
			serialization_name: "minecraft:silverfish_spawn_egg",
		},
		{
			command_name: "minecraft:skeleton_horse_spawn_egg",
			name: "minecraft:skeleton_horse_spawn_egg",
			raw_id: 495,
			serialization_id: "item.skeleton_horse_spawn_egg",
			serialization_name: "minecraft:skeleton_horse_spawn_egg",
		},
		{
			command_name: "minecraft:skeleton_skull",
			name: "minecraft:skeleton_skull",
			raw_id: 144,
			serialization_id: "item.skeleton_skull",
			serialization_name: "minecraft:skeleton_skull",
		},
		{
			command_name: "minecraft:skeleton_spawn_egg",
			name: "minecraft:skeleton_spawn_egg",
			raw_id: 471,
			serialization_id: "item.skeleton_spawn_egg",
			serialization_name: "minecraft:skeleton_spawn_egg",
		},
		{
			command_name: "minecraft:skull_banner_pattern",
			name: "minecraft:skull_banner_pattern",
			raw_id: 616,
			serialization_id: "item.skull_banner_pattern",
			serialization_name: "minecraft:skull_banner_pattern",
		},
		{
			command_name: "minecraft:skull_pottery_sherd",
			name: "minecraft:skull_pottery_sherd",
			raw_id: 713,
			serialization_id: "item.skull_pottery_sherd",
			serialization_name: "minecraft:skull_pottery_sherd",
		},
		{
			command_name: "minecraft:slime",
			name: "minecraft:slime",
			raw_id: 165,
			serialization_id: "item.slime",
			serialization_name: "minecraft:slime",
		},
		{
			command_name: "minecraft:slime_ball",
			name: "minecraft:slime_ball",
			raw_id: 414,
			serialization_id: "item.slime_ball",
			serialization_name: "minecraft:slime_ball",
		},
		{
			command_name: "minecraft:slime_spawn_egg",
			name: "minecraft:slime_spawn_egg",
			raw_id: 472,
			serialization_id: "item.slime_spawn_egg",
			serialization_name: "minecraft:slime_spawn_egg",
		},
		{
			command_name: "minecraft:small_amethyst_bud",
			name: "minecraft:small_amethyst_bud",
			raw_id: -332,
			serialization_id: "item.small_amethyst_bud",
			serialization_name: "minecraft:small_amethyst_bud",
		},
		{
			command_name: "minecraft:small_dripleaf_block",
			name: "minecraft:small_dripleaf_block",
			raw_id: -336,
			serialization_id: "item.small_dripleaf_block",
			serialization_name: "minecraft:small_dripleaf_block",
		},
		{
			command_name: "minecraft:smithing_table",
			name: "minecraft:smithing_table",
			raw_id: -202,
			serialization_id: "item.smithing_table",
			serialization_name: "minecraft:smithing_table",
		},
		{
			command_name: "minecraft:smoker",
			name: "minecraft:smoker",
			raw_id: -198,
			serialization_id: "item.smoker",
			serialization_name: "minecraft:smoker",
		},
		{
			command_name: "minecraft:smooth_basalt",
			name: "minecraft:smooth_basalt",
			raw_id: -377,
			serialization_id: "item.smooth_basalt",
			serialization_name: "minecraft:smooth_basalt",
		},
		{
			command_name: "minecraft:smooth_quartz",
			name: "minecraft:smooth_quartz",
			raw_id: -955,
			serialization_id: "item.smooth_quartz",
			serialization_name: "minecraft:smooth_quartz",
		},
		{
			command_name: "minecraft:smooth_quartz_slab",
			name: "minecraft:smooth_quartz_slab",
			raw_id: -898,
			serialization_id: "item.smooth_quartz_slab",
			serialization_name: "minecraft:smooth_quartz_slab",
		},
		{
			command_name: "minecraft:smooth_quartz_stairs",
			name: "minecraft:smooth_quartz_stairs",
			raw_id: -185,
			serialization_id: "item.smooth_quartz_stairs",
			serialization_name: "minecraft:smooth_quartz_stairs",
		},
		{
			command_name: "minecraft:smooth_red_sandstone",
			name: "minecraft:smooth_red_sandstone",
			raw_id: -958,
			serialization_id: "item.smooth_red_sandstone",
			serialization_name: "minecraft:smooth_red_sandstone",
		},
		{
			command_name: "minecraft:smooth_red_sandstone_slab",
			name: "minecraft:smooth_red_sandstone_slab",
			raw_id: -891,
			serialization_id: "item.smooth_red_sandstone_slab",
			serialization_name: "minecraft:smooth_red_sandstone_slab",
		},
		{
			command_name: "minecraft:smooth_red_sandstone_stairs",
			name: "minecraft:smooth_red_sandstone_stairs",
			raw_id: -176,
			serialization_id: "item.smooth_red_sandstone_stairs",
			serialization_name: "minecraft:smooth_red_sandstone_stairs",
		},
		{
			command_name: "minecraft:smooth_sandstone",
			name: "minecraft:smooth_sandstone",
			raw_id: -946,
			serialization_id: "item.smooth_sandstone",
			serialization_name: "minecraft:smooth_sandstone",
		},
		{
			command_name: "minecraft:smooth_sandstone_slab",
			name: "minecraft:smooth_sandstone_slab",
			raw_id: -889,
			serialization_id: "item.smooth_sandstone_slab",
			serialization_name: "minecraft:smooth_sandstone_slab",
		},
		{
			command_name: "minecraft:smooth_sandstone_stairs",
			name: "minecraft:smooth_sandstone_stairs",
			raw_id: -177,
			serialization_id: "item.smooth_sandstone_stairs",
			serialization_name: "minecraft:smooth_sandstone_stairs",
		},
		{
			command_name: "minecraft:smooth_stone",
			name: "minecraft:smooth_stone",
			raw_id: -183,
			serialization_id: "item.smooth_stone",
			serialization_name: "minecraft:smooth_stone",
		},
		{
			command_name: "minecraft:smooth_stone_slab",
			name: "minecraft:smooth_stone_slab",
			raw_id: 44,
			serialization_id: "item.smooth_stone_slab",
			serialization_name: "minecraft:smooth_stone_slab",
		},
		{
			command_name: "minecraft:sniffer_egg",
			name: "minecraft:sniffer_egg",
			raw_id: -596,
			serialization_id: "item.sniffer_egg",
			serialization_name: "minecraft:sniffer_egg",
		},
		{
			command_name: "minecraft:sniffer_spawn_egg",
			name: "minecraft:sniffer_spawn_egg",
			raw_id: 528,
			serialization_id: "item.sniffer_spawn_egg",
			serialization_name: "minecraft:sniffer_spawn_egg",
		},
		{
			command_name: "minecraft:snort_pottery_sherd",
			name: "minecraft:snort_pottery_sherd",
			raw_id: 714,
			serialization_id: "item.snort_pottery_sherd",
			serialization_name: "minecraft:snort_pottery_sherd",
		},
		{
			command_name: "minecraft:snout_armor_trim_smithing_template",
			name: "minecraft:snout_armor_trim_smithing_template",
			raw_id: 725,
			serialization_id: "item.snout_armor_trim_smithing_template",
			serialization_name: "minecraft:snout_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:snow",
			name: "minecraft:snow",
			raw_id: 80,
			serialization_id: "item.snow",
			serialization_name: "minecraft:snow",
		},
		{
			command_name: "minecraft:snow_golem_spawn_egg",
			name: "minecraft:snow_golem_spawn_egg",
			raw_id: 534,
			serialization_id: "item.snow_golem_spawn_egg",
			serialization_name: "minecraft:snow_golem_spawn_egg",
		},
		{
			command_name: "minecraft:snow_layer",
			name: "minecraft:snow_layer",
			raw_id: 78,
			serialization_id: "item.snow_layer",
			serialization_name: "minecraft:snow_layer",
		},
		{
			command_name: "minecraft:snowball",
			name: "minecraft:snowball",
			raw_id: 399,
			serialization_id: "item.snowball",
			serialization_name: "minecraft:snowball",
		},
		{
			command_name: "minecraft:soul_campfire",
			name: "minecraft:soul_campfire",
			raw_id: 658,
			serialization_id: "tile.soul_campfire",
			serialization_name: "minecraft:soul_campfire",
		},
		{
			command_name: "minecraft:soul_lantern",
			name: "minecraft:soul_lantern",
			raw_id: -269,
			serialization_id: "item.soul_lantern",
			serialization_name: "minecraft:soul_lantern",
		},
		{
			command_name: "minecraft:soul_sand",
			name: "minecraft:soul_sand",
			raw_id: 88,
			serialization_id: "item.soul_sand",
			serialization_name: "minecraft:soul_sand",
		},
		{
			command_name: "minecraft:soul_soil",
			name: "minecraft:soul_soil",
			raw_id: -236,
			serialization_id: "item.soul_soil",
			serialization_name: "minecraft:soul_soil",
		},
		{
			command_name: "minecraft:soul_torch",
			name: "minecraft:soul_torch",
			raw_id: -268,
			serialization_id: "item.soul_torch",
			serialization_name: "minecraft:soul_torch",
		},
		{
			command_name: "minecraft:spider_eye",
			name: "minecraft:spider_eye",
			raw_id: 300,
			serialization_id: "item.spider_eye",
			serialization_name: "minecraft:spider_eye",
		},
		{
			command_name: "minecraft:spider_spawn_egg",
			name: "minecraft:spider_spawn_egg",
			raw_id: 473,
			serialization_id: "item.spider_spawn_egg",
			serialization_name: "minecraft:spider_spawn_egg",
		},
		{
			command_name: "minecraft:spire_armor_trim_smithing_template",
			name: "minecraft:spire_armor_trim_smithing_template",
			raw_id: 727,
			serialization_id: "item.spire_armor_trim_smithing_template",
			serialization_name: "minecraft:spire_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:splash_potion",
			name: "minecraft:splash_potion",
			raw_id: 594,
			serialization_id: "item.splash_potion",
			serialization_name: "minecraft:splash_potion",
		},
		{
			command_name: "minecraft:sponge",
			name: "minecraft:sponge",
			raw_id: 19,
			serialization_id: "item.sponge",
			serialization_name: "minecraft:sponge",
		},
		{
			command_name: "minecraft:spore_blossom",
			name: "minecraft:spore_blossom",
			raw_id: -321,
			serialization_id: "item.spore_blossom",
			serialization_name: "minecraft:spore_blossom",
		},
		{
			command_name: "minecraft:spruce_boat",
			name: "minecraft:spruce_boat",
			raw_id: 404,
			serialization_id: "item.spruce_boat",
			serialization_name: "minecraft:spruce_boat",
		},
		{
			command_name: "minecraft:spruce_button",
			name: "minecraft:spruce_button",
			raw_id: -144,
			serialization_id: "item.spruce_button",
			serialization_name: "minecraft:spruce_button",
		},
		{
			command_name: "minecraft:spruce_chest_boat",
			name: "minecraft:spruce_chest_boat",
			raw_id: 677,
			serialization_id: "item.spruce_chest_boat",
			serialization_name: "minecraft:spruce_chest_boat",
		},
		{
			command_name: "minecraft:spruce_door",
			name: "minecraft:spruce_door",
			raw_id: 586,
			serialization_id: "item.spruce_door",
			serialization_name: "minecraft:spruce_door",
		},
		{
			command_name: "minecraft:spruce_fence",
			name: "minecraft:spruce_fence",
			raw_id: -579,
			serialization_id: "item.spruce_fence",
			serialization_name: "minecraft:spruce_fence",
		},
		{
			command_name: "minecraft:spruce_fence_gate",
			name: "minecraft:spruce_fence_gate",
			raw_id: 183,
			serialization_id: "item.spruce_fence_gate",
			serialization_name: "minecraft:spruce_fence_gate",
		},
		{
			command_name: "minecraft:spruce_hanging_sign",
			name: "minecraft:spruce_hanging_sign",
			raw_id: -501,
			serialization_id: "item.spruce_hanging_sign",
			serialization_name: "minecraft:spruce_hanging_sign",
		},
		{
			command_name: "minecraft:spruce_leaves",
			name: "minecraft:spruce_leaves",
			raw_id: -800,
			serialization_id: "item.spruce_leaves",
			serialization_name: "minecraft:spruce_leaves",
		},
		{
			command_name: "minecraft:spruce_log",
			name: "minecraft:spruce_log",
			raw_id: -569,
			serialization_id: "item.spruce_log",
			serialization_name: "minecraft:spruce_log",
		},
		{
			command_name: "minecraft:spruce_planks",
			name: "minecraft:spruce_planks",
			raw_id: -739,
			serialization_id: "item.spruce_planks",
			serialization_name: "minecraft:spruce_planks",
		},
		{
			command_name: "minecraft:spruce_pressure_plate",
			name: "minecraft:spruce_pressure_plate",
			raw_id: -154,
			serialization_id: "item.spruce_pressure_plate",
			serialization_name: "minecraft:spruce_pressure_plate",
		},
		{
			command_name: "minecraft:spruce_sapling",
			name: "minecraft:spruce_sapling",
			raw_id: -825,
			serialization_id: "item.spruce_sapling",
			serialization_name: "minecraft:spruce_sapling",
		},
		{
			command_name: "minecraft:spruce_sign",
			name: "minecraft:spruce_sign",
			raw_id: 609,
			serialization_id: "item.spruce_sign",
			serialization_name: "minecraft:spruce_sign",
		},
		{
			command_name: "minecraft:spruce_slab",
			name: "minecraft:spruce_slab",
			raw_id: -804,
			serialization_id: "item.spruce_slab",
			serialization_name: "minecraft:spruce_slab",
		},
		{
			command_name: "minecraft:spruce_stairs",
			name: "minecraft:spruce_stairs",
			raw_id: 134,
			serialization_id: "item.spruce_stairs",
			serialization_name: "minecraft:spruce_stairs",
		},
		{
			command_name: "minecraft:spruce_trapdoor",
			name: "minecraft:spruce_trapdoor",
			raw_id: -149,
			serialization_id: "item.spruce_trapdoor",
			serialization_name: "minecraft:spruce_trapdoor",
		},
		{
			command_name: "minecraft:spruce_wood",
			name: "minecraft:spruce_wood",
			raw_id: -814,
			serialization_id: "item.spruce_wood",
			serialization_name: "minecraft:spruce_wood",
		},
		{
			command_name: "minecraft:spyglass",
			name: "minecraft:spyglass",
			raw_id: 661,
			serialization_id: "item.spyglass",
			serialization_name: "minecraft:spyglass",
		},
		{
			command_name: "minecraft:squid_spawn_egg",
			name: "minecraft:squid_spawn_egg",
			raw_id: 477,
			serialization_id: "item.squid_spawn_egg",
			serialization_name: "minecraft:squid_spawn_egg",
		},
		{
			command_name: "minecraft:stick",
			name: "minecraft:stick",
			raw_id: 345,
			serialization_id: "item.stick",
			serialization_name: "minecraft:stick",
		},
		{
			command_name: "minecraft:sticky_piston",
			name: "minecraft:sticky_piston",
			raw_id: 29,
			serialization_id: "item.sticky_piston",
			serialization_name: "minecraft:sticky_piston",
		},
		{
			command_name: "minecraft:stone",
			name: "minecraft:stone",
			raw_id: 1,
			serialization_id: "item.stone",
			serialization_name: "minecraft:stone",
		},
		{
			command_name: "minecraft:stone_axe",
			name: "minecraft:stone_axe",
			raw_id: 339,
			serialization_id: "item.stone_axe",
			serialization_name: "minecraft:stone_axe",
		},
		{
			command_name: "minecraft:stone_brick_slab",
			name: "minecraft:stone_brick_slab",
			raw_id: -875,
			serialization_id: "item.stone_brick_slab",
			serialization_name: "minecraft:stone_brick_slab",
		},
		{
			command_name: "minecraft:stone_brick_stairs",
			name: "minecraft:stone_brick_stairs",
			raw_id: 109,
			serialization_id: "item.stone_brick_stairs",
			serialization_name: "minecraft:stone_brick_stairs",
		},
		{
			command_name: "minecraft:stone_brick_wall",
			name: "minecraft:stone_brick_wall",
			raw_id: -977,
			serialization_id: "item.stone_brick_wall",
			serialization_name: "minecraft:stone_brick_wall",
		},
		{
			command_name: "minecraft:stone_bricks",
			name: "minecraft:stone_bricks",
			raw_id: 98,
			serialization_id: "item.stone_bricks",
			serialization_name: "minecraft:stone_bricks",
		},
		{
			command_name: "minecraft:stone_button",
			name: "minecraft:stone_button",
			raw_id: 77,
			serialization_id: "item.stone_button",
			serialization_name: "minecraft:stone_button",
		},
		{
			command_name: "minecraft:stone_hoe",
			name: "minecraft:stone_hoe",
			raw_id: 355,
			serialization_id: "item.stone_hoe",
			serialization_name: "minecraft:stone_hoe",
		},
		{
			command_name: "minecraft:stone_pickaxe",
			name: "minecraft:stone_pickaxe",
			raw_id: 338,
			serialization_id: "item.stone_pickaxe",
			serialization_name: "minecraft:stone_pickaxe",
		},
		{
			command_name: "minecraft:stone_pressure_plate",
			name: "minecraft:stone_pressure_plate",
			raw_id: 70,
			serialization_id: "item.stone_pressure_plate",
			serialization_name: "minecraft:stone_pressure_plate",
		},
		{
			command_name: "minecraft:stone_shovel",
			name: "minecraft:stone_shovel",
			raw_id: 337,
			serialization_id: "item.stone_shovel",
			serialization_name: "minecraft:stone_shovel",
		},
		{
			command_name: "minecraft:stone_stairs",
			name: "minecraft:stone_stairs",
			raw_id: 67,
			serialization_id: "item.stone_stairs",
			serialization_name: "minecraft:stone_stairs",
		},
		{
			command_name: "minecraft:stone_sword",
			name: "minecraft:stone_sword",
			raw_id: 336,
			serialization_id: "item.stone_sword",
			serialization_name: "minecraft:stone_sword",
		},
		{
			command_name: "minecraft:stonecutter_block",
			name: "minecraft:stonecutter_block",
			raw_id: -197,
			serialization_id: "item.stonecutter_block",
			serialization_name: "minecraft:stonecutter_block",
		},
		{
			command_name: "minecraft:stray_spawn_egg",
			name: "minecraft:stray_spawn_egg",
			raw_id: 489,
			serialization_id: "item.stray_spawn_egg",
			serialization_name: "minecraft:stray_spawn_egg",
		},
		{
			command_name: "minecraft:strider_spawn_egg",
			name: "minecraft:strider_spawn_egg",
			raw_id: 523,
			serialization_id: "item.strider_spawn_egg",
			serialization_name: "minecraft:strider_spawn_egg",
		},
		{
			command_name: "minecraft:string",
			name: "minecraft:string",
			raw_id: 351,
			serialization_id: "item.string",
			serialization_name: "minecraft:string",
		},
		{
			command_name: "minecraft:stripped_acacia_log",
			name: "minecraft:stripped_acacia_log",
			raw_id: -8,
			serialization_id: "item.stripped_acacia_log",
			serialization_name: "minecraft:stripped_acacia_log",
		},
		{
			command_name: "minecraft:stripped_acacia_wood",
			name: "minecraft:stripped_acacia_wood",
			raw_id: -823,
			serialization_id: "item.stripped_acacia_wood",
			serialization_name: "minecraft:stripped_acacia_wood",
		},
		{
			command_name: "minecraft:stripped_bamboo_block",
			name: "minecraft:stripped_bamboo_block",
			raw_id: -528,
			serialization_id: "item.stripped_bamboo_block",
			serialization_name: "minecraft:stripped_bamboo_block",
		},
		{
			command_name: "minecraft:stripped_birch_log",
			name: "minecraft:stripped_birch_log",
			raw_id: -6,
			serialization_id: "item.stripped_birch_log",
			serialization_name: "minecraft:stripped_birch_log",
		},
		{
			command_name: "minecraft:stripped_birch_wood",
			name: "minecraft:stripped_birch_wood",
			raw_id: -821,
			serialization_id: "item.stripped_birch_wood",
			serialization_name: "minecraft:stripped_birch_wood",
		},
		{
			command_name: "minecraft:stripped_cherry_log",
			name: "minecraft:stripped_cherry_log",
			raw_id: -535,
			serialization_id: "item.stripped_cherry_log",
			serialization_name: "minecraft:stripped_cherry_log",
		},
		{
			command_name: "minecraft:stripped_cherry_wood",
			name: "minecraft:stripped_cherry_wood",
			raw_id: -545,
			serialization_id: "item.stripped_cherry_wood",
			serialization_name: "minecraft:stripped_cherry_wood",
		},
		{
			command_name: "minecraft:stripped_crimson_hyphae",
			name: "minecraft:stripped_crimson_hyphae",
			raw_id: -300,
			serialization_id: "item.stripped_crimson_hyphae",
			serialization_name: "minecraft:stripped_crimson_hyphae",
		},
		{
			command_name: "minecraft:stripped_crimson_stem",
			name: "minecraft:stripped_crimson_stem",
			raw_id: -240,
			serialization_id: "item.stripped_crimson_stem",
			serialization_name: "minecraft:stripped_crimson_stem",
		},
		{
			command_name: "minecraft:stripped_dark_oak_log",
			name: "minecraft:stripped_dark_oak_log",
			raw_id: -9,
			serialization_id: "item.stripped_dark_oak_log",
			serialization_name: "minecraft:stripped_dark_oak_log",
		},
		{
			command_name: "minecraft:stripped_dark_oak_wood",
			name: "minecraft:stripped_dark_oak_wood",
			raw_id: -824,
			serialization_id: "item.stripped_dark_oak_wood",
			serialization_name: "minecraft:stripped_dark_oak_wood",
		},
		{
			command_name: "minecraft:stripped_jungle_log",
			name: "minecraft:stripped_jungle_log",
			raw_id: -7,
			serialization_id: "item.stripped_jungle_log",
			serialization_name: "minecraft:stripped_jungle_log",
		},
		{
			command_name: "minecraft:stripped_jungle_wood",
			name: "minecraft:stripped_jungle_wood",
			raw_id: -822,
			serialization_id: "item.stripped_jungle_wood",
			serialization_name: "minecraft:stripped_jungle_wood",
		},
		{
			command_name: "minecraft:stripped_mangrove_log",
			name: "minecraft:stripped_mangrove_log",
			raw_id: -485,
			serialization_id: "item.stripped_mangrove_log",
			serialization_name: "minecraft:stripped_mangrove_log",
		},
		{
			command_name: "minecraft:stripped_mangrove_wood",
			name: "minecraft:stripped_mangrove_wood",
			raw_id: -498,
			serialization_id: "item.stripped_mangrove_wood",
			serialization_name: "minecraft:stripped_mangrove_wood",
		},
		{
			command_name: "minecraft:stripped_oak_log",
			name: "minecraft:stripped_oak_log",
			raw_id: -10,
			serialization_id: "item.stripped_oak_log",
			serialization_name: "minecraft:stripped_oak_log",
		},
		{
			command_name: "minecraft:stripped_oak_wood",
			name: "minecraft:stripped_oak_wood",
			raw_id: -819,
			serialization_id: "item.stripped_oak_wood",
			serialization_name: "minecraft:stripped_oak_wood",
		},
		{
			command_name: "minecraft:stripped_spruce_log",
			name: "minecraft:stripped_spruce_log",
			raw_id: -5,
			serialization_id: "item.stripped_spruce_log",
			serialization_name: "minecraft:stripped_spruce_log",
		},
		{
			command_name: "minecraft:stripped_spruce_wood",
			name: "minecraft:stripped_spruce_wood",
			raw_id: -820,
			serialization_id: "item.stripped_spruce_wood",
			serialization_name: "minecraft:stripped_spruce_wood",
		},
		{
			command_name: "minecraft:stripped_warped_hyphae",
			name: "minecraft:stripped_warped_hyphae",
			raw_id: -301,
			serialization_id: "item.stripped_warped_hyphae",
			serialization_name: "minecraft:stripped_warped_hyphae",
		},
		{
			command_name: "minecraft:stripped_warped_stem",
			name: "minecraft:stripped_warped_stem",
			raw_id: -241,
			serialization_id: "item.stripped_warped_stem",
			serialization_name: "minecraft:stripped_warped_stem",
		},
		{
			command_name: "minecraft:structure_block",
			name: "minecraft:structure_block",
			raw_id: 252,
			serialization_id: "item.structure_block",
			serialization_name: "minecraft:structure_block",
		},
		{
			command_name: "minecraft:structure_void",
			name: "minecraft:structure_void",
			raw_id: 217,
			serialization_id: "item.structure_void",
			serialization_name: "minecraft:structure_void",
		},
		{
			command_name: "minecraft:sugar",
			name: "minecraft:sugar",
			raw_id: 442,
			serialization_id: "item.sugar",
			serialization_name: "minecraft:sugar",
		},
		{
			command_name: "minecraft:sugar_cane",
			name: "minecraft:sugar_cane",
			raw_id: 411,
			serialization_id: "item.reeds",
			serialization_name: "minecraft:sugar_cane",
		},
		{
			command_name: "minecraft:sunflower",
			name: "minecraft:sunflower",
			raw_id: 175,
			serialization_id: "item.sunflower",
			serialization_name: "minecraft:sunflower",
		},
		{
			command_name: "minecraft:suspicious_gravel",
			name: "minecraft:suspicious_gravel",
			raw_id: -573,
			serialization_id: "item.suspicious_gravel",
			serialization_name: "minecraft:suspicious_gravel",
		},
		{
			command_name: "minecraft:suspicious_sand",
			name: "minecraft:suspicious_sand",
			raw_id: -529,
			serialization_id: "item.suspicious_sand",
			serialization_name: "minecraft:suspicious_sand",
		},
		{
			command_name: "minecraft:suspicious_stew",
			name: "minecraft:suspicious_stew",
			raw_id: 625,
			serialization_id: "item.suspicious_stew",
			serialization_name: "minecraft:suspicious_stew",
		},
		{
			command_name: "minecraft:sweet_berries",
			name: "minecraft:sweet_berries",
			raw_id: 309,
			serialization_id: "item.sweet_berries",
			serialization_name: "minecraft:sweet_berries",
		},
		{
			command_name: "minecraft:tadpole_bucket",
			name: "minecraft:tadpole_bucket",
			raw_id: 666,
			serialization_id: "item.tadpole_bucket",
			serialization_name: "minecraft:tadpole_bucket",
		},
		{
			command_name: "minecraft:tadpole_spawn_egg",
			name: "minecraft:tadpole_spawn_egg",
			raw_id: 665,
			serialization_id: "item.tadpole_spawn_egg",
			serialization_name: "minecraft:tadpole_spawn_egg",
		},
		{
			command_name: "minecraft:tall_grass",
			name: "minecraft:tall_grass",
			raw_id: -864,
			serialization_id: "item.tall_grass",
			serialization_name: "minecraft:tall_grass",
		},
		{
			command_name: "minecraft:target",
			name: "minecraft:target",
			raw_id: -239,
			serialization_id: "item.target",
			serialization_name: "minecraft:target",
		},
		{
			command_name: "minecraft:tide_armor_trim_smithing_template",
			name: "minecraft:tide_armor_trim_smithing_template",
			raw_id: 724,
			serialization_id: "item.tide_armor_trim_smithing_template",
			serialization_name: "minecraft:tide_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:tinted_glass",
			name: "minecraft:tinted_glass",
			raw_id: -334,
			serialization_id: "item.tinted_glass",
			serialization_name: "minecraft:tinted_glass",
		},
		{
			command_name: "minecraft:tnt",
			name: "minecraft:tnt",
			raw_id: 46,
			serialization_id: "item.tnt",
			serialization_name: "minecraft:tnt",
		},
		{
			command_name: "minecraft:tnt_minecart",
			name: "minecraft:tnt_minecart",
			raw_id: 558,
			serialization_id: "item.tnt_minecart",
			serialization_name: "minecraft:tnt_minecart",
		},
		{
			command_name: "minecraft:torch",
			name: "minecraft:torch",
			raw_id: 50,
			serialization_id: "item.torch",
			serialization_name: "minecraft:torch",
		},
		{
			command_name: "minecraft:torchflower",
			name: "minecraft:torchflower",
			raw_id: -568,
			serialization_id: "item.torchflower",
			serialization_name: "minecraft:torchflower",
		},
		{
			command_name: "minecraft:torchflower_seeds",
			name: "minecraft:torchflower_seeds",
			raw_id: 318,
			serialization_id: "item.torchflower_seeds",
			serialization_name: "minecraft:torchflower_seeds",
		},
		{
			command_name: "minecraft:totem_of_undying",
			name: "minecraft:totem_of_undying",
			raw_id: 601,
			serialization_id: "item.totem",
			serialization_name: "minecraft:totem_of_undying",
		},
		{
			command_name: "minecraft:trader_llama_spawn_egg",
			name: "minecraft:trader_llama_spawn_egg",
			raw_id: 684,
			serialization_id: "item.trader_llama_spawn_egg",
			serialization_name: "minecraft:trader_llama_spawn_egg",
		},
		{
			command_name: "minecraft:trapdoor",
			name: "minecraft:trapdoor",
			raw_id: 96,
			serialization_id: "item.trapdoor",
			serialization_name: "minecraft:trapdoor",
		},
		{
			command_name: "minecraft:trapped_chest",
			name: "minecraft:trapped_chest",
			raw_id: 146,
			serialization_id: "item.trapped_chest",
			serialization_name: "minecraft:trapped_chest",
		},
		{
			command_name: "minecraft:trial_key",
			name: "minecraft:trial_key",
			raw_id: 276,
			serialization_id: "item.trial_key.name",
			serialization_name: "minecraft:trial_key",
		},
		{
			command_name: "minecraft:trial_spawner",
			name: "minecraft:trial_spawner",
			raw_id: -315,
			serialization_id: "item.trial_spawner",
			serialization_name: "minecraft:trial_spawner",
		},
		{
			command_name: "minecraft:trident",
			name: "minecraft:trident",
			raw_id: 579,
			serialization_id: "item.trident",
			serialization_name: "minecraft:trident",
		},
		{
			command_name: "minecraft:tripwire_hook",
			name: "minecraft:tripwire_hook",
			raw_id: 131,
			serialization_id: "item.tripwire_hook",
			serialization_name: "minecraft:tripwire_hook",
		},
		{
			command_name: "minecraft:tropical_fish",
			name: "minecraft:tropical_fish",
			raw_id: 288,
			serialization_id: "item.clownfish",
			serialization_name: "minecraft:tropical_fish",
		},
		{
			command_name: "minecraft:tropical_fish_bucket",
			name: "minecraft:tropical_fish_bucket",
			raw_id: 391,
			serialization_id: "item.tropical_fish_bucket",
			serialization_name: "minecraft:tropical_fish_bucket",
		},
		{
			command_name: "minecraft:tropical_fish_spawn_egg",
			name: "minecraft:tropical_fish_spawn_egg",
			raw_id: 507,
			serialization_id: "item.tropical_fish_spawn_egg",
			serialization_name: "minecraft:tropical_fish_spawn_egg",
		},
		{
			command_name: "minecraft:tube_coral",
			name: "minecraft:tube_coral",
			raw_id: -131,
			serialization_id: "item.tube_coral",
			serialization_name: "minecraft:tube_coral",
		},
		{
			command_name: "minecraft:tube_coral_block",
			name: "minecraft:tube_coral_block",
			raw_id: -132,
			serialization_id: "item.tube_coral_block",
			serialization_name: "minecraft:tube_coral_block",
		},
		{
			command_name: "minecraft:tube_coral_fan",
			name: "minecraft:tube_coral_fan",
			raw_id: -133,
			serialization_id: "item.tube_coral_fan",
			serialization_name: "minecraft:tube_coral_fan",
		},
		{
			command_name: "minecraft:tuff",
			name: "minecraft:tuff",
			raw_id: -333,
			serialization_id: "item.tuff",
			serialization_name: "minecraft:tuff",
		},
		{
			command_name: "minecraft:tuff_brick_slab",
			name: "minecraft:tuff_brick_slab",
			raw_id: -755,
			serialization_id: "item.tuff_brick_slab",
			serialization_name: "minecraft:tuff_brick_slab",
		},
		{
			command_name: "minecraft:tuff_brick_stairs",
			name: "minecraft:tuff_brick_stairs",
			raw_id: -757,
			serialization_id: "item.tuff_brick_stairs",
			serialization_name: "minecraft:tuff_brick_stairs",
		},
		{
			command_name: "minecraft:tuff_brick_wall",
			name: "minecraft:tuff_brick_wall",
			raw_id: -758,
			serialization_id: "item.tuff_brick_wall",
			serialization_name: "minecraft:tuff_brick_wall",
		},
		{
			command_name: "minecraft:tuff_bricks",
			name: "minecraft:tuff_bricks",
			raw_id: -754,
			serialization_id: "item.tuff_bricks",
			serialization_name: "minecraft:tuff_bricks",
		},
		{
			command_name: "minecraft:tuff_slab",
			name: "minecraft:tuff_slab",
			raw_id: -744,
			serialization_id: "item.tuff_slab",
			serialization_name: "minecraft:tuff_slab",
		},
		{
			command_name: "minecraft:tuff_stairs",
			name: "minecraft:tuff_stairs",
			raw_id: -746,
			serialization_id: "item.tuff_stairs",
			serialization_name: "minecraft:tuff_stairs",
		},
		{
			command_name: "minecraft:tuff_wall",
			name: "minecraft:tuff_wall",
			raw_id: -747,
			serialization_id: "item.tuff_wall",
			serialization_name: "minecraft:tuff_wall",
		},
		{
			command_name: "minecraft:turtle_egg",
			name: "minecraft:turtle_egg",
			raw_id: -159,
			serialization_id: "item.turtle_egg",
			serialization_name: "minecraft:turtle_egg",
		},
		{
			command_name: "minecraft:turtle_helmet",
			name: "minecraft:turtle_helmet",
			raw_id: 606,
			serialization_id: "item.turtle_helmet",
			serialization_name: "minecraft:turtle_helmet",
		},
		{
			command_name: "minecraft:turtle_scute",
			name: "minecraft:turtle_scute",
			raw_id: 605,
			serialization_id: "item.turtle_shell_piece",
			serialization_name: "minecraft:turtle_scute",
		},
		{
			command_name: "minecraft:turtle_spawn_egg",
			name: "minecraft:turtle_spawn_egg",
			raw_id: 513,
			serialization_id: "item.turtle_spawn_egg",
			serialization_name: "minecraft:turtle_spawn_egg",
		},
		{
			command_name: "minecraft:twisting_vines",
			name: "minecraft:twisting_vines",
			raw_id: -287,
			serialization_id: "item.twisting_vines",
			serialization_name: "minecraft:twisting_vines",
		},
		{
			command_name: "minecraft:undyed_shulker_box",
			name: "minecraft:undyed_shulker_box",
			raw_id: 205,
			serialization_id: "item.undyed_shulker_box",
			serialization_name: "minecraft:undyed_shulker_box",
		},
		{
			command_name: "minecraft:vault",
			name: "minecraft:vault",
			raw_id: -314,
			serialization_id: "item.vault",
			serialization_name: "minecraft:vault",
		},
		{
			command_name: "minecraft:verdant_froglight",
			name: "minecraft:verdant_froglight",
			raw_id: -470,
			serialization_id: "item.verdant_froglight",
			serialization_name: "minecraft:verdant_froglight",
		},
		{
			command_name: "minecraft:vex_armor_trim_smithing_template",
			name: "minecraft:vex_armor_trim_smithing_template",
			raw_id: 723,
			serialization_id: "item.vex_armor_trim_smithing_template",
			serialization_name: "minecraft:vex_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:vex_spawn_egg",
			name: "minecraft:vex_spawn_egg",
			raw_id: 504,
			serialization_id: "item.vex_spawn_egg",
			serialization_name: "minecraft:vex_spawn_egg",
		},
		{
			command_name: "minecraft:villager_spawn_egg",
			name: "minecraft:villager_spawn_egg",
			raw_id: 476,
			serialization_id: "item.villager_spawn_egg",
			serialization_name: "minecraft:villager_spawn_egg",
		},
		{
			command_name: "minecraft:vindicator_spawn_egg",
			name: "minecraft:vindicator_spawn_egg",
			raw_id: 502,
			serialization_id: "item.vindicator_spawn_egg",
			serialization_name: "minecraft:vindicator_spawn_egg",
		},
		{
			command_name: "minecraft:vine",
			name: "minecraft:vine",
			raw_id: 106,
			serialization_id: "item.vine",
			serialization_name: "minecraft:vine",
		},
		{
			command_name: "minecraft:wandering_trader_spawn_egg",
			name: "minecraft:wandering_trader_spawn_egg",
			raw_id: 520,
			serialization_id: "item.wandering_trader_spawn_egg",
			serialization_name: "minecraft:wandering_trader_spawn_egg",
		},
		{
			command_name: "minecraft:ward_armor_trim_smithing_template",
			name: "minecraft:ward_armor_trim_smithing_template",
			raw_id: 721,
			serialization_id: "item.ward_armor_trim_smithing_template",
			serialization_name: "minecraft:ward_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:warden_spawn_egg",
			name: "minecraft:warden_spawn_egg",
			raw_id: 668,
			serialization_id: "item.warden_spawn_egg",
			serialization_name: "minecraft:warden_spawn_egg",
		},
		{
			command_name: "minecraft:warped_button",
			name: "minecraft:warped_button",
			raw_id: -261,
			serialization_id: "item.warped_button",
			serialization_name: "minecraft:warped_button",
		},
		{
			command_name: "minecraft:warped_door",
			name: "minecraft:warped_door",
			raw_id: 653,
			serialization_id: "item.warped_door",
			serialization_name: "minecraft:warped_door",
		},
		{
			command_name: "minecraft:warped_fence",
			name: "minecraft:warped_fence",
			raw_id: -257,
			serialization_id: "item.warped_fence",
			serialization_name: "minecraft:warped_fence",
		},
		{
			command_name: "minecraft:warped_fence_gate",
			name: "minecraft:warped_fence_gate",
			raw_id: -259,
			serialization_id: "item.warped_fence_gate",
			serialization_name: "minecraft:warped_fence_gate",
		},
		{
			command_name: "minecraft:warped_fungus",
			name: "minecraft:warped_fungus",
			raw_id: -229,
			serialization_id: "item.warped_fungus",
			serialization_name: "minecraft:warped_fungus",
		},
		{
			command_name: "minecraft:warped_fungus_on_a_stick",
			name: "minecraft:warped_fungus_on_a_stick",
			raw_id: 654,
			serialization_id: "item.warped_fungus_on_a_stick.name",
			serialization_name: "minecraft:warped_fungus_on_a_stick",
		},
		{
			command_name: "minecraft:warped_hanging_sign",
			name: "minecraft:warped_hanging_sign",
			raw_id: -507,
			serialization_id: "item.warped_hanging_sign",
			serialization_name: "minecraft:warped_hanging_sign",
		},
		{
			command_name: "minecraft:warped_hyphae",
			name: "minecraft:warped_hyphae",
			raw_id: -298,
			serialization_id: "item.warped_hyphae",
			serialization_name: "minecraft:warped_hyphae",
		},
		{
			command_name: "minecraft:warped_nylium",
			name: "minecraft:warped_nylium",
			raw_id: -233,
			serialization_id: "item.warped_nylium",
			serialization_name: "minecraft:warped_nylium",
		},
		{
			command_name: "minecraft:warped_planks",
			name: "minecraft:warped_planks",
			raw_id: -243,
			serialization_id: "item.warped_planks",
			serialization_name: "minecraft:warped_planks",
		},
		{
			command_name: "minecraft:warped_pressure_plate",
			name: "minecraft:warped_pressure_plate",
			raw_id: -263,
			serialization_id: "item.warped_pressure_plate",
			serialization_name: "minecraft:warped_pressure_plate",
		},
		{
			command_name: "minecraft:warped_roots",
			name: "minecraft:warped_roots",
			raw_id: -224,
			serialization_id: "item.warped_roots",
			serialization_name: "minecraft:warped_roots",
		},
		{
			command_name: "minecraft:warped_sign",
			name: "minecraft:warped_sign",
			raw_id: 651,
			serialization_id: "item.warped_sign",
			serialization_name: "minecraft:warped_sign",
		},
		{
			command_name: "minecraft:warped_slab",
			name: "minecraft:warped_slab",
			raw_id: -265,
			serialization_id: "item.warped_slab",
			serialization_name: "minecraft:warped_slab",
		},
		{
			command_name: "minecraft:warped_stairs",
			name: "minecraft:warped_stairs",
			raw_id: -255,
			serialization_id: "item.warped_stairs",
			serialization_name: "minecraft:warped_stairs",
		},
		{
			command_name: "minecraft:warped_stem",
			name: "minecraft:warped_stem",
			raw_id: -226,
			serialization_id: "item.warped_stem",
			serialization_name: "minecraft:warped_stem",
		},
		{
			command_name: "minecraft:warped_trapdoor",
			name: "minecraft:warped_trapdoor",
			raw_id: -247,
			serialization_id: "item.warped_trapdoor",
			serialization_name: "minecraft:warped_trapdoor",
		},
		{
			command_name: "minecraft:warped_wart_block",
			name: "minecraft:warped_wart_block",
			raw_id: -227,
			serialization_id: "item.warped_wart_block",
			serialization_name: "minecraft:warped_wart_block",
		},
		{
			command_name: "minecraft:water_bucket",
			name: "minecraft:water_bucket",
			raw_id: 387,
			serialization_id: "item.water_bucket",
			serialization_name: "minecraft:water_bucket",
		},
		{
			command_name: "minecraft:waterlily",
			name: "minecraft:waterlily",
			raw_id: 111,
			serialization_id: "item.waterlily",
			serialization_name: "minecraft:waterlily",
		},
		{
			command_name: "minecraft:waxed_chiseled_copper",
			name: "minecraft:waxed_chiseled_copper",
			raw_id: -764,
			serialization_id: "item.waxed_chiseled_copper",
			serialization_name: "minecraft:waxed_chiseled_copper",
		},
		{
			command_name: "minecraft:waxed_copper",
			name: "minecraft:waxed_copper",
			raw_id: -344,
			serialization_id: "item.waxed_copper",
			serialization_name: "minecraft:waxed_copper",
		},
		{
			command_name: "minecraft:waxed_copper_bulb",
			name: "minecraft:waxed_copper_bulb",
			raw_id: -780,
			serialization_id: "item.waxed_copper_bulb",
			serialization_name: "minecraft:waxed_copper_bulb",
		},
		{
			command_name: "minecraft:waxed_copper_door",
			name: "minecraft:waxed_copper_door",
			raw_id: -788,
			serialization_id: "item.waxed_copper_door",
			serialization_name: "minecraft:waxed_copper_door",
		},
		{
			command_name: "minecraft:waxed_copper_grate",
			name: "minecraft:waxed_copper_grate",
			raw_id: -772,
			serialization_id: "item.waxed_copper_grate",
			serialization_name: "minecraft:waxed_copper_grate",
		},
		{
			command_name: "minecraft:waxed_copper_trapdoor",
			name: "minecraft:waxed_copper_trapdoor",
			raw_id: -796,
			serialization_id: "item.waxed_copper_trapdoor",
			serialization_name: "minecraft:waxed_copper_trapdoor",
		},
		{
			command_name: "minecraft:waxed_cut_copper",
			name: "minecraft:waxed_cut_copper",
			raw_id: -351,
			serialization_id: "item.waxed_cut_copper",
			serialization_name: "minecraft:waxed_cut_copper",
		},
		{
			command_name: "minecraft:waxed_cut_copper_slab",
			name: "minecraft:waxed_cut_copper_slab",
			raw_id: -365,
			serialization_id: "item.waxed_cut_copper_slab",
			serialization_name: "minecraft:waxed_cut_copper_slab",
		},
		{
			command_name: "minecraft:waxed_cut_copper_stairs",
			name: "minecraft:waxed_cut_copper_stairs",
			raw_id: -358,
			serialization_id: "item.waxed_cut_copper_stairs",
			serialization_name: "minecraft:waxed_cut_copper_stairs",
		},
		{
			command_name: "minecraft:waxed_exposed_chiseled_copper",
			name: "minecraft:waxed_exposed_chiseled_copper",
			raw_id: -765,
			serialization_id: "item.waxed_exposed_chiseled_copper",
			serialization_name: "minecraft:waxed_exposed_chiseled_copper",
		},
		{
			command_name: "minecraft:waxed_exposed_copper",
			name: "minecraft:waxed_exposed_copper",
			raw_id: -345,
			serialization_id: "item.waxed_exposed_copper",
			serialization_name: "minecraft:waxed_exposed_copper",
		},
		{
			command_name: "minecraft:waxed_exposed_copper_bulb",
			name: "minecraft:waxed_exposed_copper_bulb",
			raw_id: -781,
			serialization_id: "item.waxed_exposed_copper_bulb",
			serialization_name: "minecraft:waxed_exposed_copper_bulb",
		},
		{
			command_name: "minecraft:waxed_exposed_copper_door",
			name: "minecraft:waxed_exposed_copper_door",
			raw_id: -789,
			serialization_id: "item.waxed_exposed_copper_door",
			serialization_name: "minecraft:waxed_exposed_copper_door",
		},
		{
			command_name: "minecraft:waxed_exposed_copper_grate",
			name: "minecraft:waxed_exposed_copper_grate",
			raw_id: -773,
			serialization_id: "item.waxed_exposed_copper_grate",
			serialization_name: "minecraft:waxed_exposed_copper_grate",
		},
		{
			command_name: "minecraft:waxed_exposed_copper_trapdoor",
			name: "minecraft:waxed_exposed_copper_trapdoor",
			raw_id: -797,
			serialization_id: "item.waxed_exposed_copper_trapdoor",
			serialization_name: "minecraft:waxed_exposed_copper_trapdoor",
		},
		{
			command_name: "minecraft:waxed_exposed_cut_copper",
			name: "minecraft:waxed_exposed_cut_copper",
			raw_id: -352,
			serialization_id: "item.waxed_exposed_cut_copper",
			serialization_name: "minecraft:waxed_exposed_cut_copper",
		},
		{
			command_name: "minecraft:waxed_exposed_cut_copper_slab",
			name: "minecraft:waxed_exposed_cut_copper_slab",
			raw_id: -366,
			serialization_id: "item.waxed_exposed_cut_copper_slab",
			serialization_name: "minecraft:waxed_exposed_cut_copper_slab",
		},
		{
			command_name: "minecraft:waxed_exposed_cut_copper_stairs",
			name: "minecraft:waxed_exposed_cut_copper_stairs",
			raw_id: -359,
			serialization_id: "item.waxed_exposed_cut_copper_stairs",
			serialization_name: "minecraft:waxed_exposed_cut_copper_stairs",
		},
		{
			command_name: "minecraft:waxed_oxidized_chiseled_copper",
			name: "minecraft:waxed_oxidized_chiseled_copper",
			raw_id: -766,
			serialization_id: "item.waxed_oxidized_chiseled_copper",
			serialization_name: "minecraft:waxed_oxidized_chiseled_copper",
		},
		{
			command_name: "minecraft:waxed_oxidized_copper",
			name: "minecraft:waxed_oxidized_copper",
			raw_id: -446,
			serialization_id: "item.waxed_oxidized_copper",
			serialization_name: "minecraft:waxed_oxidized_copper",
		},
		{
			command_name: "minecraft:waxed_oxidized_copper_bulb",
			name: "minecraft:waxed_oxidized_copper_bulb",
			raw_id: -783,
			serialization_id: "item.waxed_oxidized_copper_bulb",
			serialization_name: "minecraft:waxed_oxidized_copper_bulb",
		},
		{
			command_name: "minecraft:waxed_oxidized_copper_door",
			name: "minecraft:waxed_oxidized_copper_door",
			raw_id: -791,
			serialization_id: "item.waxed_oxidized_copper_door",
			serialization_name: "minecraft:waxed_oxidized_copper_door",
		},
		{
			command_name: "minecraft:waxed_oxidized_copper_grate",
			name: "minecraft:waxed_oxidized_copper_grate",
			raw_id: -775,
			serialization_id: "item.waxed_oxidized_copper_grate",
			serialization_name: "minecraft:waxed_oxidized_copper_grate",
		},
		{
			command_name: "minecraft:waxed_oxidized_copper_trapdoor",
			name: "minecraft:waxed_oxidized_copper_trapdoor",
			raw_id: -799,
			serialization_id: "item.waxed_oxidized_copper_trapdoor",
			serialization_name: "minecraft:waxed_oxidized_copper_trapdoor",
		},
		{
			command_name: "minecraft:waxed_oxidized_cut_copper",
			name: "minecraft:waxed_oxidized_cut_copper",
			raw_id: -447,
			serialization_id: "item.waxed_oxidized_cut_copper",
			serialization_name: "minecraft:waxed_oxidized_cut_copper",
		},
		{
			command_name: "minecraft:waxed_oxidized_cut_copper_slab",
			name: "minecraft:waxed_oxidized_cut_copper_slab",
			raw_id: -449,
			serialization_id: "item.waxed_oxidized_cut_copper_slab",
			serialization_name: "minecraft:waxed_oxidized_cut_copper_slab",
		},
		{
			command_name: "minecraft:waxed_oxidized_cut_copper_stairs",
			name: "minecraft:waxed_oxidized_cut_copper_stairs",
			raw_id: -448,
			serialization_id: "item.waxed_oxidized_cut_copper_stairs",
			serialization_name: "minecraft:waxed_oxidized_cut_copper_stairs",
		},
		{
			command_name: "minecraft:waxed_weathered_chiseled_copper",
			name: "minecraft:waxed_weathered_chiseled_copper",
			raw_id: -767,
			serialization_id: "item.waxed_weathered_chiseled_copper",
			serialization_name: "minecraft:waxed_weathered_chiseled_copper",
		},
		{
			command_name: "minecraft:waxed_weathered_copper",
			name: "minecraft:waxed_weathered_copper",
			raw_id: -346,
			serialization_id: "item.waxed_weathered_copper",
			serialization_name: "minecraft:waxed_weathered_copper",
		},
		{
			command_name: "minecraft:waxed_weathered_copper_bulb",
			name: "minecraft:waxed_weathered_copper_bulb",
			raw_id: -782,
			serialization_id: "item.waxed_weathered_copper_bulb",
			serialization_name: "minecraft:waxed_weathered_copper_bulb",
		},
		{
			command_name: "minecraft:waxed_weathered_copper_door",
			name: "minecraft:waxed_weathered_copper_door",
			raw_id: -790,
			serialization_id: "item.waxed_weathered_copper_door",
			serialization_name: "minecraft:waxed_weathered_copper_door",
		},
		{
			command_name: "minecraft:waxed_weathered_copper_grate",
			name: "minecraft:waxed_weathered_copper_grate",
			raw_id: -774,
			serialization_id: "item.waxed_weathered_copper_grate",
			serialization_name: "minecraft:waxed_weathered_copper_grate",
		},
		{
			command_name: "minecraft:waxed_weathered_copper_trapdoor",
			name: "minecraft:waxed_weathered_copper_trapdoor",
			raw_id: -798,
			serialization_id: "item.waxed_weathered_copper_trapdoor",
			serialization_name: "minecraft:waxed_weathered_copper_trapdoor",
		},
		{
			command_name: "minecraft:waxed_weathered_cut_copper",
			name: "minecraft:waxed_weathered_cut_copper",
			raw_id: -353,
			serialization_id: "item.waxed_weathered_cut_copper",
			serialization_name: "minecraft:waxed_weathered_cut_copper",
		},
		{
			command_name: "minecraft:waxed_weathered_cut_copper_slab",
			name: "minecraft:waxed_weathered_cut_copper_slab",
			raw_id: -367,
			serialization_id: "item.waxed_weathered_cut_copper_slab",
			serialization_name: "minecraft:waxed_weathered_cut_copper_slab",
		},
		{
			command_name: "minecraft:waxed_weathered_cut_copper_stairs",
			name: "minecraft:waxed_weathered_cut_copper_stairs",
			raw_id: -360,
			serialization_id: "item.waxed_weathered_cut_copper_stairs",
			serialization_name: "minecraft:waxed_weathered_cut_copper_stairs",
		},
		{
			command_name: "minecraft:wayfinder_armor_trim_smithing_template",
			name: "minecraft:wayfinder_armor_trim_smithing_template",
			raw_id: 729,
			serialization_id: "item.wayfinder_armor_trim_smithing_template",
			serialization_name: "minecraft:wayfinder_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:weathered_chiseled_copper",
			name: "minecraft:weathered_chiseled_copper",
			raw_id: -762,
			serialization_id: "item.weathered_chiseled_copper",
			serialization_name: "minecraft:weathered_chiseled_copper",
		},
		{
			command_name: "minecraft:weathered_copper",
			name: "minecraft:weathered_copper",
			raw_id: -342,
			serialization_id: "item.weathered_copper",
			serialization_name: "minecraft:weathered_copper",
		},
		{
			command_name: "minecraft:weathered_copper_bulb",
			name: "minecraft:weathered_copper_bulb",
			raw_id: -778,
			serialization_id: "item.weathered_copper_bulb",
			serialization_name: "minecraft:weathered_copper_bulb",
		},
		{
			command_name: "minecraft:weathered_copper_door",
			name: "minecraft:weathered_copper_door",
			raw_id: -786,
			serialization_id: "item.weathered_copper_door",
			serialization_name: "minecraft:weathered_copper_door",
		},
		{
			command_name: "minecraft:weathered_copper_grate",
			name: "minecraft:weathered_copper_grate",
			raw_id: -770,
			serialization_id: "item.weathered_copper_grate",
			serialization_name: "minecraft:weathered_copper_grate",
		},
		{
			command_name: "minecraft:weathered_copper_trapdoor",
			name: "minecraft:weathered_copper_trapdoor",
			raw_id: -794,
			serialization_id: "item.weathered_copper_trapdoor",
			serialization_name: "minecraft:weathered_copper_trapdoor",
		},
		{
			command_name: "minecraft:weathered_cut_copper",
			name: "minecraft:weathered_cut_copper",
			raw_id: -349,
			serialization_id: "item.weathered_cut_copper",
			serialization_name: "minecraft:weathered_cut_copper",
		},
		{
			command_name: "minecraft:weathered_cut_copper_slab",
			name: "minecraft:weathered_cut_copper_slab",
			raw_id: -363,
			serialization_id: "item.weathered_cut_copper_slab",
			serialization_name: "minecraft:weathered_cut_copper_slab",
		},
		{
			command_name: "minecraft:weathered_cut_copper_stairs",
			name: "minecraft:weathered_cut_copper_stairs",
			raw_id: -356,
			serialization_id: "item.weathered_cut_copper_stairs",
			serialization_name: "minecraft:weathered_cut_copper_stairs",
		},
		{
			command_name: "minecraft:web",
			name: "minecraft:web",
			raw_id: 30,
			serialization_id: "item.web",
			serialization_name: "minecraft:web",
		},
		{
			command_name: "minecraft:weeping_vines",
			name: "minecraft:weeping_vines",
			raw_id: -231,
			serialization_id: "item.weeping_vines",
			serialization_name: "minecraft:weeping_vines",
		},
		{
			command_name: "minecraft:wet_sponge",
			name: "minecraft:wet_sponge",
			raw_id: -984,
			serialization_id: "item.wet_sponge",
			serialization_name: "minecraft:wet_sponge",
		},
		{
			command_name: "minecraft:wheat",
			name: "minecraft:wheat",
			raw_id: 359,
			serialization_id: "item.wheat",
			serialization_name: "minecraft:wheat",
		},
		{
			command_name: "minecraft:wheat_seeds",
			name: "minecraft:wheat_seeds",
			raw_id: 313,
			serialization_id: "item.wheat_seeds",
			serialization_name: "minecraft:wheat_seeds",
		},
		{
			command_name: "minecraft:white_bundle",
			name: "minecraft:white_bundle",
			raw_id: 272,
			serialization_id: "item.white_bundle",
			serialization_name: "minecraft:white_bundle",
		},
		{
			command_name: "minecraft:white_candle",
			name: "minecraft:white_candle",
			raw_id: -413,
			serialization_id: "item.white_candle",
			serialization_name: "minecraft:white_candle",
		},
		{
			command_name: "minecraft:white_carpet",
			name: "minecraft:white_carpet",
			raw_id: 171,
			serialization_id: "item.white_carpet",
			serialization_name: "minecraft:white_carpet",
		},
		{
			command_name: "minecraft:white_concrete",
			name: "minecraft:white_concrete",
			raw_id: 236,
			serialization_id: "item.white_concrete",
			serialization_name: "minecraft:white_concrete",
		},
		{
			command_name: "minecraft:white_concrete_powder",
			name: "minecraft:white_concrete_powder",
			raw_id: 237,
			serialization_id: "item.white_concrete_powder",
			serialization_name: "minecraft:white_concrete_powder",
		},
		{
			command_name: "minecraft:white_dye",
			name: "minecraft:white_dye",
			raw_id: 436,
			serialization_id: "item.white_dye",
			serialization_name: "minecraft:white_dye",
		},
		{
			command_name: "minecraft:white_glazed_terracotta",
			name: "minecraft:white_glazed_terracotta",
			raw_id: 220,
			serialization_id: "item.white_glazed_terracotta",
			serialization_name: "minecraft:white_glazed_terracotta",
		},
		{
			command_name: "minecraft:white_shulker_box",
			name: "minecraft:white_shulker_box",
			raw_id: 218,
			serialization_id: "item.white_shulker_box",
			serialization_name: "minecraft:white_shulker_box",
		},
		{
			command_name: "minecraft:white_stained_glass",
			name: "minecraft:white_stained_glass",
			raw_id: 241,
			serialization_id: "item.white_stained_glass",
			serialization_name: "minecraft:white_stained_glass",
		},
		{
			command_name: "minecraft:white_stained_glass_pane",
			name: "minecraft:white_stained_glass_pane",
			raw_id: 160,
			serialization_id: "item.white_stained_glass_pane",
			serialization_name: "minecraft:white_stained_glass_pane",
		},
		{
			command_name: "minecraft:white_terracotta",
			name: "minecraft:white_terracotta",
			raw_id: 159,
			serialization_id: "item.white_terracotta",
			serialization_name: "minecraft:white_terracotta",
		},
		{
			command_name: "minecraft:white_tulip",
			name: "minecraft:white_tulip",
			raw_id: -835,
			serialization_id: "item.white_tulip",
			serialization_name: "minecraft:white_tulip",
		},
		{
			command_name: "minecraft:white_wool",
			name: "minecraft:white_wool",
			raw_id: 35,
			serialization_id: "item.white_wool",
			serialization_name: "minecraft:white_wool",
		},
		{
			command_name: "minecraft:wild_armor_trim_smithing_template",
			name: "minecraft:wild_armor_trim_smithing_template",
			raw_id: 720,
			serialization_id: "item.wild_armor_trim_smithing_template",
			serialization_name: "minecraft:wild_armor_trim_smithing_template",
		},
		{
			command_name: "minecraft:wind_charge",
			name: "minecraft:wind_charge",
			raw_id: 277,
			serialization_id: "item.wind_charge.name",
			serialization_name: "minecraft:wind_charge",
		},
		{
			command_name: "minecraft:witch_spawn_egg",
			name: "minecraft:witch_spawn_egg",
			raw_id: 479,
			serialization_id: "item.witch_spawn_egg",
			serialization_name: "minecraft:witch_spawn_egg",
		},
		{
			command_name: "minecraft:wither_rose",
			name: "minecraft:wither_rose",
			raw_id: -216,
			serialization_id: "item.wither_rose",
			serialization_name: "minecraft:wither_rose",
		},
		{
			command_name: "minecraft:wither_skeleton_skull",
			name: "minecraft:wither_skeleton_skull",
			raw_id: -965,
			serialization_id: "item.wither_skeleton_skull",
			serialization_name: "minecraft:wither_skeleton_skull",
		},
		{
			command_name: "minecraft:wither_skeleton_spawn_egg",
			name: "minecraft:wither_skeleton_spawn_egg",
			raw_id: 492,
			serialization_id: "item.wither_skeleton_spawn_egg",
			serialization_name: "minecraft:wither_skeleton_spawn_egg",
		},
		{
			command_name: "minecraft:wither_spawn_egg",
			name: "minecraft:wither_spawn_egg",
			raw_id: 536,
			serialization_id: "item.wither_spawn_egg",
			serialization_name: "minecraft:wither_spawn_egg",
		},
		{
			command_name: "minecraft:wolf_armor",
			name: "minecraft:wolf_armor",
			raw_id: 740,
			serialization_id: "item.wolf_armor",
			serialization_name: "minecraft:wolf_armor",
		},
		{
			command_name: "minecraft:wolf_spawn_egg",
			name: "minecraft:wolf_spawn_egg",
			raw_id: 466,
			serialization_id: "item.wolf_spawn_egg",
			serialization_name: "minecraft:wolf_spawn_egg",
		},
		{
			command_name: "minecraft:wooden_axe",
			name: "minecraft:wooden_axe",
			raw_id: 335,
			serialization_id: "item.wooden_axe",
			serialization_name: "minecraft:wooden_axe",
		},
		{
			command_name: "minecraft:wooden_button",
			name: "minecraft:wooden_button",
			raw_id: 143,
			serialization_id: "item.wooden_button",
			serialization_name: "minecraft:wooden_button",
		},
		{
			command_name: "minecraft:wooden_door",
			name: "minecraft:wooden_door",
			raw_id: 384,
			serialization_id: "item.wooden_door",
			serialization_name: "minecraft:wooden_door",
		},
		{
			command_name: "minecraft:wooden_hoe",
			name: "minecraft:wooden_hoe",
			raw_id: 354,
			serialization_id: "item.wooden_hoe",
			serialization_name: "minecraft:wooden_hoe",
		},
		{
			command_name: "minecraft:wooden_pickaxe",
			name: "minecraft:wooden_pickaxe",
			raw_id: 334,
			serialization_id: "item.wooden_pickaxe",
			serialization_name: "minecraft:wooden_pickaxe",
		},
		{
			command_name: "minecraft:wooden_pressure_plate",
			name: "minecraft:wooden_pressure_plate",
			raw_id: 72,
			serialization_id: "item.wooden_pressure_plate",
			serialization_name: "minecraft:wooden_pressure_plate",
		},
		{
			command_name: "minecraft:wooden_shovel",
			name: "minecraft:wooden_shovel",
			raw_id: 333,
			serialization_id: "item.wooden_shovel",
			serialization_name: "minecraft:wooden_shovel",
		},
		{
			command_name: "minecraft:wooden_sword",
			name: "minecraft:wooden_sword",
			raw_id: 332,
			serialization_id: "item.wooden_sword",
			serialization_name: "minecraft:wooden_sword",
		},
		{
			command_name: "minecraft:writable_book",
			name: "minecraft:writable_book",
			raw_id: 544,
			serialization_id: "item.writable_book",
			serialization_name: "minecraft:writable_book",
		},
		{
			command_name: "minecraft:yellow_bundle",
			name: "minecraft:yellow_bundle",
			raw_id: 273,
			serialization_id: "item.yellow_bundle",
			serialization_name: "minecraft:yellow_bundle",
		},
		{
			command_name: "minecraft:yellow_candle",
			name: "minecraft:yellow_candle",
			raw_id: -417,
			serialization_id: "item.yellow_candle",
			serialization_name: "minecraft:yellow_candle",
		},
		{
			command_name: "minecraft:yellow_carpet",
			name: "minecraft:yellow_carpet",
			raw_id: -600,
			serialization_id: "item.yellow_carpet",
			serialization_name: "minecraft:yellow_carpet",
		},
		{
			command_name: "minecraft:yellow_concrete",
			name: "minecraft:yellow_concrete",
			raw_id: -631,
			serialization_id: "item.yellow_concrete",
			serialization_name: "minecraft:yellow_concrete",
		},
		{
			command_name: "minecraft:yellow_concrete_powder",
			name: "minecraft:yellow_concrete_powder",
			raw_id: -712,
			serialization_id: "item.yellow_concrete_powder",
			serialization_name: "minecraft:yellow_concrete_powder",
		},
		{
			command_name: "minecraft:yellow_dye",
			name: "minecraft:yellow_dye",
			raw_id: 432,
			serialization_id: "item.yellow_dye",
			serialization_name: "minecraft:yellow_dye",
		},
		{
			command_name: "minecraft:yellow_glazed_terracotta",
			name: "minecraft:yellow_glazed_terracotta",
			raw_id: 224,
			serialization_id: "item.yellow_glazed_terracotta",
			serialization_name: "minecraft:yellow_glazed_terracotta",
		},
		{
			command_name: "minecraft:yellow_shulker_box",
			name: "minecraft:yellow_shulker_box",
			raw_id: -616,
			serialization_id: "item.yellow_shulker_box",
			serialization_name: "minecraft:yellow_shulker_box",
		},
		{
			command_name: "minecraft:yellow_stained_glass",
			name: "minecraft:yellow_stained_glass",
			raw_id: -676,
			serialization_id: "item.yellow_stained_glass",
			serialization_name: "minecraft:yellow_stained_glass",
		},
		{
			command_name: "minecraft:yellow_stained_glass_pane",
			name: "minecraft:yellow_stained_glass_pane",
			raw_id: -646,
			serialization_id: "item.yellow_stained_glass_pane",
			serialization_name: "minecraft:yellow_stained_glass_pane",
		},
		{
			command_name: "minecraft:yellow_terracotta",
			name: "minecraft:yellow_terracotta",
			raw_id: -727,
			serialization_id: "item.yellow_terracotta",
			serialization_name: "minecraft:yellow_terracotta",
		},
		{
			command_name: "minecraft:yellow_wool",
			name: "minecraft:yellow_wool",
			raw_id: -558,
			serialization_id: "item.yellow_wool",
			serialization_name: "minecraft:yellow_wool",
		},
		{
			command_name: "minecraft:zoglin_spawn_egg",
			name: "minecraft:zoglin_spawn_egg",
			raw_id: 526,
			serialization_id: "item.zoglin_spawn_egg",
			serialization_name: "minecraft:zoglin_spawn_egg",
		},
		{
			command_name: "minecraft:zombie_head",
			name: "minecraft:zombie_head",
			raw_id: -966,
			serialization_id: "item.zombie_head",
			serialization_name: "minecraft:zombie_head",
		},
		{
			command_name: "minecraft:zombie_horse_spawn_egg",
			name: "minecraft:zombie_horse_spawn_egg",
			raw_id: 496,
			serialization_id: "item.zombie_horse_spawn_egg",
			serialization_name: "minecraft:zombie_horse_spawn_egg",
		},
		{
			command_name: "minecraft:zombie_pigman_spawn_egg",
			name: "minecraft:zombie_pigman_spawn_egg",
			raw_id: 475,
			serialization_id: "item.zombie_pigman_spawn_egg",
			serialization_name: "minecraft:zombie_pigman_spawn_egg",
		},
		{
			command_name: "minecraft:zombie_spawn_egg",
			name: "minecraft:zombie_spawn_egg",
			raw_id: 474,
			serialization_id: "item.zombie_spawn_egg",
			serialization_name: "minecraft:zombie_spawn_egg",
		},
		{
			command_name: "minecraft:zombie_villager_spawn_egg",
			name: "minecraft:zombie_villager_spawn_egg",
			raw_id: 505,
			serialization_id: "item.zombie_villager_spawn_egg",
			serialization_name: "minecraft:zombie_villager_spawn_egg",
		},
	],
	module_type: "vanilla_data",
	name: "mojang-item",
	vanilla_data_type: "item",
};

export const typeIdToID = new Map(typeIds.data_items.map((v) => [v.name.replace("minecraft:", ""), v.raw_id]));
